import { Injectable, NgZone } from '@angular/core';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { LoadingController, MenuController, ToastController, AlertController, PopoverController, Platform, ModalController } from '@ionic/angular';
import { environment } from "../../environments/environment";
import { globalConst } from "../../environments/global-const";
import { Router } from '@angular/router';
import { EditempPage } from "../components/editemp/editemp.page";
import { NewempPage } from "../components/newemp/newemp.page";
import { PublictoespPage } from "../components/publictoesp/publictoesp.page";
import { SearchciudadesPage } from "../components/searchciudades/searchciudades.page";
import { TitleCasePipe, DatePipe, CurrencyPipe } from "@angular/common";
import { DownloadreintegrosPage } from "../components/downloadreintegros/downloadreintegros.page";

import { Plugins } from '@capacitor/core';

import * as XLSX from 'xlsx';
import { MatTableDataSource } from '@angular/material/table';

const { Storage } = Plugins;


@Injectable({
  providedIn: 'root'
})
export class ApiService {

  HTTPoptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': environment.Authorization
    })
  };
  versionCorp = '1.8.55';
  reinShowOp = false; //Cambios Sebastian
  segReinReload = false; //Cambios Sebastian

  usersKam = [];

  page = "login"; //login
  login = false;
  loading;
  apiOnReq = false;


  temporizador;
  title = "";
  estados;
  estadosSelectValue = ["APROBADO", "PENDIENTE-DESEMBOLSO", "PENDIENTE-RH", "DESEMBOLSADO", "PAGADO", "VENTA"];
  estadosSelectValueP = ["APROBADO", "PENDIENTE-DESEMBOLSO", "PENDIENTE-RH", "DESEMBOLSADO", "PAGADO", "VENTA"];
  estadosSelectEspValue = ["DESEMBOLSADO"];
  estadosSelectHisEspValue = ["APROBADO", "PENDIENTE-DESEMBOLSO", "PENDIENTE-RH", "DESEMBOLSADO", "PAGADO", "VENTA"];
  columns = [];
  rows = [];
  allEncCredits = [];
  filtEncCred = [];
  detCredito: any = [];
  numsol1;
  tablaCredito = [];
  otrosCreditos = [];
  otrosCreditosAll = [];
  totalSaldoK = 0;
  totalMontoSol = 0;
  totalCuotasSol = 0;
  CapacidadCliente = 0;
  CapacidadClientePor = 0;
  CapacidadClienteDin = 0;
  CupoDis = 0;
  CupoDisPor = 0;
  rowsDet = [];
  busqueda1 = "";
  busqueda2 = "";
  busqueda3 = "";
  busqueda4 = "";
  busqueda5 = "";
  busqueda6 = "";
  busqueda7 = "";
  busqueda8 = "";
  busqueda9 = "";
  busqueda10 = "";
  busqueda11 = "";
  busqueda12 = "";
  busqueda13 = "";
  busqueda14 = "";
  busqueda15 = "";
  busqueda16 = "";
  busqueda17 = "";
  busqueda18 = "";
  busqueda19 = "";
  busqueda21 = "";
  PenRes = "p";
  PenResDis = "p";
  genhis = "g";
  repShowEn = false;
  medPagosShow = false;
  bonosShow = false;
  denariosShow = false;
  cashbackShow = false;
  cobrosShowOp = false;
  pagShowOp = false;
  disShowOp = false;
  repShowOp = false;
  esShowOp = false;
  esShowDCard = false;
  esShowApp = false;
  esShowAuto = false;
  liqShowOp = false;
  usuarioShowOp = false;
  novedadesShowOp = false;
  showTitle = true; timeShowTitle = 50;
  totMontoSol = 0;
  totSolAprobado = 0;
  totSolPendienteRh = 0;
  totSolPendientesDes = 0;
  totSolDesembolsado = 0;

  allRowsPagosR = [];
  rowsPagosR = [];
  busquedaPagosR = "";
  selectPagosR = "c"
  empresas1 = [];
  empresas2 = [];
  empresas3 = [];
  totalValor = 0;

  allRowsPagosP = [];
  rowsPagosP = [];
  selectPagosP = "e";
  busquedaPagosP = "";
  TotCuota = 0;
  Ncobros = 0;

  ReporteNov: any = [];
  ReporteNovShow: any = [];
  IdReporte;

  EncReportes = [];
  DetReporte = [];
  DetReporteFilt = [];
  showDetReporte = false;
  encReporte: any = [];
  EncReportesFilt = [];


  allEncPensiones = [];
  filtEncPen = [];

  showTable = "EncCreditos";

  fechaHoy = new Date(Date.now());
  fechaHoyF;
  fechaHoyS;
  fechaHoyS1;
  TipoInforme = "";
  FechaDesde;
  FechaHasta;
  FechaHastaReintegros;
  rowsInformeCierreDiario: any = [];
  rowsInformeCierreDiarioD: any = [];
  rowsInformeCierreDiarioM: any = [];

  usuario = "";
  clave = "";
  user: any;
  newClave = "";
  confNewClave = "";
  correo = "";

  motivoRechazo = "";
  solRechazo;
  solEdit;
  editEstadoValue;
  solReperfilado;

  allHisLiq = [];
  filtHisLiq = [];

  allEmpresas = [];
  allEmpresas3 = []
  filtEmpresas = [];
  filtEmpresas3 = [];
  hisBasesSubidas = []

  convenio: any;
  convenioNew: any = {
    Contacto: null,
    Corte15: "30",
    Corte30: "30",
    DV: null,
    Direccion: null,
    Encargado: null,
    IdEmpresa: null,
    Nombre: null,
    Periocidad: 'MENSUAL',
    Telefono: null,
    email: null,
    type: 'new'
  };
  convenioEdit: any;

  convenioNewDef: any = {
    Contacto: null,
    Corte15: "30",
    Corte30: "30",
    DV: null,
    Direccion: null,
    Encargado: null,
    IdEmpresa: null,
    Nombre: null,
    Periocidad: 'MENSUAL',
    Telefono: null,
    email: null,
    type: 'new'
  };

  mensajeNoLabora = '';
  numSolNoLabora = 0;
  cedulaNoLabora = '';
  acuerdoNoLabora = false;

  selectEmpleadosB = "c";
  busquedaEmpleado = "";
  AllEmpleados = [];
  EmpleadosFilt = [];

  pagoAntValue = {
    saldok: 0,
    intereses: 0,
    cloud: 0,
    seguro: 0,
    diasinteres: 0,
    fechapago: ''
  }

  widthPru = 0;

  dataSourcePendDes = new MatTableDataSource<any>([]);
  dataSourcePendDesFiltradas = new MatTableDataSource<any>([]);
  dataSourceHisDes = new MatTableDataSource<any>([]);

  AllPendDes: any[] = [];
  FiltPendDes: any[] = [];

  AllPendDesFiltradas: any[] = [];
  FiltPendDesFiltradas: any[] = [];

  TotPendDes = 0;
  TotPendDesFiltradas = 0;

  PendDesReady: any[] = [];
  AllHisDes: any[] = [];
  FiltHisDes: any[] = [];

  Empleado;
  EmpleadoNew = {
    Cedula: null,
    Apellido1: "",
    Apellido2: "",
    Nombre: null,
    Nombre1: null,
    Nombre2: "",
    Cargo: null,
    Salario: 0,
    Empleador: null,
    Contrato: "0",
    CodigoCargo: null,
    IdEmpresa: null,
    TipoContrato: null,
    FechaIngreso: null,
    FechaFinalCont: null,
    Descuentos: 0,
    Periodo: null,
    CuentaBancaria: null,
    TipoCuenta: null,
    Banco: null,
    BancoCodigo: null,
    Variable: null,
    IdConvenio: null,
    Celular: null,
    Direccion: null,
    email: null,
    Ciudad: null,
    FechaNacimiento: null,
    Sexo: null
  };
  EmpleadoNewDef = {
    Cedula: null,
    Apellido1: "",
    Apellido2: "",
    Nombre: null,
    Nombre1: null,
    Nombre2: "",
    Cargo: null,
    Salario: 0,
    Empleador: null,
    Contrato: "0",
    CodigoCargo: null,
    IdEmpresa: null,
    TipoContrato: null,
    FechaIngreso: null,
    FechaFinalCont: null,
    Descuentos: 0,
    Periodo: null,
    CuentaBancaria: null,
    TipoCuenta: null,
    Banco: null,
    BancoCodigo: null,
    Variable: null,
    IdConvenio: null,
    Celular: null,
    Direccion: null,
    email: null,
    Ciudad: null,
    FechaNacimiento: null,
    Sexo: null
  };

  Lineas;
  LineasXemp;

  bancos;

  allLineas = [];
  filtLineas;
  linea: any;
  lineaNew: any = {
    Politica: 'SI',
    Aplica_Seguro: 1,
    CuentaVariable: 0,
    PlazoMin: 1,
    TipoAmort: 'Cuota-Fija',
    BNPL: 0,
    SeguroD: "NO",
    DenarioYA: 0,
    DenarioCobre: 0,
    EnDenarioCobre: 0,
    Recargas: 0,
    DCardPersonal: 0,
    DCard: 0,
    ViajesDenario: 0,
    DCardCashback: 0,
    PorcentajeCashbackDCard: 0,
    PorcentajeCostoAdministrativo: 0,
    type: 'new'
  }
  lineaNewDef: any = {
    Politica: 'SI',
    Aplica_Seguro: 1,
    CuentaVariable: 0,
    PlazoMin: 1,
    TipoAmort: 'Cuota-Fija',
    BNPL: 0,
    SeguroD: "NO",
    DenarioYA: 0,
    DenarioCobre: 0,
    EnDenarioCobre: 0,
    Recargas: 0,
    type: 'new'
  }

  lineasbonos: any = [
    {
      categoria: 'Comercios',
      credito: true,
      puntos: false
    },
    {
      categoria: 'Plataformas',
      credito: true,
      puntos: false
    },
    {
      categoria: 'Dotacion',
      credito: true,
      puntos: false
    },
    {
      categoria: 'Entretenimiento',
      credito: true,
      puntos: false
    },
    {
      categoria: 'Tiendas Especializadas',
      credito: true,
      puntos: false
    },
    {
      categoria: 'Restaurantes',
      credito: true,
      puntos: false
    },
    {
      categoria: 'Salud',
      credito: true,
      puntos: false
    },
    {
      categoria: 'Mascotas',
      credito: true,
      puntos: false
    },
    {
      categoria: 'Supermercados',
      credito: true,
      puntos: false
    }
  ];


  lineaEdit: any;
  ccCreEsp;
  empToEsp;
  prodEsp;
  montoEsp;
  plazoEsp;
  obsEsp;
  cod1Esp = "";
  cod2Esp = "";
  cod3Esp = "";
  publicToEsp = [];
  publicToEspFilt = [];
  publicSelectEsp
  catPublic;
  catSelectValue = [];
  pubSelected = {
    CodUniversal: null,
    Id: 0,
    IdCategoria: null,
    Stock: null,
    Titulo: null,
    UrlFotos: null,
    Usr: null,
    ValorUnt: null
  };
  porPublic = 100;
  NumSolEsp;

  allCredEsp = [];
  filtCredEsp = [];

  convPens = [];

  allOpPse = [];
  filtOpPse = [];

  allOpGmovil = [];
  filtOpGmovil = [];

  cedulasString = "";
  cedulasExist = [];
  cedulasNotFound = [];
  cedulasNotFoundString = ""
  Liq = [];
  filtLiq = [];
  usersForLiq = [];
  count = 0;
  descarga;
  descargaShow = false;
  generarShow = false;
  uploadFileValue;
  ClientesConv = [];
  ClientesConvFilt = [];
  FechaGenLiq;
  ccForLiq;

  ciudadesFromTrebol = [];
  ciudadesFromTrebolFilt = [];
  ciudadValue;
  busquedaCiu = "";
  isNewEmp = false;

  conciliacion = [];
  conciliacionFilt = [];
  conciliacionAgru = [];
  conciliacionAgruFilt = [];
  conciliacionAgruEn = false;
  totalReportado = 0;
  totalValPagado = 0;
  numCuotasToApl = 0;
  numCuotasApl = 0;
  DifCuota = 5;
  pagosToApl = 0;
  pagosAplCount = 0;
  pagosAplPorc = 0;
  pagosAplLoad = false;
  AplEn = false;
  toAgruEn = false;
  yearHoy;

  opLineaRiesgo;

  idPedido;
  despacho: any;

  saldoTured = 0;
  saldoCobre = 0
  saldoOgloba = 0
  /* inventarioBonos; */

  constructor(
    public http: HttpClient,
    public loadingController: LoadingController,
    public menu: MenuController,
    public router: Router,
    public toastController: ToastController,
    public ngzone: NgZone,
    public alertController: AlertController,
    public popoverController: PopoverController,
    public titlecase: TitleCasePipe,
    public datePipe: DatePipe,
    public currencyPipe: CurrencyPipe,
    public plt: Platform,
    public modalController: ModalController
  ) {

    let linea = {
      Cesantias: 1,
      Prima: 1,
      Salario: 1,
      Vacaciones: 0
    }
    let lineaString = '{"Cesantias":1,"Prima":1,"Salario":1,"Vacaciones":0}';

    console.log('lineaObj: ', linea);
    console.log('lineaObj2: ', JSON.parse(lineaString));

    console.log('hola desde api service!');
    this.fechaHoyF = this.fechaHoy.getFullYear() + "-" + ("0" + (this.fechaHoy.getMonth() + 1)).slice(-2) + "-" + ("0" + this.fechaHoy.getDate()).slice(-2);
    if (this.fechaHoy.getMonth() == 0) { this.fechaHoyS = (this.fechaHoy.getFullYear() - 1) + "-12-01" } else { this.fechaHoyS = this.fechaHoy.getFullYear() + "-" + ("0" + (this.fechaHoy.getMonth())).slice(-2) + "-01"; }
    this.FechaDesde = this.fechaHoyF;
    this.FechaHasta = this.fechaHoyF;
    this.FechaHastaReintegros = this.fechaHoyF;
    this.FechaGenLiq = this.fechaHoyF;
    console.log('Fecha Hoy: ', this.fechaHoyF);
    this.yearHoy = this.fechaHoyF.split('-')[0] + '';
    this.pagoAntValue.fechapago = this.fechaHoyF;
    this.init();

  }

  async init() {
    await Storage.get({ key: 'loginNewCoorpDen' })
      .then((res) => {
        console.log('Storageget: ', res);
        let resJSON = JSON.parse(res.value);
        console.log('resJSON: ', resJSON);
        if (resJSON) {
          this.login = resJSON.login;
          this.user = resJSON.user;
          const initPath = this.checkInitPath();
          if (
            initPath != 'lineas' /* El modulo lineas ya fue refactorizado he independizado */
            && initPath != 'solicitudes' /* El modulo solicitudes ya fue refactorizado he independizado */
            && initPath != 'convenios' /* El modulo convenios ya fue refactorizado he independizado */
            && initPath != 'dipersiones-auto' /* El modulo dipersiones-auto es nuevo */
            && initPath != 'pagos' /* El modulo pagos ya fué refactorizado */
            && initPath != 'op-denarios' /* El modulo es nuevo */
            && initPath != 'bonos-operaciones' /* El modulo es nuevo */
            && initPath != 'denarios-recarga-empresarial' /* El modulo es nuevo */
            && initPath != 'formulario'
          ) {
            this.router.navigate(['/dashboard']);
            this.cargaApiIni();
          }
          /* this.getEstados();
          this.getEmpresas1();
          this.getConvPensiones();
          this.getRunCredits2(); */
        }
      })
      .catch((err) => {
        console.log('error Storageget: ', err);
      });
    if (!this.login) { this.router.navigate(['/login']); }
  }

  checkInitPath() {
    const initPathArr = window.location.href.split('/');
    const initPath = initPathArr[3];
    console.log('current url: ', initPath);
    return initPath
  }

  initCargaIni = false;
  async cargaApiIni() {
    this.initCargaIni = true;
    console.log('Carga api inicial...');

    await this.http.post(environment.urlApi + 'cargainicoorppro', {}, this.HTTPoptions).toPromise().then(async (res: any) => {
      console.log('res cargaApiIni: ', res);
      this.estados = res.estados;
      this.empresas1 = res.empresas;
      this.convPens = res.convpen;
      /* this.inventarioBonos = res.inventario; */
      // this.saldoTured = res.recarga.data.saldo_productos[0].valor;
      this.saldoTured = (typeof res.recarga?.data?.saldo_productos?.[0]?.valor === 'number' || typeof res.recarga?.data?.saldo_productos?.[0]?.valor === 'string') ? res.recarga.data.saldo_productos[0].valor : '0';
      this.saldoCobre = res.saldoCobre;
      this.saldoOgloba = res.saldoOgloba;
      this.totSolAprobado = res.dashboard1.Aprobados;
      this.totSolPendienteRh = res.dashboard1.PendientesRh;
      this.totSolPendientesDes = res.dashboard1.PendientesDes;
      this.totSolDesembolsado = res.dashboard1.Desembolsados;
      this.usersKam = (res.dashboard1.kamUsers).split(',');
    }).catch((err) => {
      this.presentAlert('Error', 'Al cargar datos iniciales', JSON.stringify(err));
    })

    this.ciudadesFromTrebol = globalConst.Ciudades;
    this.ciudadesFromTrebolFilt = globalConst.Ciudades;
    console.log('ciudadesFromTrebol: ', this.ciudadesFromTrebol);
    console.log('saldoTured: ', this.saldoTured);
    return 1;
  }

  async presentAlert(titulo, subtitulo, mensaje) {
    const alert = await this.alertController.create({
      mode: 'ios',
      header: titulo,
      subHeader: subtitulo,
      message: mensaje,
      buttons: ['OK']
    });

    await alert.present();

    const { role } = await alert.onDidDismiss();
    console.log('onDidDismiss resolved with role', role);
  }

  getEmpresaNameXid(id) {
    let name = "N/E'";
    const empresa = this.empresas1.find(empresa => empresa.IdEmpresa == id);
    if (empresa) { name = empresa.Nombre.trim(); }
    return name;
  }

  exportAsExcelFile(json: any[], nombre: string) {
    let fecha = new Date();
    let fechaForm = fecha.getFullYear() + '-' + (fecha.getMonth() + 1) + '-' + fecha.getDate() + '_' + fecha.getHours() + '-' + fecha.getMinutes();
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json, { cellDates: true, dateNF: 'yyy-MM-dd HH:mm:ss' });
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, nombre);
    XLSX.writeFile(wb, nombre + '_' + fechaForm + '.xlsx');
  }

  exportAsExcelFile2(json: any[], nombre: string) {
    let fecha = new Date();
    let fechaForm = fecha.getFullYear() + '-' + (fecha.getMonth() + 1) + '-' + fecha.getDate() + '_' + fecha.getHours() + '-' + fecha.getMinutes();
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json, { cellDates: true, dateNF: 'yyy-MM-dd HH:mm:ss' });
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Hoja1');
    XLSX.writeFile(wb, nombre + '_' + fechaForm + '.xlsx');
  }

  importExcelAsJSON(ev) {
    return new Promise((resolve, reject) => {
      console.log('Event: ', ev);
      let workBook = null;
      let jsonData = null;
      const reader = new FileReader();
      const file = ev.target.files[0];
      reader.onload = (event) => {
        const data = reader.result;
        workBook = XLSX.read(data, { type: 'binary' });
        jsonData = workBook.SheetNames.reduce((initial, name) => {
          const sheet = workBook.Sheets[name];
          initial[name] = XLSX.utils.sheet_to_json(sheet);
          return initial;
        }, {});
        console.log('DataJson: ', jsonData);
        resolve(jsonData);
      }
      reader.readAsBinaryString(file);
    })
  }

  async presentToast(mensaje, color = 'primary', time = 2000) {
    const toast = await this.toastController.create({
      message: mensaje,
      position: 'bottom',
      duration: time,
      color: color,
      mode: 'ios',
      cssClass: 'toastStyle'
    });
    toast.present();
  }


  async cambiarClave() {
    const alert = await this.alertController.create({
      cssClass: 'my-custom-class',
      header: 'Cambio de contraseña!',
      inputs: [
        {
          name: 'pass',
          type: 'password',
          placeholder: 'Ingresa Clave anterior'
        },
        {
          name: 'newpass',
          type: 'password',
          placeholder: 'Ingresa nueva clave'
        },
        {
          name: 'confnewpass',
          type: 'password',
          placeholder: 'Confirma nueva clave'
        }
      ],
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          cssClass: 'secondary',
          handler: () => {
            console.log('Confirm Cancel');
          }
        }, {
          text: 'Ok',
          handler: (alertData) => {
            console.log('Confirm Ok');
            this.cambiarClaveApi(alertData)
          }
        }
      ]
    });

    await alert.present();
  }

  /* async rechazarSol(ev: any,sol) {
    console.log(sol);
    this.solRechazo = sol;
    const popover = await this.popoverController.create({
      component: RechazarsolPage,
      cssClass: 'popoverStyle',
      event: ev,
      translucent: true,
      componentProps: {},
      mode:'ios'
    });
    return await popover.present();
  } */

  /* async editarSol(ev: any,sol) {
    console.log(sol);
    this.solEdit = sol;
    this.editEstadoValue = sol.IdEstado;
    const popover = await this.popoverController.create({
      component: EditarsolPage,
      cssClass: 'popoverStyle2',
      event: ev,
      translucent: true,
      componentProps: {},
      mode:'ios'
    });
    return await popover.present();
  } */

  /* rechazarSolicitudApi(){
    this.popoverController.dismiss();
    console.log('Rechazando solicitud...');
      this.presentLoading('Rechazando solicitud '+this.solRechazo.NumSol+'...');
      this.apiOnReq = true;
      let body={
        usuario:this.user.Usuario.trim(),
        numsol:this.solRechazo.NumSol,
        obs:this.motivoRechazo
      };
      console.log(body);
      this.http.post(environment.urlApi + 'putrechazosol',body).subscribe((res:any)=>{
        console.log(res);
        this.presentToast(res.res);
        if (this.loading) { this.loading.dismiss(); }
        this.apiOnReq = false;
        clearTimeout(this.temporizador);
        this.getRunCredits2();
        this.getEncPensionesF();
      })
  } */


  async getEncPensionesF() {
    console.log('Obteniendo operaciones de pensiones...');
    let body = {};
    this.http.post(environment.urlApi + 'getencpensiones', body).subscribe((res: any) => {
      res.tabla.forEach(credito => {
        let empresa = this.empresas1.find(empresa => empresa.IdEmpresa == credito.IdEmpresa);
        if (empresa) { credito.IdEmpresa = empresa.Nombre.trim(); }
        else { credito.IdEmpresa = 'N/E' }
        if (credito.IdEstado == 2 && credito.AprobadoRH == 0) { credito.IdEstado = '8' }
        let estado = this.estados.find(estado => estado.IdEstado == credito.IdEstado)
        credito.IdEstado = estado.Descripcion
      });
      this.allEncPensiones = res.tabla;
      this.filtEncPen = res.tabla;
      console.log('AllEncPensiones: ', this.allEncPensiones);
      this.updateFilter4(this.busqueda4);
    })
  }



  cambiarClaveApi(data) {
    console.log('Alert: ', data);
    console.log('Clave: ', data.pass);
    console.log('New Clave: ', data.newpass);
    console.log('Conf New Clave: ', data.confnewpass);
    if (data.newpass.trim() == data.confnewpass.trim()) {

      console.log('Actualizando clave...');
      this.presentLoading('Actualizando clave...');
      this.apiOnReq = true;
      let body = {
        usuario: this.user.Usuario,
        clave: data.pass,
        newclave: data.newpass
      };
      this.http.post(environment.urlApi + 'changepassnewcoorp', body).subscribe((res: any) => {
        console.log(res);
        this.presentToast(res.res + "" + res.mensaje)
        if (this.loading) { this.loading.dismiss(); }
        this.apiOnReq = false;
        clearTimeout(this.temporizador);
      })

    } else {
      alert('Por favor confirma bien la nueva contraseña')
    }

  }


  onFooterPage(ev) {
    let pagina = [];
    console.log('Footer pager: ', ev.page)
    for (let index = ev.page; index < 20; index++) {
      pagina.push(this.rows[index]);
    }
    /* this.rows = pagina;
    console.log('rows: ', pagina); */
  }

  openCustom() {
    this.menu.enable(true, 'custom');
    this.menu.open('custom');
  }

  openLoginMenu() {
    this.menu.enable(true, 'end');
    this.menu.open('end');
  }

  irSolicitudes() {
    /* if (this.allEncCredits.length == 0) { this.getRunCredits2(); } */
    this.menu.close('custom')
    this.router.navigate(['/solicitudes']);
  }

  irCashback() {
    this.menu.close('custom')
    this.router.navigate(['/cashback']);
  }

  irCashbackDCard() {
    this.menu.close('custom')
    this.router.navigate(['/cashback-dcard']);
  }

  irOpFedac() {
    /* if (this.allEncCredits.length == 0) { this.getRunCredits2(); } */
    this.menu.close('custom')
    this.router.navigate(['/op-fedac'])
  }

  irCredNoLabora() {
    this.menu.close('custom')
    this.router.navigate(['/cred-no-labora']);
  }

  irPagos(res) {
    this.PenRes = res
    console.log('ir pagos: ', this.PenRes);
    if (this.PenRes == 'd') {
      this.title = "Pagos por documento";
    }
    this.showTitle = false; setTimeout(() => { this.showTitle = true; }, this.timeShowTitle); //animación
    this.menu.close('custom')
    this.router.navigate(['/pagos']);
  }

  irHisPagosAuto() {
    this.menu.close('custom')
    this.router.navigate(['/pagos-his']);
  }

  irHisPagosCobre() {
    this.menu.close('custom')
    this.router.navigate(['/his-pagos-cobre']);
  }

  reinShow() {
    if (this.reinShowOp) { this.reinShowOp = false; } else { this.reinShowOp = true; }
  }

  medPagShow() {
    this.medPagosShow = !this.medPagosShow;
  }

  bonosFunShow() {
    this.bonosShow = !this.bonosShow;
  }

  denariosFunShow() {
    this.denariosShow = !this.denariosShow;
  }

  cashbackFunShow() {
    this.cashbackShow = !this.cashbackShow;
  }

  cobrosShow() {
    if (this.cobrosShowOp) { this.cobrosShowOp = false; } else { this.cobrosShowOp = true; }
  }

  pagShow() {
    if (this.pagShowOp) { this.pagShowOp = false; } else { this.pagShowOp = true; }
  }

  disShow() {
    if (this.disShowOp) { this.disShowOp = false; } else { this.disShowOp = true; }
  }

  repShow() {
    if (this.repShowOp) { this.repShowOp = false; } else { this.repShowOp = true; }
  }

  esShow() {
    if (this.esShowOp) { this.esShowOp = false; } else { this.esShowOp = true; }
  }

  dCardShow() {
    if (this.esShowDCard) { this.esShowDCard = false; } else { this.esShowDCard = true; }
  }

  appShow() {
    this.esShowApp = !this.esShowApp;
  }

  autoShow() {
    this.esShowAuto = !this.esShowAuto;
  }

  liqShow() {
    if (this.liqShowOp) { this.liqShowOp = false; } else { this.liqShowOp = true; }
  }

  novedadesShow() {
    if (this.novedadesShowOp) { this.novedadesShowOp = false; } else { this.novedadesShowOp = true; }
  }

  usuarioShow() {
    this.usuarioShowOp = !this.usuarioShowOp
  }

  irDispersiones(res) {
    this.PenResDis = res
    if (this.PenResDis == 'p') {
      this.title = "Dispersiones pendientes";
      if (this.AllPendDes.length == 0) { this.getPendDes(); }
    } else {
      this.title = "Dispersiones realizadas";
      if (this.AllHisDes.length == 0) { this.getHisDes(); }
    }
    this.showTitle = false; setTimeout(() => { this.showTitle = true; }, this.timeShowTitle); //animación
    console.log('ir dispersiones: ', this.PenResDis);
    this.menu.close('custom')
    this.router.navigate(['/dispersiones']);
  }

  irDashboard() {
    this.menu.close('custom')
    this.router.navigate(['/dashboard']);
  }

  irCreEspeciales() {
    this.menu.close('custom')
    this.router.navigate(['/credespeciales']);
  }

  irDCardLineasComercios() {
    this.menu.close('custom')
    this.router.navigate(['/d-card-lineas-comercios']);
  }

  irDCardFacturacion() {
    this.menu.close('custom')
    this.router.navigate(['/d-card-facturacion']);
  }

  irDCardCreditos() {
    this.menu.close('custom')
    this.router.navigate(['/d-card-creditos']);
  }

  irDCardTransacciones() {
    this.menu.close('custom')
    this.router.navigate(['/d-card-transacciones']);
  }

  irDcardUsuarios() {
    this.menu.close('custom')
    this.router.navigate(['/d-card-usuarios']);
  }

  irDcardMarketing() {
    this.menu.close('custom')
    this.router.navigate(['/d-card-marketing']);
  }

  irBannersApp() {
    this.menu.close('custom')
    this.router.navigate(['/banners-app']);
  }

  irBannersAuto() {
    this.menu.close('custom')
    this.router.navigate(['/banners-autogestion']);
  }


  irCreEspecialesHis() {
    if (this.allCredEsp.length == 0) { this.getAllCredEsp(); }
    this.menu.close('custom')
    this.router.navigate(['/creditosespecialeshis']);
  }

  irOpPensiones() {
    if (this.allEncPensiones.length == 0) { this.getEncPensiones(); }
    this.menu.close('custom')
    this.router.navigate(['/oppensiones']);
  }

  irOpPSE() {
    if (this.allOpPse.length == 0) { this.getOpPse(); }
    this.menu.close('custom')
    this.router.navigate(['/operacionespse']);
  }

  irOpGmovil() {
    if (this.allOpGmovil.length == 0) { this.getOpGmovil(); this.getEstadosGmovil(); }
    this.menu.close('custom')
    this.router.navigate(['/operaciones-gmovil']);
  }

  irOpTpaga() {
    this.menu.close('custom');
    this.router.navigate(['/op-tpaga']);
  }

  irOpDenarioYa() {
    this.menu.close('custom');
    this.router.navigate(['/denario-ya']);
  }

  irReportes(res) {
    this.genhis = res
    if (this.genhis == 'g') {
      this.title = "generar reporte de novedades"
    } else {
      if (this.EncReportes.length == 0) { this.getEncReporte(); }
      this.title = "historial reporte de novedades"
    }
    this.showTitle = false; setTimeout(() => { this.showTitle = true; }, this.timeShowTitle); //animación
    console.log('ir reportes: ', this.genhis);
    this.menu.close('custom')
    this.router.navigate(['/reportes']);
  }

  irInformes() {
    this.menu.close('custom')
    this.router.navigate(['/informes']);
  }

  irEmpleados() {
    this.menu.close('custom')
    this.router.navigate(['/empleados']);
  }

  irConvenios() {
    this.menu.close('custom')
    this.router.navigate(['/convenios']);
  }

  irLineas() {
    this.menu.close('custom')
    this.router.navigate(['/lineas']);
  }

  irNovedades() {
    this.menu.close('custom')
    this.router.navigate(['/novedades-convenios']);
  }

  verUsuarios() {
    this.menu.close('custom')
    this.router.navigate(['/usuarios']);
  }

  crearUsuarios() {
    this.menu.close('custom')
    this.router.navigate(['/registrar-usuarios']);
  }

  irHisLiq() {
    // if (this.allHisLiq.length == 0) { this.getLiqHis(); }
    this.menu.close('custom')
    this.router.navigate(['/hisliquidacion']);
  }

  irCreaLiq() {
    this.menu.close('custom')
    this.router.navigate(['/crealiquidacion']);
  }

  async irConciliacion(reporte) {
    this.router.navigate(['/cconciliacion']);
    await this.presentLoading('Obteniendo detalles del reporte..');
    console.log('Obteniendo detalles del reporte..:');
    this.encReporte = reporte;
    this.apiOnReq = true;
    let body = {
      idreporte: reporte.IdReporte
    };
    this.http.post(environment.urlApi + 'getdetreporte', body).subscribe((res: any) => {
      res.tabla = res.tabla.sort((a, b) => b.NumSol - a.NumSol);
      this.DetReporte = res.tabla;
      this.DetReporteFilt = res.tabla;
      console.log('DetReporte: ', this.DetReporte);
      if (this.loading) { this.loading.dismiss(); }
      this.apiOnReq = false;
      clearTimeout(this.temporizador);

      this.conciliacion = this.DetReporte;
      this.conciliacionFilt = this.DetReporte;

      let body2 = {
        idreporte: reporte.IdReporte
      }
      this.http.post(environment.urlApi + 'getconciliacion', body2).subscribe(async (res: any) => {
        console.log('conciliación: ', res);
        this.DetReporte.forEach(d => {
          d = Object.assign(d, res.find(r => r.NumSol == d.NumSol && r.Cuota == d.Cuota && r.Cedula == d.Cedula));
        });
        console.log('DetReporte conciliado: ', this.DetReporte);
        await this.getConciliacionLiq();
        await this.getConciliacionCuot();
        await this.getConciliacionDev();
        this.getTotalValPagado2();

      })
    })
    if (this.totalValPagado > 0) { this.diligenciaConciliacion(); }
  }

  getConciliacionLiq() {
    return new Promise((resolve, reject) => {
      this.apiOnReq = true;
      let body = {
        idpago: this.encReporte.IdReporte
      };
      this.http.post(environment.urlApi + '/coorp/getConciliacionesLiq', body, this.HTTPoptions).subscribe((res: any) => {
        console.log('ConciliacionLiq: ', res);
        res.forEach(c => {
          c.nombre = c.Nombre;
          c.documento = c.Documento;
          c.saldok = c.SaldoK;
          c.intereses = c.Intereses;
          c.cloud = c.Cloud;
          c.seguro = c.Seguro;
          c.fecha = c.Fecha;
          c.usuario = c.Usuario;
          c.diasinteres = c.DiasInt;
          c.total = c.Total;
        });
        this.liquidacionesPxD = res;
        this.liquidacionesPxDFilt = res;
        resolve('ok');
      });
    })
  }
  getConciliacionCuot() {
    return new Promise((resolve, reject) => {
      this.apiOnReq = true;
      let body = {
        idpago: this.encReporte.IdReporte
      };
      this.http.post(environment.urlApi + '/coorp/getConciliacionesCuot', body, this.HTTPoptions).subscribe((res: any) => {
        console.log('ConciliacionCuot: ', res);
        res.forEach(c => {
          c.nombre = c.Nombre;
          c.documento = c.Documento;
        });
        this.cuotasPxD = res;
        this.cuotasPxDFilt = res;
        resolve('ok');
      });
    })
  }
  getConciliacionDev() {
    return new Promise((resolve, reject) => {
      this.apiOnReq = true;
      let body = {
        idpago: this.encReporte.IdReporte
      };
      this.http.post(environment.urlApi + '/coorp/getConciliacionesDev', body, this.HTTPoptions).subscribe((res: any) => {
        console.log('ConciliacionDev: ', res);
        res.forEach(c => {
          c.nombre = c.Nombre;
          c.documento = c.Documento;
        });
        this.devolucionesPxD = res;
        this.devolucionesPxDFilt = res;
        resolve('ok');
      });
    })
  }

  async presentLoading(mensaje) {
    this.loading = await this.loadingController.create({
      cssClass: 'loading',
      mode: 'ios',
      message: mensaje
    });
    await this.loading.present();
    this.temporizador = setTimeout(() => {
      if (this.apiOnReq) {
        if (this.loading) { this.loading.dismiss(); }
        this.apiOnReq = false;
        console.log('Mucho tiempo esperando respuesta del api');
      }
    }, 300000);
  }
  async presentLoadingContados(mensaje: string, cantidad: number) {
    let contador = 0;

    this.loading = await this.loadingController.create({
      cssClass: 'loading',
      mode: 'ios',
      message: `${mensaje} (${contador}/${cantidad})`
    });

    await this.loading.present();

    const intervalo = setInterval(() => {
      if (contador < cantidad) {
        contador++;
        this.loading.message = `${mensaje} (${contador}/${cantidad})`;
      } else {
        this.loading.dismiss();
        clearInterval(intervalo);
      }
    }, 60);


    this.temporizador = setTimeout(() => {
      if (this.apiOnReq) {
        if (this.loading) {
          this.loading.dismiss();
        }
        clearInterval(intervalo);
        this.apiOnReq = false;
        console.log('Mucho tiempo esperando respuesta del API');
      }
    }, 300000);
  }

  /* getRunCredits(){
    console.log('Obteniendo todas las solicitudes en proceso...');
    this.presentLoading('Obteniendo todas las solicitudes en proceso...');
    this.apiOnReq = true;
    let body={};
    this.http.post(environment.urlApi + 'getruncredits',body).subscribe((res:any)=>{
      this.allEncCredits = res.creditos;
      this.filtEncCred = res.creditos;
      if (this.loading) { this.loading.dismiss(); }
      this.apiOnReq = false;
      clearTimeout(this.temporizador);
      this.updateFilter(this.busqueda1.trim());
    })
  } */

  filtPensionados(arreglo) {
    let filt = [];
    arreglo.forEach(e => {
      if (this.convPens.findIndex(c => c.Id == e.IdEmpresa) < 0) {
        filt.push(e);
      }
    });
    return filt;
  }


  /* async getRunCredits2_Antes(){
    console.log('estadosSelectValue: ',this.estadosSelectValue);
    let idEstadosArray = [];
    this.estadosSelectValue.forEach(element => {
      idEstadosArray.push(this.estados.find(find => find.Descripcion === element).IdEstado);
    });
    let idEstadosString = JSON.stringify(idEstadosArray).replace('[','(');
    idEstadosString = idEstadosString.replace(']',')');
    console.log('idEstadosString: ', idEstadosString);

    console.log('Obteniendo todas las solicitudes en proceso...');
    await this.presentLoading('Obteniendo todas las solicitudes en proceso...');
    this.apiOnReq = true;
    this.http.get(environment.urlApi + 'getruncredits2', {}).subscribe((res: any) => {
      if (this.loading) { this.loading.dismiss() };
      this.apiOnReq = false;
      clearTimeout(this.temporizador);
      res.creditos = this.filtPensionados(res.creditos);
      res.creditos.forEach(credito => {
        let empresa = this.empresas1.find(empresa => empresa.IdEmpresa==credito.IdEmpresa);
        credito.IdEmpresa = empresa.Nombre.trim();
        if(credito.IdEstado==2 && credito.AprobadoRH==0){credito.IdEstado='8'}
        let estado = this.estados.find(estado => estado.IdEstado==credito.IdEstado) 
        credito.IdEstado = estado.Descripcion
      });
      this.allEncCredits = res.creditos;
      this.filtEncCred = res.creditos;
      this.updateFilter(this.busqueda1.trim());
    }, (err: any) => {
      if (this.loading) { this.loading.dismiss() };
      this.apiOnReq = false;
      clearTimeout(this.temporizador);
      this.presentAlert('Error', 'Al cargar solicitudes en proceso', JSON.stringify(err));
    })
  } */

  /* allOpTimeStamp:any;
  async getRunCredits2(){
    console.log('Obteniendo todas las solicitudes en proceso...');
    this.req('get','getruncredits2',{},'Obteniendo todas las solicitudes en proceso...')
      .then((res:any) => {
        res.creditos = this.filtPensionados(res.creditos);
        res.creditos.forEach(credito => {
          let empresa = this.empresas1.find(empresa => empresa.IdEmpresa==credito.IdEmpresa);
          credito.IdEmpresa = empresa.Nombre.trim();
          if(credito.IdEstado==2 && credito.AprobadoRH==0){credito.IdEstado='8'}
          let estado = this.estados.find(estado => estado.IdEstado==credito.IdEstado) 
          credito.IdEstado = estado.Descripcion
        });
        this.allEncCredits = res.creditos;
        this.filtEncCred = res.creditos;
        this.allOpTimeStamp = res.timeStamp - (3600*1000*5);
        this.updateFilter(this.busqueda1.trim());
      })
      .catch((err) => {
        this.presentAlert('Error', 'Al cargar solicitudes en proceso', JSON.stringify(err));
      })
  } */

  formatDate(date) {
    if (date) {
      const myDate = new Date(date + (5 * 3600 * 1000)); /* hora actual más 5 horas */
      return myDate.getFullYear() + '-' + ('0' + (myDate.getMonth() + 1)).slice(-2) + '-' + ('0' + myDate.getDate()).slice(-2) + ' ' + myDate.getHours() + ':' + ('0' + (myDate.getMinutes())).slice(-2) + ':' + myDate.getSeconds();
    } else {
      return '2000-01-01'
    }
  }

  getEstados() {
    console.log('Obteniendo estados...');
    /* this.presentLoading('Obteniendo todas las solicitudes en proceso...');
    this.apiOnReq = true; */
    let body = {};
    this.http.post(environment.urlApi + 'getestados', body).subscribe((res: any) => {
      this.estados = res;
      console.log('Estados: ', this.estados);
      /* this.loading.dismiss();
      this.apiOnReq = false;
      clearTimeout(this.temporizador); */
    })
  }

  getConvPensiones() {
    console.log('Obteniendo estados...');
    /* this.presentLoading('Obteniendo todas las solicitudes en proceso...');
    this.apiOnReq = true; */
    let body = {};
    this.http.post(environment.urlApi + 'getconvpensiones', body).subscribe((res: any) => {
      this.estados = res;
      console.log('Estados: ', this.estados);
      /* this.loading.dismiss();
      this.apiOnReq = false;
      clearTimeout(this.temporizador); */
    })
  }

  /* updateFilter(event) {
    const val = event.toLowerCase().trim();
    this.filtEncCred = this.allEncCredits.filter((d) => {
      return (
           d.Cedula.toLowerCase().indexOf(val) !== -1
        || d.NombreCompleto.toLowerCase().indexOf(val) !== -1
        || d.NumSol.toString().indexOf(val) !== -1
        || d.IdEmpresa.toLowerCase().indexOf(val) !== -1
        || d.IdEstado.toLowerCase().indexOf(val) !== -1
        || d.TipoCredito.toLowerCase().indexOf(val) !== -1
        || !val);
    });
    this.filtEncCreditEstados(this.filtEncCred);
  } */

  updateFilter2(event) {
    const val = event.toLowerCase().trim();
    // filter our data
    this.filtEncCred = this.allRowsPagosR.filter((d) => {
      return (d.Cedula.toLowerCase().indexOf(val) !== -1 || d.Nombre.toLowerCase().indexOf(val) !== -1 || d.NumSol.toString().indexOf(val) !== -1 || d.Empresa.toLowerCase().indexOf(val) !== -1 || d.IdPago.toLowerCase().indexOf(val) !== -1 || !val);
    });
    this.rowsPagosR = this.filtEncCred;
    this.getTotValor();
  }

  updateFilter3(event) {
    const val = event.toLowerCase().trim();
    // filter our data
    this.filtEncCred = this.allRowsPagosP.filter((d) => {
      return (d.Cedula.toLowerCase().indexOf(val) !== -1 || d.NombreCompleto.toLowerCase().indexOf(val) !== -1 || d.NumSol.toString().indexOf(val) !== -1 || d.IdEmpresa.toString().indexOf(val) !== -1 || !val);
    });
    this.rowsPagosP = this.filtEncCred;
    this.getTotalCuota();
  }

  updateFilter4(event) {
    const val = event.toLowerCase().trim();
    // filter our data
    this.filtEncPen = this.allEncPensiones.filter((d) => {
      return (
        d.Cedula.toLowerCase().indexOf(val) !== -1
        || d.NombreCompleto.toLowerCase().indexOf(val) !== -1
        || d.NumSol.toString().indexOf(val) !== -1
        || d.IdEmpresa.toLowerCase().indexOf(val) !== -1
        || d.IdEstado.toLowerCase().indexOf(val) !== -1
        || d.TipoCredito.toLowerCase().indexOf(val) !== -1
        || !val);
    });
    this.filtEncCreditEstadosP(this.filtEncPen);
  }


  filtEncCreditEstadosP(filtEncCredits) {
    let tempFilt = [];
    this.estadosSelectValueP.forEach(estado => {
      const found = filtEncCredits.filter(est => est.IdEstado.toLowerCase() == estado.toLowerCase());
      tempFilt = tempFilt.concat(found);
    });
    tempFilt.sort((a, b) => b.NumSol - a.NumSol);
    this.filtEncPen = tempFilt;
    this.totMontoSol = 0;
    this.totSolAprobado = 0;
    this.totSolPendienteRh = 0;
    this.totSolPendientesDes = 0;
    this.totSolDesembolsado = 0;
    this.filtEncPen.forEach(row => {
      this.totMontoSol = this.totMontoSol + row.MontoSol
      if (row.IdEstado == "APROBADO") { this.totSolAprobado = this.totSolAprobado + 1; }
      if (row.IdEstado == "PENDIENTE-RH") { this.totSolPendienteRh = this.totSolPendienteRh + 1; }
      if (row.IdEstado == "PENDIENTE-DESEMBOLSO") { this.totSolPendientesDes = this.totSolPendientesDes + 1; }
      if (row.IdEstado == "DESEMBOLSADO") { this.totSolDesembolsado = this.totSolDesembolsado + 1; }
    });
    console.log('filtEncPen: ', this.filtEncPen);
    console.log('totMontoSol: ', this.totMontoSol);
    console.log('totSolAprobado: ', this.totSolAprobado);
    console.log('totSolPendienteRh: ', this.totSolPendienteRh);
    console.log('totSolPendientesDes: ', this.totSolPendientesDes);
    console.log('totSolDesembolsado: ', this.totSolDesembolsado);
    /* let maxlength = this.rows.sort((a, b) => { return b.NombreCompleto.trim().length - a.NombreCompleto.trim().length })[0];
    console.log('maxlengthArray: ', maxlength);
    console.log('maxlength: ', maxlength.NombreCompleto.trim().length);
    this.widthPru = maxlength.NombreCompleto.trim().length * 7; */
  }



  updateFilter5(event) {
    const val = event.toLowerCase().trim();
    // filter our data
    this.filtHisLiq = this.allHisLiq.filter((d) => {
      if (!d.Usuario) { d.Usuario = ""; }
      return (
        d.Cedula.toLowerCase().indexOf(val) !== -1
        || d.Nombre.toLowerCase().indexOf(val) !== -1
        || d.AplString.toLowerCase().indexOf(val) !== -1
        || d.NumSol.toString().indexOf(val) !== -1
        || d.IdEmpresa.toString().indexOf(val) !== -1
        || d.Empresa.toString().toLowerCase().indexOf(val) !== -1
        || d.Usuario.toString().toLowerCase().trim().indexOf(val) !== -1
        || !val);
    });
    this.filtHisLiq = this.filtHisLiq.sort((a, b) => new Date(b.FechaGen).getTime() - new Date(a.FechaGen).getTime());
    console.log('filtHisLiq: ', this.filtHisLiq);
  }

  /* updateFilter6(event) {
    const val = event.toLowerCase().trim();
    this.filtEmpresas = this.allEmpresas.filter((d) => {
      if(d.email==null){d.email="";}
      if(d.Encargado==null){d.Encargado="";}
      return (
             d.Nombre.toLowerCase().indexOf(val) !== -1 
          || d.IdEmpresa.toString().indexOf(val) !== -1  
          || d.email.toString().indexOf(val) !== -1 
          || d.Encargado.toString().indexOf(val) !== -1 
          || !val);
    });
    console.log('filtEmpresas: ',this.filtEmpresas);
  } */

  updateFilter7(event) {
    const val = event.toLowerCase().trim();
    // filter our data
    this.EmpleadosFilt = this.AllEmpleados.filter((d) => {
      if (!d.NombreCompleto) { d.NombreCompleto = "" }; if (!d.IdEmpresa) { d.IdEmpresa = "" }; if (!d.Empleador) { d.Empleador = "" }; if (!d.IdConvenio) { d.IdConvenio = "" }; if (!d.email) { d.email = "" }; if (!d.emailReg) { d.emailReg = "" }; if (!d.Celular) { d.Celular = "" }; if (!d.CelularReg) { d.CelularReg = "" };
      return (d.NombreCompleto.toLowerCase().indexOf(val) !== -1 || d.Cedula.indexOf(val) !== -1 || d.Empleador.toLowerCase().indexOf(val) !== -1 || d.IdEmpresa.toString().indexOf(val) !== -1 || d.IdConvenio.toLowerCase().indexOf(val) !== -1 || d.email.toLowerCase().indexOf(val) !== -1 || d.emailReg.toLowerCase().indexOf(val) !== -1 || d.Celular.indexOf(val) !== -1 || d.CelularReg.indexOf(val) !== -1 || !val);
    });
    console.log('EmpleadosFilt: ', this.filtEmpresas);
  }

  updateFilter8(event) {
    const val = event.toLowerCase().trim();
    // filter our data
    this.EncReportesFilt = this.EncReportes.filter((d) => {
      return (d.IdReporte.toString().indexOf(val) !== -1 || d.IdEmpresa.toString().indexOf(val) !== -1 || d.Empresa.toLowerCase().indexOf(val) !== -1 || !val);
    });
    this.EncReportesFilt.sort((b, a) => a.IdReporte - b.IdReporte);
    console.log('EncReportesFilt: ', this.EncReportesFilt);
  }

  updateFilter9(event) {
    const val = event.toLowerCase().trim();
    // filter our data
    this.DetReporteFilt = this.DetReporte.filter((d) => {
      return (d.Cedula.toLowerCase().indexOf(val) !== -1 || d.NombreCompleto.toLowerCase().indexOf(val) !== -1 || d.NumSol.toString().indexOf(val) !== -1 || !val);
    });
  }

  tipoPendDes = ['D', 'P'];

  updateFilter10() {
    console.log('busqueda10: ', this.busqueda10);
    console.log('tipoPendDes: ', this.tipoPendDes);
    const val = this.sinTildes(this.busqueda10);
    // filter our data
    let filt1 = this.AllPendDes.filter((d) => {
      if (!d.Usr) { d.Usr = ""; }
      return (
        d.Cedula.toLowerCase().indexOf(val) !== -1
        || d.NombreCompleto.toLowerCase().indexOf(val) !== -1
        || d.IdEmpresa.toLowerCase().indexOf(val) !== -1
        || d.NumSol.toString().indexOf(val) !== -1
        || d.Usr.toLowerCase().indexOf(val) !== -1
        || !val);
    });

    let filt2 = [];
    filt1.forEach(f => {
      if (this.tipoPendDes.find(b => b == f.Type)) {
        filt2.push(f);
      }
    });

    this.FiltPendDes = filt2;
    this.TotPendDes = 0;
    this.FiltPendDes.forEach(credito => {
      this.TotPendDes = this.TotPendDes + credito.MontoSol;
    });

    this.dataSourcePendDes.data = this.FiltPendDes;
  }

  busqueda10Filtradas = '';
  tipoPendDesFiltradas: string[] = ['D', 'P'];
  updateFilter10Filtradas() {
    const texto = (this.busqueda10Filtradas || '').toString().trim().toLowerCase();
    const tipos = this.tipoPendDesFiltradas || [];

    this.FiltPendDesFiltradas = this.AllPendDesFiltradas.filter((credito: any) => {
      const coincideTexto =
        !texto ||
        String(credito.NumSol ?? '').toLowerCase().includes(texto) ||
        String(credito.Cedula ?? '').toLowerCase().includes(texto) ||
        String(credito.NombreCompleto ?? '').toLowerCase().includes(texto) ||
        String(credito.IdEmpresa ?? '').toLowerCase().includes(texto) ||
        String(credito.Usr ?? '').toLowerCase().includes(texto) ||
        String(credito.Tipo ?? '').toLowerCase().includes(texto);

      const coincideTipo = tipos.length === 0 || tipos.includes(credito.Type);

      return coincideTexto && coincideTipo;
    });

    this.dataSourcePendDesFiltradas.data = [...this.FiltPendDesFiltradas];
    this.TotPendDesFiltradas = this.FiltPendDesFiltradas.reduce((total: number, item: any) => total + Number(item.MontoSol || 0), 0);
  }

  updateFilter11(event: any) {
    const val = String(event ?? '').toLowerCase().trim();

    if (!val) {
      this.FiltHisDes = this.AllHisDes;
      this.dataSourceHisDes.data = this.AllHisDes;

      return;
    }

    this.FiltHisDes = this.AllHisDes.filter((d: any) => {
      return (
        String(d.Cedula ?? '').toLowerCase().indexOf(val) !== -1 ||
        String(d.NombreCompleto ?? '').toLowerCase().indexOf(val) !== -1 ||
        String(d.NumSol ?? '').indexOf(val) !== -1 ||
        !val
      );
    });

    this.dataSourceHisDes.data = [...this.FiltHisDes];
  }

  /* updateFilter12(event) {
    const val = event.toLowerCase().trim();
    this.filtLineas = this.allLineas.filter((d) => {
      return (d.IdConvenio.toLowerCase().indexOf(val) !== -1 || d.Empresa.toLowerCase().indexOf(val) !== -1 || d.IdEmpresa.toString().indexOf(val) !== -1 ||  !val);
    });
  } */

  totValPagado = 0;
  updateFilter17(event: any) {
    const val = event.toLowerCase().trim();
    // filter our data
    this.conciliacionFilt = this.conciliacion.filter((d) => {
      if (d.Obs == null) { d.Obs = ""; }
      if (d.UsrCre == null) { d.UsrCre = ""; }
      if (d.UsuarioPago == null) { d.UsuarioPago = ""; }
      return (
        d.Cedula.toLowerCase().indexOf(val) !== -1
        || d.NombreCompleto.toLowerCase().indexOf(val) !== -1
        || d.NumSol.toString().indexOf(val) !== -1
        || d.Estado.toLowerCase().indexOf(val) !== -1
        || d.Obs.toLowerCase().indexOf(val) !== -1
        || d.UsrCre.toLowerCase().indexOf(val) !== -1
        || d.UsuarioPago.toLowerCase().indexOf(val) !== -1
        || !val);
    });
    console.log(this.conciliacionFilt);

    this.liquidacionesPxDFilt = this.liquidacionesPxD.filter((d) => {
      if (d.Obs == null) { d.Obs = ""; }
      return (
        d.documento.toLowerCase().indexOf(val) !== -1
        || d.nombre.toLowerCase().indexOf(val) !== -1
        || d.NumSol.toString().indexOf(val) !== -1
        || !val);
    });
    console.log(this.liquidacionesPxDFilt);

    this.cuotasPxDFilt = this.cuotasPxD.filter((d) => {
      if (d.Obs == null) { d.Obs = ""; }
      return (
        d.documento.toLowerCase().indexOf(val) !== -1
        || d.nombre.toLowerCase().indexOf(val) !== -1
        || d.NumSol.toString().indexOf(val) !== -1
        || !val);
    });
    console.log(this.cuotasPxDFilt);

    this.devolucionesPxDFilt = this.devolucionesPxD.filter((d) => {
      if (d.Obs == null) { d.Obs = ""; }
      return (
        d.Documento.toLowerCase().indexOf(val) !== -1
        || d.nombre.toLowerCase().indexOf(val) !== -1
        || !val);
    });
    console.log(this.devolucionesPxDFilt);

    this.totValPagado = 0;
    this.liquidacionesPxDFilt.forEach(l => { this.totValPagado = this.totValPagado + l.total; });
    this.cuotasPxDFilt.forEach(c => { this.totValPagado = this.totValPagado + c.Pago; });
    this.devolucionesPxDFilt.forEach(d => { this.totValPagado = this.totValPagado + d.Devolucion; });
    console.log('totValPagado: ', this.totValPagado);
  }

  updateFilter18(event) {
    const val = event.toLowerCase().trim();
    // filter our data
    this.conciliacionAgruFilt = this.conciliacionAgru.filter((d) => {
      if (d.Obs == null) { d.Obs = ""; }
      if (d.UsrCre == null) { d.UsrCre = ""; }
      if (d.UsuarioPago == null) { d.UsuarioPago = ""; }
      return (
        d.Cedula.toLowerCase().indexOf(val) !== -1
        || d.NombreCompleto.toLowerCase().indexOf(val) !== -1
        || d.Estado.toLowerCase().indexOf(val) !== -1
        || d.Obs.toLowerCase().indexOf(val) !== -1
        || d.UsrCre.toLowerCase().indexOf(val) !== -1
        || d.UsuarioPago.toLowerCase().indexOf(val) !== -1
        || !val);
    });
    console.log(this.conciliacionAgruFilt);
  }

  /* filtEncCreditEstados(filtEncCredits){
    let tempFilt=[];
    this.estadosSelectValue.forEach(estado => {
      const found = filtEncCredits.filter(est => est.IdEstado.toLowerCase() == estado.toLowerCase());
      tempFilt = tempFilt.concat(found);
    });
    tempFilt.sort((a,b)=> b.NumSol - a.NumSol);
    this.rows = tempFilt;
    this.totMontoSol = 0;
    this.totSolAprobado = 0;
    this.totSolPendienteRh = 0;
    this.totSolPendientesDes = 0;
    this.totSolDesembolsado = 0;
    this.rows.forEach(row => {
      this.totMontoSol = this.totMontoSol + row.MontoSol
      if (row.IdEstado == "APROBADO") { this.totSolAprobado = this.totSolAprobado + 1; }
      if (row.IdEstado == "PENDIENTE-RH") { this.totSolPendienteRh = this.totSolPendienteRh + 1; }
      if (row.IdEstado == "PENDIENTE-DESEMBOLSO") { this.totSolPendientesDes = this.totSolPendientesDes + 1; }
      if (row.IdEstado == "DESEMBOLSADO") { this.totSolDesembolsado = this.totSolDesembolsado + 1; }
    });
    console.log('rows: ',this.rows);
    console.log('totMontoSol: ',this.totMontoSol);
    console.log('totSolAprobado: ',this.totSolAprobado);
    console.log('totSolPendienteRh: ',this.totSolPendienteRh);
    console.log('totSolPendientesDes: ',this.totSolPendientesDes);
    console.log('totSolDesembolsado: ', this.totSolDesembolsado);
  } */

  /* estadosSelect(event) {
    this.estadosSelectValue = event.detail.value;
    console.log('Estados select: ', this.estadosSelectValue);
    this.filtEncCreditEstados(this.filtEncCred);
  } */

  estadosSelectP(event) {
    this.estadosSelectValueP = event.detail.value;
    console.log('Estados select: ', this.estadosSelectValueP);
    this.updateFilter4(this.busqueda4);
  }

  getOtrosCreditos(cedula) {
    console.log('Obteniendo todos los creditos...', cedula);
    /* await this.presentLoading('Obteniendo todos los creditos...');
    this.apiOnReq = true; */
    let HTTPoptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    let body = {
      cedula: cedula.trim()
    };
    this.http.post(environment.urlApi + 'getotroscreditos', body, HTTPoptions).subscribe((res: any) => {
      this.otrosCreditos = res.tabla;
      console.log('otros creditos: ', this.otrosCreditos);
      this.loading.dismiss();
      this.apiOnReq = false;
      clearTimeout(this.temporizador);
    })
  }

  getTableCredit(solicitud) {
    console.log('Obteniendo Tabla de amortización...');
    /* await this.presentLoading('Obteniendo Tabla de amortización...');
    this.apiOnReq = true; */
    let HTTPoptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    let body = {
      sol: solicitud
    };
    this.http.post(environment.urlApi + 'gettablecredit', body, HTTPoptions).subscribe((res: any) => {
      this.tablaCredito = res.tabla;
      console.log('TablaCredit: ', this.tablaCredito);
      /* this.loading.dismiss();
      this.apiOnReq = false; */
      this.getOtrosCreditos(this.detCredito.Cedula)
    })
  }

  getDetCredit(solicitud) {
    console.log('Obteniendo Detalles del credito...');
    this.presentLoading('Obteniendo Detalles del credito...');
    this.apiOnReq = true;
    let HTTPoptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    let body = {
      sol: solicitud
    };
    this.http.post(environment.urlApi + 'getdetcredit', body, HTTPoptions).subscribe((res: any) => {
      console.log('DetCredit res: ', res.detalle[0]);
      this.detCredito.CodUniversal = res.detalle[0].CodUniversal;
      this.detCredito.Producto = res.detalle[0].Producto;
      this.detCredito.email = res.detalle[0].email;
      this.detCredito.telefono = res.detalle[0].telefono;
      this.detCredito.Direccion = res.detalle[0].Direccion;
      this.detCredito.TipoContrato = res.detalle[0].TipoContrato;
      this.detCredito.IdEmpresa = res.detalle[0].IdEmpresa;
      console.log('Credito new: ', this.detCredito);
      /* this.loading.dismiss();
      this.apiOnReq = false; */
      this.getTableCredit(solicitud);
    })
  }

  totalOtros() {
    this.totalSaldoK = 0;
    this.totalMontoSol = 0;
    this.totalCuotasSol = 0;
    this.CapacidadCliente = 0;
    this.CapacidadClientePor = 0;
    this.CapacidadClienteDin = 0;
    this.otrosCreditos.forEach(credito => {
      this.totalSaldoK = this.totalSaldoK + credito.Saldok;
      this.totalMontoSol = this.totalMontoSol + credito.MontoSol;
      this.totalCuotasSol = this.totalCuotasSol + credito.TotCuota;
    });
    this.CapacidadCliente = this.totalCuotasSol / (this.detCredito.Salario * 0.6);
    if (this.CapacidadCliente > 0.5) { this.CapacidadCliente = 0.5; }
    this.CapacidadClientePor = Math.round(100 - 2 * (this.CapacidadCliente * 100));
    this.CapacidadClienteDin = (this.detCredito.Salario * 0.6 / 2) - this.totalCuotasSol;
    if (this.CapacidadClienteDin < 0) { this.CapacidadClienteDin = 0; }
    console.log('totalSaldoK: ', this.totalSaldoK);
    console.log('totalMontoSol: ', this.totalMontoSol);
    console.log('totalCuotasSol: ', this.totalCuotasSol);
    console.log('CapacidadCliente: ', this.CapacidadCliente);
    this.otrosCreditos.push({
      MontoSol: this.totalMontoSol,
      NumSol: 'TOTAL',
      OnCuota: '',
      Plazo: '',
      Saldok: this.totalSaldoK,
      TotCuota: this.totalCuotasSol
    })

    let MontoSolUnoDos = 0;
    let SolUnoDos = this.allEncCredits.filter((sol: any) => (sol.IdEstado == "APROBADO" || sol.IdEstado == "PENDIENTE-RH" || sol.IdEstado == "PENDIENTE-DESEMBOLSO") && sol.Cedula == this.detCredito.Cedula);
    SolUnoDos.forEach(sol => {
      MontoSolUnoDos = MontoSolUnoDos + sol.MontoSol;
    });
    this.CupoDis = this.detCredito.CupoTot - this.totalSaldoK - MontoSolUnoDos;
    if (this.CupoDis < 0) { this.CupoDis = 0; }
    this.CupoDisPor = this.CupoDis / this.detCredito.CupoTot;
  }

  async getDetCredit2(solicitud) {
    console.log('solicitud en cuestion: ', this.numsol1);
    console.log('Obteniendo Detalles del credito...');

    this.apiOnReq = true;
    let body = { sol: solicitud };

    return new Promise(async (resolve, reject) => {
      await this.presentLoading('Obteniendo Detalles del credito...');

      this.http.post(environment.urlApi + 'getdetcredit4', body).subscribe({
        next: (res: any) => {
          this.apiOnReq = false;
          if (this.loading) this.loading.dismiss();

          if (res.detalle && res.tabladet) {
            let empresa = this.empresas1.find(empresa => empresa.IdEmpresa == res.detalle.NitEmpresa);
            
            if (empresa) { res.detalle.IdEmpresa = empresa.Nombre.trim(); } else { res.detalle.IdEmpresa = 'N/E'; }
            
            let estado = this.estados.find((estado: any) => estado.IdEstado == res.detalle.IdEstado);
            res.detalle.IdEstado = estado.Descripcion;
            res.detalle.NumSol = solicitud;
            this.detCredito = res.detalle;
            this.tablaCredito = res.tabladet;
            this.otrosCreditos = res.tablaotros;
            this.totalOtros();
            resolve(res);
          } else {
            if (this.loading) this.loading.dismiss();

            this.apiOnReq = false;
            clearTimeout(this.temporizador);
            this.presentAlert('Error', 'Información no encontrada', 'El detalle no fue encontrado');
            reject(res);
          }
        },
        error: (err) => {
          if (this.loading) this.loading.dismiss();
          this.apiOnReq = false;
          clearTimeout(this.temporizador);
          this.presentAlert('Error', 'Al cargar detalle', (err?.error?.body?.originalError?.info?.message ?? ''));
          reject(err);
        }
      });
    });
  }

  ionLoadingDidPresent(event) {
    console.log('ionLoadingDidPresent: ', event);
  }

  showCreditDetail(credito: any) {
    this.numsol1 = {
      NumSol: credito.NumSol
    };
    console.log('detCredito:', credito.NumSol);
    this.getDetCredit2(credito.NumSol);
    this.showTable = "DetCredito"
  }

  showCreditDetail2(credito: any) {
    this.getDetCredit2(credito.NumSol);
    this.showTable = "DetCredito"
  }

  async showCreditDetail3(credito: any) {
    this.numsol1 = {
      NumSol: credito.NumSol,
    };

    await this.getDetCredit2(this.numsol1.NumSol);
    await this.router.navigate(['/detalle-credito']);
  }


  getTotValor() {
    this.totalValor = 0;
    this.rowsPagosR.forEach(pago => {
      this.totalValor = this.totalValor + pago.Valor;
    });
  }

  getTotalCuota() {
    this.TotCuota = 0;
    this.Ncobros = 0;
    this.rowsPagosP.forEach(pago => {
      pago.check = true; this.Ncobros = this.Ncobros + 1;
      this.TotCuota = this.TotCuota + pago.TotCuota;
    });
  }

  async getPagosR() {
    console.log('Obteniendo información de pagos...', this.busquedaPagosR, this.selectPagosR);
    await this.presentLoading('Obteniendo información de pagos...');
    this.apiOnReq = true;
    let HTTPoptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
    let body = {
      dato: this.busquedaPagosR.trim(),
      tipo: this.selectPagosR
    };
    this.http.post(environment.urlApi + 'getpagosr', body, HTTPoptions).subscribe((res: any) => {
      this.allRowsPagosR = res.tabla;
      this.rowsPagosR = res.tabla;
      this.getTotValor();
      console.log('rowsPagosR: ', this.allRowsPagosR);
      if (this.loading) { this.loading.dismiss(); }
      this.apiOnReq = false;
      clearTimeout(this.temporizador);
    })
  }

  async getPagosP() {
    console.log('Obteniendo información de pagos...', this.busquedaPagosR, this.selectPagosR);
    await this.presentLoading('Obteniendo información de pagos...');
    this.apiOnReq = true;
    let HTTPoptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
    let path;
    if (this.selectPagosP == 'e') { path = 'getreportenov' }
    if (this.selectPagosP == 'c') { path = 'getpagospendxcc' }
    if (this.selectPagosP == 's') { path = 'getpagospendxsol' }
    let body = {
      dato: this.busquedaPagosP.trim()
    };
    this.http.post(environment.urlApi + path, body, HTTPoptions).subscribe((res: any) => {
      this.allRowsPagosP = res.tabla;
      this.rowsPagosP = res.tabla;
      this.getTotalCuota();
      console.log('rowsPagosP: ', this.allRowsPagosP);
      if (this.loading) { this.loading.dismiss(); }
      this.apiOnReq = false;
      clearTimeout(this.temporizador);
    })
  }

  getTotalCuotaCheck() {
    this.TotCuota = 0;
    this.Ncobros = 0;
    this.rowsPagosP.forEach(pago => {
      if (pago.check) { this.TotCuota = this.TotCuota + pago.TotCuota; this.Ncobros = this.Ncobros + 1; }
    });
  }

  checkAllRep(ev) {
    console.log(ev);
    this.rowsPagosP.forEach(pago => {
      pago.check = ev;
    });
    this.getTotalCuotaCheck();
  }

  /* async getReporteG(){
    console.log('Obteniendo información de pagos...',this.busquedaPagosP, this.selectPagosP);
    let path;
    if(this.selectPagosP == 'e'){ path='getreportenov' }
    if(this.selectPagosP == 'c'){ path='getpagospendxcc' }
    if(this.selectPagosP == 's'){ path='getpagospendxsol' }
    this.allRowsPagosP = [];
    this.rowsPagosP = [];
    let HTTPoptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
    for(let bus of this.busquedaPagosP){
      let body={
        dato:bus.trim()
      };
      this.presentLoading('Obteniendo información de pagos Nit: '+bus+' por favor espera');
      this.apiOnReq = true;
      let query = new Promise ((resolve,reject)=>{
        this.http.post(environment.urlApi + path,body,HTTPoptions).subscribe((res:any)=>{
          this.allRowsPagosP = this.allRowsPagosP.concat(res.tabla);
          this.rowsPagosP =  this.rowsPagosP.concat(res.tabla);
          resolve('Idempresa; '+bus.trim());
        })
      });
      await query.then((res)=>{console.log('query: ',res);});
      this.loading.dismiss();
      this.apiOnReq = false;
      clearTimeout(this.temporizador);
    }
    console.log('rowsPagosP: ',this.allRowsPagosP);
    this.getTotalCuota();
  } */

  async getReporteG() {
    if (this.busquedaPagosP) {
      console.log('Obteniendo información de pagos...', this.busquedaPagosP, this.selectPagosP);
      this.presentLoading('Obteniendo información de pagos Nit: ' + this.busquedaPagosP + ' por favor espera');
      this.apiOnReq = true;
      let path;
      if (this.selectPagosP == 'e') { path = 'getreportenov2' }
      if (this.selectPagosP == 'c') { path = 'getpagospendxcc' }
      if (this.selectPagosP == 's') { path = 'getpagospendxsol' }
      let HTTPoptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
      let body = {
        dato: this.busquedaPagosP.trim()
      };
      this.http.post(environment.urlApi + path, body, HTTPoptions).subscribe((res: any) => {
        this.allRowsPagosP = (res.tabla);
        this.rowsPagosP = (res.tabla);
        this.allRowsPagosP.sort((a, b) => b.NumSol - a.NumSol);
        this.rowsPagosP.sort((a, b) => b.NumSol - a.NumSol);
        console.log('rowsPagosP: ', this.allRowsPagosP);
        this.getTotalCuota();
        if (this.loading) { this.loading.dismiss(); }
        this.apiOnReq = false;
        clearTimeout(this.temporizador);
      })
    }
  }

  async getEmpresas1() {
    console.log('Obteniendo empresas1...');
    /* await this.presentLoading('Obteniendo información de pagos...');
    this.apiOnReq = true; */
    let HTTPoptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
    let body = {
    };
    this.http.post(environment.urlApi + 'getempresas1', body, HTTPoptions).subscribe((res: any) => {
      this.empresas1 = res.tabla;
      console.log('Empresas1: ', this.empresas1);
      /* this.loading.dismiss();
      this.apiOnReq = false; */
    })
  }

  /* async getEmpresas2(){
    console.log('Obteniendo empresas2...');
    await this.presentLoading('Obteniendo información de Convenios...');
    this.apiOnReq = true;
    let HTTPoptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
    let body={
    };
    this.http.post(environment.urlApi + 'getempresas2',body,HTTPoptions).subscribe((res:any)=>{
      this.empresas2 = res.tabla;
      this.allEmpresas = res.tabla;
      this.filtEmpresas = res.tabla;
      console.log('Empresas2: ', this.empresas2);
      this.updateFilter6(this.busqueda6);
      if (this.loading) { this.loading.dismiss(); }
      this.apiOnReq = false;
      clearTimeout(this.temporizador);
    })
  } */

  GenReporte() {
    console.log('reporte length: ', this.ReporteNov.length)
    let fecha = new Date();
    let fechaForm = fecha.getFullYear() + '-' + (fecha.getMonth() + 1) + '-' + fecha.getDate(); /* +' '+fecha.getHours()+':'+fecha.getMinutes()+':'+fecha.getSeconds()+':'+fecha.getMilliseconds(); */
    this.ReporteNov.enc = {
      IdEmpresa: this.busquedaPagosP.trim(),
      Fecha: fechaForm,
      Ncobros: this.Ncobros,
      ValorRep: this.TotCuota
    }
    /* this.ReporteNov.det = this.rowsPagosP; */
    this.ReporteNov.det = [];
    this.rowsPagosP.forEach(p => { if (p.check) { this.ReporteNov.det.push(p); } });
    this.ReporteNovShow.enc = this.ReporteNov.enc;
    this.ReporteNovShow.det = this.ReporteNov.det.slice();
    this.ReporteNovShow.det.push({
      Cedula: "",
      Cuota: "",
      Empresa: "",
      FechaDes: "",
      FechaEstPago: "TOTAL",
      IdEmpresa: "",
      MontoSol: "",
      NombreCompleto: "",
      NumSol: "",
      OnCuota: "",
      Plazo: "",
      Sede: "",
      Tipo: "",
      TotCuota: this.TotCuota
    });
    console.log('ReporteNovShow: ', this.ReporteNovShow);
    this.IdReporte = "";
    this.repShowEn = true;
  }

  async SendRepNov() {
    console.log("ReporteNov.enc: ", this.ReporteNov.enc);
    console.log("ReporteNov.det: ", this.ReporteNov.det);
    console.log('Guardando ReporteNov: ', this.ReporteNov);
    await this.presentLoading('Guardando reporte de novedad...');
    this.apiOnReq = true;
    let HTTPoptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
    let body = {
      enc: this.ReporteNov.enc,
      det: this.ReporteNov.det
    };
    this.http.post(environment.urlApi + 'putreportenov', body, HTTPoptions).subscribe((res: any) => {
      console.log('rowsPagosP: ', res);
      this.IdReporte = res.IdReporte
      if (this.ReporteNov.enc.Ncobros != res.CobrosOk) { alert('Solo se guardaron ' + res.CobrosOk + ' cobros.') }
      else { this.presentToast('Se guardó el reporte de novedad correctamente!'); }
      if (this.loading) { this.loading.dismiss(); }
      this.apiOnReq = false;
      clearTimeout(this.temporizador);
      this.getEncReporte();
    })
  }

  async getEncReporte() {
    console.log('Obteniendo encabezado de reportes..');
    await this.presentLoading('Obteniendo encabezado de reportes..');
    this.apiOnReq = true;
    let HTTPoptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
    let body = {
    };
    this.http.post(environment.urlApi + 'getencreportes', body, HTTPoptions).subscribe((res: any) => {
      res.tabla.forEach(rep => {
        rep.DifRec = rep.ValorRep - rep.ValorRec;
        rep.ValorDif = rep.ValorRec - rep.ValorApl;
      });
      this.EncReportes = res.tabla;
      this.EncReportesFilt = res.tabla;
      console.log('EncReportes: ', this.EncReportes);
      this.updateFilter8(this.busqueda8);
      if (this.loading) { this.loading.dismiss(); }
      this.apiOnReq = false;
      clearTimeout(this.temporizador);
    })
  }

  async getDetReporte(reporte) {
    this.showDetReporte = true;
    this.encReporte = reporte;
    console.log('Obteniendo detalles del reporte..');
    await this.presentLoading('Obteniendo detalles del reporte..');
    this.apiOnReq = true;
    let HTTPoptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
    let body = {
      idreporte: reporte.IdReporte
    };
    this.http.post(environment.urlApi + 'getdetreporte', body, HTTPoptions).subscribe((res: any) => {
      res.tabla = res.tabla.sort((a, b) => b.NumSol - a.NumSol);
      this.DetReporte = res.tabla;
      this.DetReporteFilt = res.tabla;
      console.log('DetReporte: ', this.DetReporte);
      if (this.loading) { this.loading.dismiss(); }
      this.apiOnReq = false;
      clearTimeout(this.temporizador);
      this.updateFilter9(this.busqueda9);
    })
  }

  async getFechaEst(cobro) {
    console.log('cobro: ', cobro);
    if (cobro.Cuota > 0 && cobro.Cuota <= cobro.Plazo) {
      console.log('Obteniendo fecha estimada de pago...');
      /* this.presentLoading('Obteniendo fecha estimada de pago...');
      this.apiOnReq = true; */
      let HTTPoptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
      let body = {
        numsol: cobro.NumSol,
        cuota: cobro.Cuota
      };
      this.http.post(environment.urlApi + 'getfechaestpago', body, HTTPoptions).subscribe((res: any) => {
        /* this.DetReporte = res.tabla;
        console.log('DetReporte: ',this.DetReporte); */
        console.log('res: ', res.FechaEstPago);
        let index = this.rowsPagosP.findIndex(cob => cob.NumSol == cobro.NumSol && cob.Cuota == cobro.Cuota);
        this.rowsPagosP[index].FechaEstPago = res.FechaEstPago
        /* this.loading.dismiss();
        this.apiOnReq = false;
        clearTimeout(this.temporizador); */
      })
    }
  }

  async getEncPensiones() {
    console.log('Obteniendo operaciones de pensiones...');
    await this.presentLoading('Obteniendo operaciones de pensiones...');
    this.apiOnReq = true;
    let body = {};
    this.http.post(environment.urlApi + 'getencpensiones', body).subscribe((res: any) => {
      res.tabla.forEach(credito => {
        let empresa = this.empresas1.find(empresa => empresa.IdEmpresa == credito.IdEmpresa);
        if (empresa) { credito.IdEmpresa = empresa.Nombre.trim(); }
        else { credito.IdEmpresa = 'N/E' }
        if (credito.IdEstado == 2 && credito.AprobadoRH == 0) { credito.IdEstado = '8' }
        let estado = this.estados.find(estado => estado.IdEstado == credito.IdEstado)
        credito.IdEstado = estado.Descripcion
      });
      this.allEncPensiones = res.tabla;
      this.filtEncPen = res.tabla;
      if (this.loading) { this.loading.dismiss(); }
      this.apiOnReq = false;
      clearTimeout(this.temporizador);
      console.log('AllEncPensiones: ', this.allEncPensiones);
      this.updateFilter4(this.busqueda4);
    })
  }

  async getInfoCierreDiario2() {
    console.log('Obteniendo informe diario...');
    await this.presentLoading('Obteniendo informe diario...');
    this.apiOnReq = true;
    let body = {
      fechadesde: this.FechaDesde,
      fechahasta: this.FechaHasta
    };
    this.http.post(environment.urlApi + 'getinfocierrediario2', body).subscribe((res: any) => {
      console.log('getinfocierrediario2: ', res);
      this.rowsInformeCierreDiarioD = [];
      this.rowsInformeCierreDiarioM = [];
      res.forEach(e => {
        this.rowsInformeCierreDiarioD.push({
          Estado: e.Descrip,
          Cantidad: e.CantidadF || 0,
          Monto: e.MontoF || 0,
          Interes: e.InteresF || 0,
          Seguro: e.SeguroF || 0,
          Cloud: e.CloudF || 0
        });
        this.rowsInformeCierreDiarioM.push({
          Estado: e.Descrip,
          Cantidad: e.CantidadM || 0,
          Monto: e.MontoM || 0,
          Interes: e.InteresM || 0,
          Seguro: e.SeguroM || 0,
          Cloud: e.CloudM || 0
        });
      });
      this.apiOnReq = false;
      if (this.loading) { this.loading.dismiss(); }
      clearTimeout(this.temporizador);
    })
  }

  cant_Aprobados;
  fee_Aprobados;
  interes_Aprobados;
  montoSol_Aprobados;
  seguro_Aprobados;

  cant_AprobadosM;
  fee_AprobadosM;
  interes_AprobadosM;
  montoSol_AprobadosM;
  seguro_AprobadosM;

  cant_Desembolsados;
  fee_Desembolsados;
  interes_Desembolsados;
  montoSol_Desembolsados;
  seguro_Desembolsados;

  cant_DesembolsadosM;
  fee_DesembolsadosM;
  interes_DesembolsadosM;
  montoSol_DesembolsadosM;
  seguro_DesembolsadosM;

  cant_Pagados;
  fee_Pagados;
  interes_Pagados;
  montoSol_Pagados;
  seguro_Pagados;

  cant_PagadosM;
  fee_PagadosM;
  interes_PagadosM;
  montoSol_PagadosM;
  seguro_PagadosM;

  cant_PendientesDes;
  fee_PendientesDes;
  interes_PendientesDes;
  montoSol_PendientesDes;
  seguro_PendientesDes;

  cant_PendientesDesM;
  fee_PendientesDesM;
  interes_PendientesDesM;
  montoSol_PendientesDesM;
  seguro_PendientesDesM;

  cant_PendientesRh;
  fee_PendientesRh;
  interes_PendientesRh;
  montoSol_PendientesRh;
  seguro_PendientesRh;

  cant_PendientesRhM;
  fee_PendientesRhM;
  interes_PendientesRhM;
  montoSol_PendientesRhM;
  seguro_PendientesRhM;

  cant_Rechazados;
  fee_Rechazados;
  interes_Rechazados;
  montoSol_Rechazados;
  seguro_Rechazados;

  cant_RechazadosM;
  fee_RechazadosM;
  interes_RechazadosM;
  montoSol_RechazadosM;
  seguro_RechazadosM;

  cant_Solicitudes;
  fee_Solicitudes;
  interes_Solicitudes;
  montoSol_Solicitudes;
  seguro_Solicitudes;

  cant_SolicitudesM;
  fee_SolicitudesM;
  interes_SolicitudesM;
  montoSol_SolicitudesM;
  seguro_SolicitudesM;

  genInfCierreDiario() {
    console.log(this.FechaDesde)
    console.log(this.FechaHasta)
    if (this.FechaDesde && this.FechaHasta) {
      let desde = this.FechaDesde.split("-");
      let hasta = this.FechaHasta.split("-");
      console.log('Fecha desde:', +desde[0], "-", +desde[1], "-", +desde[2]);
      console.log('Fecha hasta:', +hasta[0], "-", +hasta[1], "-", +hasta[2]);
      console.log('Obteniendo operaciones de pensiones...');
      this.presentLoading('Obteniendo informe por favor espera...');
      this.apiOnReq = true;
      let body = {
        yeardesde: +desde[0],
        monthdesde: +desde[1],
        daydesde: +desde[2],
        yearhasta: +hasta[0],
        monthhasta: +hasta[1],
        dayhasta: +hasta[2]
      };
      this.http.post(environment.urlApi + 'getinfocierrediario', body).subscribe((res: any) => {
        console.log('Informe: ', res);
        if (this.loading) { this.loading.dismiss(); }
        this.apiOnReq = false;
        clearTimeout(this.temporizador);
        this.getCalcInformeCierreDiario(res);
      })

    } else { alert('Por favor indica ambas fechas'); }
  }

  getCalcInformeCierreDiario(res) {
    this.rowsInformeCierreDiario = [];



    this.cant_Solicitudes = 0;
    this.fee_Solicitudes = 0;
    this.interes_Solicitudes = 0;
    this.montoSol_Solicitudes = 0;
    this.seguro_Solicitudes = 0;
    this.cant_SolicitudesM = 0;
    this.fee_SolicitudesM = 0;
    this.interes_SolicitudesM = 0;
    this.montoSol_SolicitudesM = 0;
    this.seguro_SolicitudesM = 0;
    res.solicitudes.forEach(sol => {
      if (sol.Tipo.toLowerCase() == 'd') {
        this.cant_Solicitudes = this.cant_Solicitudes + 1;
        this.fee_Solicitudes = this.fee_Solicitudes + sol.Fee;
        this.interes_Solicitudes = this.interes_Solicitudes + sol.Interes;
        this.montoSol_Solicitudes = this.montoSol_Solicitudes + sol.MontoSol;
        this.seguro_Solicitudes = this.seguro_Solicitudes + sol.Seguro;
      } else {
        this.cant_SolicitudesM = this.cant_SolicitudesM + 1;
        this.fee_SolicitudesM = this.fee_SolicitudesM + sol.Fee;
        this.interes_SolicitudesM = this.interes_SolicitudesM + sol.Interes;
        this.montoSol_SolicitudesM = this.montoSol_SolicitudesM + sol.MontoSol;
        this.seguro_SolicitudesM = this.seguro_SolicitudesM + sol.Seguro;
      }
    });
    this.rowsInformeCierreDiario.push({
      Tipo: 'Dinero',
      IdSolicitud: 'Solicitudes',
      Cantidad: this.cant_Solicitudes,
      Monto: this.montoSol_Solicitudes,
      Interes: this.interes_Solicitudes,
      Seguro: this.seguro_Solicitudes,
      Cloud: this.fee_Solicitudes,
    })
    this.rowsInformeCierreDiario.push({
      Tipo: 'Market',
      IdSolicitud: 'Solicitudes',
      Cantidad: this.cant_SolicitudesM,
      Monto: this.montoSol_SolicitudesM,
      Interes: this.interes_SolicitudesM,
      Seguro: this.seguro_SolicitudesM,
      Cloud: this.fee_SolicitudesM,
    })



    this.cant_Aprobados = 0;
    this.fee_Aprobados = 0;
    this.interes_Aprobados = 0;
    this.montoSol_Aprobados = 0;
    this.seguro_Aprobados = 0;
    this.cant_AprobadosM = 0;
    this.fee_AprobadosM = 0;
    this.interes_AprobadosM = 0;
    this.montoSol_AprobadosM = 0;
    this.seguro_AprobadosM = 0;
    res.aprobados.forEach(sol => {
      if (sol.tipo.toLowerCase() == 'd') {
        this.cant_Aprobados = this.cant_Aprobados + 1;
        this.fee_Aprobados = this.fee_Aprobados + sol.Fee;
        this.interes_Aprobados = this.interes_Aprobados + sol.Interes;
        this.montoSol_Aprobados = this.montoSol_Aprobados + sol.MontoSol;
        this.seguro_Aprobados = this.seguro_Aprobados + sol.Seguro;
      } else {
        this.cant_AprobadosM = this.cant_AprobadosM + 1;
        this.fee_AprobadosM = this.fee_AprobadosM + sol.Fee;
        this.interes_AprobadosM = this.interes_AprobadosM + sol.Interes;
        this.montoSol_AprobadosM = this.montoSol_AprobadosM + sol.MontoSol;
        this.seguro_AprobadosM = this.seguro_AprobadosM + sol.Seguro;
      }
    });
    this.rowsInformeCierreDiario.push({
      Tipo: 'Dinero',
      IdSolicitud: 'Aprobados',
      Cantidad: this.cant_Aprobados,
      Monto: this.montoSol_Aprobados,
      Interes: this.interes_Aprobados,
      Seguro: this.seguro_Aprobados,
      Cloud: this.fee_Aprobados,
    })
    this.rowsInformeCierreDiario.push({
      Tipo: 'Market',
      IdSolicitud: 'Aprobados',
      Cantidad: this.cant_AprobadosM,
      Monto: this.montoSol_AprobadosM,
      Interes: this.interes_AprobadosM,
      Seguro: this.seguro_AprobadosM,
      Cloud: this.fee_AprobadosM,
    })


    this.cant_PendientesRh = 0;
    this.fee_PendientesRh = 0;
    this.interes_PendientesRh = 0;
    this.montoSol_PendientesRh = 0;
    this.seguro_PendientesRh = 0;
    this.cant_PendientesRhM = 0;
    this.fee_PendientesRhM = 0;
    this.interes_PendientesRhM = 0;
    this.montoSol_PendientesRhM = 0;
    this.seguro_PendientesRhM = 0;
    res.pendientesrh.forEach(sol => {
      if (sol.Tipo.toLowerCase() == 'd') {
        this.cant_PendientesRh = this.cant_PendientesRh + 1;
        this.fee_PendientesRh = this.fee_PendientesRh + sol.Fee;
        this.interes_PendientesRh = this.interes_PendientesRh + sol.Interes;
        this.montoSol_PendientesRh = this.montoSol_PendientesRh + sol.MontoSol;
        this.seguro_PendientesRh = this.seguro_PendientesRh + sol.Seguro;
      } else {
        this.cant_PendientesRhM = this.cant_PendientesRhM + 1;
        this.fee_PendientesRhM = this.fee_PendientesRhM + sol.Fee;
        this.interes_PendientesRhM = this.interes_PendientesRhM + sol.Interes;
        this.montoSol_PendientesRhM = this.montoSol_PendientesRhM + sol.MontoSol;
        this.seguro_PendientesRhM = this.seguro_PendientesRhM + sol.Seguro;
      }
    });
    this.rowsInformeCierreDiario.push({
      Tipo: 'Dinero',
      IdSolicitud: 'PendientesRh',
      Cantidad: this.cant_PendientesRh,
      Monto: this.montoSol_PendientesRh,
      Interes: this.interes_PendientesRh,
      Seguro: this.seguro_PendientesRh,
      Cloud: this.fee_PendientesRh,
    })
    this.rowsInformeCierreDiario.push({
      Tipo: 'Market',
      IdSolicitud: 'PendientesRh',
      Cantidad: this.cant_PendientesRhM,
      Monto: this.montoSol_PendientesRhM,
      Interes: this.interes_PendientesRhM,
      Seguro: this.seguro_PendientesRhM,
      Cloud: this.fee_PendientesRhM,
    })

    this.cant_PendientesDes = 0;
    this.fee_PendientesDes = 0;
    this.interes_PendientesDes = 0;
    this.montoSol_PendientesDes = 0;
    this.seguro_PendientesDes = 0;
    this.cant_PendientesDesM = 0;
    this.fee_PendientesDesM = 0;
    this.interes_PendientesDesM = 0;
    this.montoSol_PendientesDesM = 0;
    this.seguro_PendientesDesM = 0;
    res.pendientesdes.forEach(sol => {
      if (sol.Tipo.toLowerCase() == 'd') {
        this.cant_PendientesDes = this.cant_PendientesDes + 1;
        this.fee_PendientesDes = this.fee_PendientesDes + sol.Fee;
        this.interes_PendientesDes = this.interes_PendientesDes + sol.Interes;
        this.montoSol_PendientesDes = this.montoSol_PendientesDes + sol.MontoSol;
        this.seguro_PendientesDes = this.seguro_PendientesDes + sol.Seguro;
      } else {
        this.cant_PendientesDesM = this.cant_PendientesDesM + 1;
        this.fee_PendientesDesM = this.fee_PendientesDesM + sol.Fee;
        this.interes_PendientesDesM = this.interes_PendientesDesM + sol.Interes;
        this.montoSol_PendientesDesM = this.montoSol_PendientesDesM + sol.MontoSol;
        this.seguro_PendientesDesM = this.seguro_PendientesDesM + sol.Seguro;
      }
    });
    this.rowsInformeCierreDiario.push({
      Tipo: 'Dinero',
      IdSolicitud: 'PendientesDes',
      Cantidad: this.cant_PendientesDes,
      Monto: this.montoSol_PendientesDes,
      Interes: this.interes_PendientesDes,
      Seguro: this.seguro_PendientesDes,
      Cloud: this.fee_PendientesDes,
    })
    this.rowsInformeCierreDiario.push({
      Tipo: 'Market',
      IdSolicitud: 'PendientesDes',
      Cantidad: this.cant_PendientesDesM,
      Monto: this.montoSol_PendientesDesM,
      Interes: this.interes_PendientesDesM,
      Seguro: this.seguro_PendientesDesM,
      Cloud: this.fee_PendientesDesM,
    })

    this.cant_Desembolsados = 0;
    this.fee_Desembolsados = 0;
    this.interes_Desembolsados = 0;
    this.montoSol_Desembolsados = 0;
    this.seguro_Desembolsados = 0;
    this.cant_DesembolsadosM = 0;
    this.fee_DesembolsadosM = 0;
    this.interes_DesembolsadosM = 0;
    this.montoSol_DesembolsadosM = 0;
    this.seguro_DesembolsadosM = 0;
    res.desembolsados.forEach(sol => {
      if (sol.Tipo.toLowerCase() == 'd') {
        this.cant_Desembolsados = this.cant_Desembolsados + 1;
        this.fee_Desembolsados = this.fee_Desembolsados + sol.Fee;
        this.interes_Desembolsados = this.interes_Desembolsados + sol.Interes;
        this.montoSol_Desembolsados = this.montoSol_Desembolsados + sol.MontoSol;
        this.seguro_Desembolsados = this.seguro_Desembolsados + sol.Seguro;
      } else {
        this.cant_DesembolsadosM = this.cant_DesembolsadosM + 1;
        this.fee_DesembolsadosM = this.fee_DesembolsadosM + sol.Fee;
        this.interes_DesembolsadosM = this.interes_DesembolsadosM + sol.Interes;
        this.montoSol_DesembolsadosM = this.montoSol_DesembolsadosM + sol.MontoSol;
        this.seguro_DesembolsadosM = this.seguro_DesembolsadosM + sol.Seguro;
      }
    });
    this.rowsInformeCierreDiario.push({
      Tipo: 'Dinero',
      IdSolicitud: 'Desembolsados',
      Cantidad: this.cant_Desembolsados,
      Monto: this.montoSol_Desembolsados,
      Interes: this.interes_Desembolsados,
      Seguro: this.seguro_Desembolsados,
      Cloud: this.fee_Desembolsados,
    })
    this.rowsInformeCierreDiario.push({
      Tipo: 'Market',
      IdSolicitud: 'Desembolsados',
      Cantidad: this.cant_DesembolsadosM,
      Monto: this.montoSol_DesembolsadosM,
      Interes: this.interes_DesembolsadosM,
      Seguro: this.seguro_DesembolsadosM,
      Cloud: this.fee_DesembolsadosM,
    })

    this.cant_Pagados = 0;
    this.fee_Pagados = 0;
    this.interes_Pagados = 0;
    this.montoSol_Pagados = 0;
    this.seguro_Pagados = 0;
    this.cant_PagadosM = 0;
    this.fee_PagadosM = 0;
    this.interes_PagadosM = 0;
    this.montoSol_PagadosM = 0;
    this.seguro_PagadosM = 0;
    res.pagados.forEach(sol => {
      if (sol.Tipo.toLowerCase() == 'd') {
        this.cant_Pagados = this.cant_Pagados + 1;
        this.fee_Pagados = this.fee_Pagados + sol.Fee;
        this.interes_Pagados = this.interes_Pagados + sol.Interes;
        this.montoSol_Pagados = this.montoSol_Pagados + sol.MontoSol;
        this.seguro_Pagados = this.seguro_Pagados + sol.Seguro;
      } else {
        this.cant_PagadosM = this.cant_PagadosM + 1;
        this.fee_PagadosM = this.fee_PagadosM + sol.Fee;
        this.interes_PagadosM = this.interes_PagadosM + sol.Interes;
        this.montoSol_PagadosM = this.montoSol_PagadosM + sol.MontoSol;
        this.seguro_PagadosM = this.seguro_PagadosM + sol.Seguro;
      }
    });
    this.rowsInformeCierreDiario.push({
      Tipo: 'Dinero',
      IdSolicitud: 'Pagados',
      Cantidad: this.cant_Pagados,
      Monto: this.montoSol_Pagados,
      Interes: this.interes_Pagados,
      Seguro: this.seguro_Pagados,
      Cloud: this.fee_Pagados,
    })
    this.rowsInformeCierreDiario.push({
      Tipo: 'Market',
      IdSolicitud: 'Pagados',
      Cantidad: this.cant_PagadosM,
      Monto: this.montoSol_PagadosM,
      Interes: this.interes_PagadosM,
      Seguro: this.seguro_PagadosM,
      Cloud: this.fee_PagadosM,
    })

    this.cant_Rechazados = 0;
    this.fee_Rechazados = 0;
    this.interes_Rechazados = 0;
    this.montoSol_Rechazados = 0;
    this.seguro_Rechazados = 0;
    this.cant_RechazadosM = 0;
    this.fee_RechazadosM = 0;
    this.interes_RechazadosM = 0;
    this.montoSol_RechazadosM = 0;
    this.seguro_RechazadosM = 0;
    res.rechazados.forEach(sol => {
      if (sol.Tipo.toLowerCase() == 'd') {
        this.cant_Rechazados = this.cant_Rechazados + 1;
        this.fee_Rechazados = this.fee_Rechazados + sol.Fee;
        this.interes_Rechazados = this.interes_Rechazados + sol.Interes;
        this.montoSol_Rechazados = this.montoSol_Rechazados + sol.MontoSol;
        this.seguro_Rechazados = this.seguro_Rechazados + sol.Seguro;
      } else {
        this.cant_RechazadosM = this.cant_RechazadosM + 1;
        this.fee_RechazadosM = this.fee_RechazadosM + sol.Fee;
        this.interes_RechazadosM = this.interes_RechazadosM + sol.Interes;
        this.montoSol_RechazadosM = this.montoSol_RechazadosM + sol.MontoSol;
        this.seguro_RechazadosM = this.seguro_RechazadosM + sol.Seguro;
      }
    });
    this.rowsInformeCierreDiario.push({
      Tipo: 'Dinero',
      IdSolicitud: 'Rechazados',
      Cantidad: this.cant_Rechazados,
      Monto: this.montoSol_Rechazados,
      Interes: this.interes_Rechazados,
      Seguro: this.seguro_Rechazados,
      Cloud: this.fee_Rechazados,
    })
    this.rowsInformeCierreDiario.push({
      Tipo: 'Market',
      IdSolicitud: 'Rechazados',
      Cantidad: this.cant_RechazadosM,
      Monto: this.montoSol_RechazadosM,
      Interes: this.interes_RechazadosM,
      Seguro: this.seguro_RechazadosM,
      Cloud: this.fee_RechazadosM,
    })


    this.rowsInformeCierreDiarioD = [];
    this.rowsInformeCierreDiarioM = [];
    this.rowsInformeCierreDiario.forEach(res => {
      if (res.Tipo == "Dinero") {
        this.rowsInformeCierreDiarioD.push(res);
      } else if (res.Tipo == "Market") {
        this.rowsInformeCierreDiarioM.push(res);
      }
    });
    this.rowsInformeCierreDiarioD = this.rowsInformeCierreDiarioD.slice();
    this.rowsInformeCierreDiarioM = this.rowsInformeCierreDiarioM.slice();

    console.log('rowsInformeCierreDiario: ', this.rowsInformeCierreDiario);
    console.log('rowsInformeCierreDiarioD: ', this.rowsInformeCierreDiarioD);
    console.log('rowsInformeCierreDiarioM: ', this.rowsInformeCierreDiarioM);
  }


  /* async loginFun() {
    console.log('Validando credenciales por favor espera...');
    await this.presentLoading('Validando credenciales por favor espera...');
    this.apiOnReq = true;
    let body = {
      usuario: this.usuario.trim(),
      clave:this.clave.trim()
    };
    this.http.post(environment.urlApi + 'loginnewcoorp',body).subscribe((res:any)=>{
      console.log('res: ', res);
      if (res.res == "Logeado") {
        this.login = true;
        this.user = res.usuario;
        this.router.navigate(['/dashboard']);
        this.presentToast('Bienvenido ' + this.user.Nombres);
        this.cargaApiIni();
        Storage.set({
          key: 'loginNewCoorpDen',
          value: JSON.stringify({
            login: this.login,
            user:this.user
          })
        })
        .then((res) => {
          console.log('informacion de usuario guardada correctamente ', res);
        })
        .catch((err) => {
          console.log('Error al guardar informacion de usuario ', err);
        });
        this.usuario = ""; this.clave = "";
      }
      else {
        alert(res.res);
      }
      if (this.loading) { this.loading.dismiss(); }
      this.apiOnReq = false;
      clearTimeout(this.temporizador);
    })
  } */

  logOut() {
    /* this.menu.close('end'); */
    this.login = false;
    Storage.remove({ key: 'loginNewCoorpDen' }).then(() => {
      window.location.reload();
      /* this.router.navigate(['/']); */
    });
  }

  recuperarClave() {
    console.log('correo: ', this.correo);
    console.log('Enviando correo...');
    this.presentLoading('Enviando correo...');
    this.apiOnReq = true;
    let body = {
      email: this.correo
    };
    this.http.post(environment.urlApi + 'recuperarclavecoorp', body).subscribe((res: any) => {
      console.log(res);
      this.presentToast(res.res);
      if (this.loading) { this.loading.dismiss(); }
      this.apiOnReq = false;
      clearTimeout(this.temporizador);
    })

  }
  async getLiqHis() {
    console.log('Obteniendo Historial de Liquidaciones...');
    await this.presentLoading('Obteniendo Historial de Liquidaciones...');
    this.apiOnReq = true;
    let body = {};
    this.http.post(environment.urlApi + 'gethisliq', body).subscribe((res: any) => {
      res.forEach(credito => {
        let empresa = this.empresas1.find(empresa => empresa.IdEmpresa == credito.IdEmpresa);
        credito.Empresa = empresa.Nombre.trim();
        if (credito.Aplicado > 0) { credito.AplString = 'aplicado'; } else { credito.AplString = ''; }
      });
      this.allHisLiq = res;
      this.filtHisLiq = res;
      if (this.loading) { this.loading.dismiss(); }
      this.apiOnReq = false;
      clearTimeout(this.temporizador);
      /* this.filtEncCreditEstados(this.allEncCredits); */
      this.updateFilter5(this.busqueda5.trim());
    })
    /* this.allEncCredits = this.allEncCreditsPru;
    this.filtEncCred = this.allEncCreditsPru;
    this.filtEncCreditEstados(this.allEncCredits); */
  }

  /* async deleteConvenio(convenio) {
    console.log('convenio: ',convenio)
    const alert = await this.alertController.create({
      cssClass: 'my-custom-class',
      header: '¿Estás seguro?',
      mode:'ios',
      subHeader: 'Eliminarás a '+ convenio.Nombre.trim(),
      buttons: [
        {
          text: 'Cancelar',
          role: 'cancel',
          cssClass: 'secondary',
          handler: (blah) => {
            console.log('Confirm Cancel: blah');
          }
        }, {
          text: 'Confirmar',
          handler: () => {
            console.log('Confirm Okay');
            this.deleteConvenioApi(convenio);
          }
        }
      ]
    });

    await alert.present();
  }

  async deleteConvenioApi(convenio) {
    console.log('deleteConvenioApi: ', convenio);
    console.log('Eliminando convenio...');
        await this.presentLoading('Eliminando convenio...');
        this.apiOnReq = true;
        let body={
          convenio:convenio
        };
        this.http.post(environment.urlApi + 'deleteconv',body).subscribe((res:any)=>{
          console.log('deleteconv: ',res);
          if (res.res == "error") {
            this.presentAlert('Error', 'Al eliminar convenio', res.body.originalError.info.message);
          } else {
            this.getEmpresas2();
            this.presentToast('Convenio eliminado correctamente!');
          }
          if (this.loading) { this.loading.dismiss(); }
          this.apiOnReq = false;
          clearTimeout(this.temporizador);
        })
  } */


  /* async editConvenio(ev: any,convenio:any) {
    console.log('convenio: ',convenio)
    this.convenio = convenio;
    const popover = await this.popoverController.create({
      component: ConvenioPage,
      cssClass: 'popoverStyle2',
      event: ev,
      translucent: true,
      componentProps: {},
      mode:'ios'
    });
    return await popover.present();
  } */

  /* async editConvenioApi(){
    console.log('convenio to edit:', this.convenio);
    if (this.toNull(this.convenio.IdEmpresa) != null && this.toNull(this.convenio.Nombre) != null) {
        console.log('Guardando datos de Convenio...');
        await this.presentLoading('Guardando datos de convenio...');
        this.apiOnReq = true;
        let body={
          convenio:this.convenio
        };
        this.http.post(environment.urlApi + 'updateconv',body).subscribe((res:any)=>{
          console.log('updateconv: ',res);
          if (res.res == "error") {
            this.presentAlert('Error', 'Al editar convenio', res.body.originalError.info.message);
          }else{
            this.popoverController.dismiss();
            this.getEmpresas2();
            this.presentToast('Información guardada correctamente!');
          }
          if (this.loading) { this.loading.dismiss(); }
          this.apiOnReq = false;
          clearTimeout(this.temporizador);
        })
    } else {
      this.presentAlert('Error', 'Al editar convenio', 'Los campos que inician con * son obligatorios');
    }
  } */

  /* async verAddConvenio(ev: any) {
    const popover = await this.popoverController.create({
      component: ConvenionewPage,
      cssClass: 'popoverStyle2',
      event: ev,
      translucent: true,
      componentProps: {},
      mode:'ios'
    });
    return await popover.present();
  } */

  /* async addConvenio(){
    console.log('Convenio New: ',this.convenioNew);
    if (this.toNull(this.convenioNew.IdEmpresa) != null && this.toNull(this.convenioNew.Nombre) != null) {
        console.log('Creando Convenio...');
        await this.presentLoading('Creando convenio...');
        this.apiOnReq = true;
        let body={
          convenio:this.convenioNew
        };
        this.http.post(environment.urlApi + 'createconv',body).subscribe((res:any)=>{
          console.log('createconv: ',res);
          if (res.res == "error") {
            this.presentAlert('Error', 'Al crear convenio', res.body.originalError.info.message);
          }else{
            this.popoverController.dismiss();
            this.getEmpresas2();
            this.presentToast('Convenio creado correctamente!');
          }
          if (this.loading) { this.loading.dismiss(); }
          this.apiOnReq = false;
          clearTimeout(this.temporizador);
        })
    } else {
      this.presentAlert('Error', 'Al editar convenio', 'Los campos que inician con * son obligatorios');
    }
  } */


  getLineasXemp() {
    this.LineasXemp = this.Lineas.filter((d) => {
      return (d.IdEmpresa.toString().indexOf(this.Empleado.IdEmpresa) !== -1);
    });
    console.log('LineasXemp: ', this.LineasXemp);
  }

  getLineasXempNew() {
    this.LineasXemp = this.Lineas.filter((d) => {
      return (d.IdEmpresa.toString().indexOf(this.EmpleadoNew.IdEmpresa) !== -1);
    });
    console.log('LineasXemp: ', this.LineasXemp);
  }

  async empleadosSearchFun() {
    console.log('Empleados Search: ', this.busquedaEmpleado);
    console.log('Empleados Select: ', this.selectEmpleadosB);

    console.log('Obteniendo informacion...');
    this.presentLoading('Obteniendo información...');
    this.apiOnReq = true;
    let body = {
      tipo: this.selectEmpleadosB,
      search: this.busquedaEmpleado
    };
    this.http.post(environment.urlApi + 'getempleados', body).subscribe((res: any) => {
      console.log('res: ', res);
      res.forEach(emp => {
        emp.NombreCompleto = emp.Apellido1 + ' ' + emp.Apellido2 + ' ' + emp.Nombre1 + ' ' + emp.Nombre2;
        emp.FechaNacimiento = this.datePipe.transform(emp.FechaNacimiento, "yyy-MM-dd", "+0000");
        emp.FechaIngreso = this.datePipe.transform(emp.FechaIngreso, "yyy-MM-dd", "+0000");
        emp.FechaFinalCont = this.datePipe.transform(emp.FechaFinalCont, "yyy-MM-dd", "+0000");
        if (emp.TipoContrato) { emp.TipoContrato = emp.TipoContrato.toUpperCase(); }
        if (emp.TipoCuenta) { emp.TipoCuenta = emp.TipoCuenta.toUpperCase(); }
        if (emp.Sexo) { emp.Sexo = emp.Sexo.toUpperCase(); }
      });
      this.AllEmpleados = res;
      this.EmpleadosFilt = res;
      this.updateFilter7(this.busqueda7);
      if (this.loading) { this.loading.dismiss(); }
      this.apiOnReq = false;
      clearTimeout(this.temporizador);
    })

  }


  /* async cambiarSolicitudApi(){
    console.log("soliitud: ",this.solEdit);
    console.log("New estado:", this.editEstadoValue);
    let item = this.estados.findIndex(est => est.Descripcion == this.editEstadoValue);
    let IdEstado = this.estados[item].IdEstado;
    console.log('IdEstado: ',IdEstado);
    console.log('New Sol. Reperf.: ',this.solReperfilado)
    if(IdEstado == 9 || IdEstado == 11){
      console.log('Cambiando estado...');
      await this.presentLoading('Cambiando estado...');
      this.apiOnReq = true;
      let body={
        numsol:this.solEdit.NumSol,
        newidestado:IdEstado,
        newsol:this.solReperfilado
      };
      this.http.post(environment.urlApi + 'changeestadosol',body).subscribe((res:any)=>{
        console.log('res: ',res);
        if (this.loading) { this.loading.dismiss(); }
        this.apiOnReq = false;
        clearTimeout(this.temporizador);
        this.getRunCredits2();
        this.popoverController.dismiss();
      })

    }else if(IdEstado == 10){
      console.log('pagoAntValue: ',this.pagoAntValue);
      console.log('usuario: ',this.user.Usuario);

      console.log('Cambiando estado...');
      await this.presentLoading('Cambiando estado...');
      this.apiOnReq = true;
      let body={
        numsol:this.solEdit.NumSol,
        saldok:this.pagoAntValue.saldok,
        intereses:this.pagoAntValue.intereses,
        cloud:this.pagoAntValue.cloud,
        seguro:this.pagoAntValue.seguro,
        fecha:this.pagoAntValue.fechapago,
        usuario:this.user.Usuario,
        diasinteres:this.pagoAntValue.diasinteres,
      };
      this.http.post(environment.urlApi + 'pagoant',body).subscribe((res:any)=>{
        console.log('res: ',res);
        if (this.loading) { this.loading.dismiss(); }
        this.apiOnReq = false;
        clearTimeout(this.temporizador);
        this.getRunCredits2();
        this.popoverController.dismiss();
      })

    }
    else{
      alert("Solicitud denegada!");
    }

  } */

  /* async aplicarPagoAnt(event,row){
    console.log('Liquidacion: ',row);
    this.solEdit = row;
    this.editEstadoValue = "PAGO-ANTICIPADO";
    this.pagoAntValue.saldok = row.Saldo;
    this.pagoAntValue.intereses = row.Interes;
    this.pagoAntValue.cloud = row.Cloud;
    this.pagoAntValue.seguro = row.Seguro;
    this.pagoAntValue.diasinteres = row.Dias;

    const popover = await this.popoverController.create({
      component: EditarsolPage,
      cssClass: 'popoverStyle2',
      event: event,
      translucent: true,
      componentProps: {},
      mode:'ios'
    });
    return await popover.present();
  } */

  async getPendDes() {
    console.log('Obteniendo pendientes de desembolso...');

    await this.presentLoading('Obteniendo pendientes de desembolso...');

    this.apiOnReq = true;
    const body = {};

    this.http.post(environment.urlApi + 'getpenddes', body).subscribe((res: any) => {
      console.log('PendDes:', res);
      this.PendDesReady = [];

      res.forEach((credito: any, index: number) => {
        credito.CarpDcontDis = credito.CarpDcont;

        const idEmpresaOriginal = credito.IdEmpresa;

        const empresa: any = this.empresas1.find(empresa => empresa.IdEmpresa == idEmpresaOriginal);

        if (empresa) {
          credito.IdEmpresa = empresa.Nombre?.trim() || '';
        } else {
          console.error('Empresa no encontrada:', {index, NumSol: credito.NumSol, IdEmpresa: idEmpresaOriginal})

          credito.IdEmpresa = idEmpresaOriginal;
        }

        credito.Type = credito.Tipo;

        if (credito.Type == 'D') {
          credito.Tipo = 'DINERO - ' + credito.TipoCredito;
          credito.DispEn = !!(credito.CarpPbank && credito.CarpDcont);
        } else {
          credito.Tipo = 'MARKET';
          credito.DispEn = !!(credito.CarpPbank && credito.DatosDesp && credito.CarpDcont && credito.Market);
        }

        credito.NombreCompleto = [
          credito.Apellido1,
          credito.Apellido2,
          credito.Nombre1,
          credito.Nombre2
        ]
        .filter(Boolean)
        .join(' ');

        if (credito.FrmVin > 0) {
          credito.linkFrmVin = 'https://denario.com.co/user.html?' + credito.Cedula;
        }
      });

      this.AllPendDes = [...res];
      this.FiltPendDes = [...res];

      this.dataSourcePendDes.data = [...this.FiltPendDes];

      this.AllPendDesFiltradas = res.filter(cre => {
        if (cre.Type == 'P') {
          return !!(cre.CarpPbank && cre.DatosDesp);
        }

        if (cre.Type == 'D') {
          return !!cre.CarpPbank;
        }

        return false;
      });

      this.FiltPendDesFiltradas = [...this.AllPendDesFiltradas];
      this.dataSourcePendDesFiltradas.data = [...this.FiltPendDesFiltradas];
      this.TotPendDesFiltradas = this.FiltPendDesFiltradas.reduce((total, item) => total + Number(item.MontoSol || 0), 0);
      
      this.updateFilter10();
      this.dataSourcePendDes.data = [...this.FiltPendDes];

      if (this.loading) {
        this.loading.dismiss();
      }

      this.apiOnReq = false;
      clearTimeout(this.temporizador);
    });
  }

  async getHisDes() {
    console.log('Obteniendo historial de desembolso...');

    await this.presentLoading('Obteniendo historial de desembolsos...');

    this.apiOnReq = true;
    const body = {};

    this.http.post(environment.urlApi + 'gethisdes', body).subscribe({
      next: (res: any) => {

        console.log('hisDes:', res);
        console.log('Cantidad:', res?.length);

        res.forEach((h: any) => {
          if (h.FrmVin > 0) {
            h.Formulario = 'https://denario.com.co/user.html?' + h.Cedula;
          }
        });

        this.AllHisDes = res;

        if (!this.busqueda11?.trim()) {
          this.FiltHisDes = res;
        } else {
          this.updateFilter11(this.busqueda11);
        }

        if (!this.busqueda11?.trim()) {
          this.dataSourceHisDes.data = res;
        }

        this.apiOnReq = false;

        if (this.loading) {
          this.loading.dismiss();
        }

        clearTimeout(this.temporizador);
      }, error: (error) => {
        console.error('Error obteniendo historial:', error);
        this.apiOnReq = false;

        if (this.loading) {
          this.loading.dismiss();
        }

        clearTimeout(this.temporizador);
      }
    });
  }

  tfconv(val) {
    if (val) {
      return 1;
    } else {
      return 0;
    }
  }

  async savePendDes(cre) {
    console.log(cre);
    console.log('Guardando información...');
    await this.presentLoading('Guardando información...');
    this.apiOnReq = true;
    let body = {
      numsol: cre.NumSol,
      iddispersion: cre.IdDispersion,
      codigoautorizacion: cre.CodigoAutorizacion,
      carppbank: this.tfconv(cre.CarpPbank),
      datosdesp: this.tfconv(cre.DatosDesp),
      carpetadcont: this.tfconv(cre.CarpDcont),
      market: 1,
      carpeta: cre.Carpeta,
      usr: this.user.Usuario.trim()
    };
    this.http.post(environment.urlApi + 'savedispcomp', body).subscribe((res: any) => {
      console.log('saved: ', res);
      if (this.loading) { this.loading.dismiss(); }
      this.apiOnReq = false;
      clearTimeout(this.temporizador);
      cre.Usr = this.user.Usuario.trim();
      cre.FechaUp = res.body.recordset[0].fecha;
    })
  }

  async linkCarpeta(numsol, carpeta) {
    const alert = await this.alertController.create({
      cssClass: 'my-custom-class',
      header: 'Link Carpeta Unica',
      inputs: [
        {
          name: 'link',
          type: 'text',
          placeholder: 'Link',
          value: carpeta
        },
      ],
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          cssClass: 'secondary',
          handler: () => {
            console.log('Confirm Cancel');
          }
        }, {
          text: 'Ok',
          handler: (alertData) => {
            console.log(alertData, '', numsol);
            let index = this.AllPendDes.findIndex(a => a.NumSol == numsol);
            this.AllPendDes[index].Carpeta = alertData.link;
          }
        }
      ]
    });

    await alert.present();
  }

  formCodBank(cod) {
    if (cod.length == 1) {
      return '00' + cod;
    } else if (cod.length == 2) {
      return '0' + cod;
    } else {
      return cod;
    }
  }

  formTipoCuenta(cta) {
    if (cta == "AHORROS") {
      return '02-Ahorros';
    } else if (cta == 'CORRIENTE') {
      return '01-Corriente';
    } else if (cta == 'ESPECIAL') {
      return '19-Especial';
    } else {
      return '02-Ahorros'
    }
  }

  formSexo(s) {
    if (s) {
      if (s.toLowerCase() == 'masculino') {
        return 'M';
      } else if (s.toLowerCase() == 'femenino') {
        return 'F';
      } else {
        return s;
      }
    } else {
      return '';
    }
  }

  async Dispersar() {
    console.log("PendDesReady: ", this.PendDesReady)
    let bodyDisp = [];
    let toBBVA = [];
    let credTrebol = [];
    let asoTrebol = [];
    this.PendDesReady.forEach(cred => {
      bodyDisp.push({
        Cedula: cred.Cedula,
        NumSol: cred.NumSol,
        MontoDes: cred.MontoSol,
        CuentaBancaria: cred.CuentaBancaria,
        TipoCuenta: cred.TipoCuenta,
        Banco: cred.Banco,
        BancoCodigo: cred.BancoCodigo,
        IdDispersion: cred.IdDispersion,
        FechaDispersion: '2000-01-01',
        CodigoAutorizacion: cred.CodigoAutorizacion,
        Cobre: cred.Cobre
      })
      if (!cred.Cobre) {
        toBBVA.push({
          OK: "OK",
          TipoId: '01- Cédula de ciudadanía',
          NumeroId: cred.Cedula.toString(),
          TipoCta: this.formTipoCuenta(cred.TipoCuenta),
          NumeroCta: cred.CuentaBancaria.toString(),
          Banco: this.formCodBank(cred.BancoCodigo) + '.' + cred.Banco,
          Nombre: this.titlecase.transform(cred.NombreCompleto),
          Direccion: cred.IdEmpresa,
          email: '',
          TipoPago: '1- Abono en Cuenta',
          OficinaPago: '',
          Importe: cred.MontoSol,
          Concepto1: 'DESEMBOLSO DENARIO',
          FechaLim: '',
          Concepto2: cred.NumSol
        })
      }
      credTrebol.push({
        Cedula: cred.Cedula,
        Monto: cred.MontoSol,
        Plazo: cred.Plazo,
        Periodo: 'M',
        Linea: '',
        Descuento: 'S',
        PrimDto: this.datePipe.transform(cred.PrimDto, "yyy.MM.dd", "+0000"),
        Cuota: cred.ValCuota + cred.Cloud + cred.Seguro,
        Tasa: '',
        Seguro: cred.Seguro,
        Cloud: cred.Cloud,
        Cero: 0,
        Blanco: '',
        NumSol: cred.NumSol,
        CodGrant: '01',
        ValGrant: '',
        CodDest: '01'
      })
      asoTrebol.push({
        Cedula: cred.Cedula,
        Apellido1: cred.Apellido1,
        Apellido2: cred.Apellido2,
        Nombre1: cred.Nombre1,
        Nombre2: cred.Nombre2,
        CodNom: cred.Cedula,
        TipoDoc: 'C',
        Sexo: this.formSexo(cred.Sexo),
        Salario: cred.Salario,
        EstCivil: 'U',
        CtaBank: '',
        TipoCuenta: '',
        CodBank: '',
        Bank: '',
        CodUb: '',
        DesArea: '',
        CodPag: '',
        NomPag: cred.IdEmpresa,
        Cliente: 'S',
        Direct: 'N',
        CiudadN: 11001,
        FechaCC: '1993.12.01',
        Direccion: 'CARRERA 7 # 45 - 48 APTO  301',
        CiudadL: 11001,
        TelefonoL: '3052303080',
        Prof: 'EMPLEADO',
        CondPep: 'N',
        DecOr: 'EMPLEADO',
        Eps: '901317239',
        Afp: '901317239',
        FondoC: '901317239',
        SalInt: 'N',
        OtrosIn: 1,
        Egresos: 1,
        Activos: 1,
        Pasivos: 1,
        Rh: '+',
        Gs: 'O',
        Scoring: '',
        TipViv: 'F',
        FormatoIn: 'T',
        ConcIn: 'A',
        PerA: '',
        FechaCon: '',
        RealizaOp: 'N',
        TipMon: '',
        TipoOp: '',
        TipProd: '',
        Nprod: '',
        Mont: '',
        Banco: '',
        CodP: '',
        Ciud: '',
        Aprendiz: 'N',
        Planta: 'N',
        Admin: 'A',
        FechaAf: '',
        NumSol: cred.NumSol
      })
    });
    let body = {
      Hoja1: bodyDisp
    }
    console.log('body: ', body);
    console.log('toBBVA: ', toBBVA);
    console.log('credTrebol: ', credTrebol);
    console.log('asoTrebol: ', asoTrebol);
    console.log('Dispersando...');

    await this.presentLoading('Dispersando...');
    this.apiOnReq = true;
    this.http.post(environment.urlApi + 'aplicardispersion', body).subscribe((res: any) => {
      console.log('Dispersado: ', res);
      if (this.loading) { this.loading.dismiss(); }
      this.apiOnReq = false;
      clearTimeout(this.temporizador);
      let toBBVAc = [];
      let credTrebolc = [];
      let asoTrebolc = [];
      res.body.forEach(disp => {
        let cred1 = toBBVA.findIndex(p => p.Concepto2 == disp.NumSol);
        if (cred1 >= 0) { toBBVAc.push(toBBVA[cred1]); }
        let cred2 = credTrebol.findIndex(p => p.NumSol == disp.NumSol);
        if (cred2 >= 0) { credTrebolc.push(credTrebol[cred2]); }
        let cred3 = asoTrebol.findIndex(p => p.NumSol == disp.NumSol);
        if (cred3 >= 0) { asoTrebolc.push(asoTrebol[cred3]); }
      });
      if (res.body.length > 0) {
        this.exportAsExcelFile(toBBVAc, 'BBVA');
        this.exportAsExcelFile(credTrebolc, 'credTrebol');
        this.exportAsExcelFile(asoTrebolc, 'asoTrebol');
      }
      if (res.disError.length > 0) {
        let sols = "";
        let ErroresDis = [];
        res.disError.forEach(dise => {
          sols = sols + '-' + dise.dispersion.NumSol
          ErroresDis.push({
            NumSol: dise.dispersion.NumSol,
            Cedula: dise.dispersion.Cedula,
            Banco: dise.dispersion.Banco,
            BancoCodigo: dise.dispersion.BancoCodigo,
            CodigoAutorizacion: dise.dispersion.CodigoAutorizacion,
            CuentaBancaria: dise.dispersion.CuentaBancaria,
            IdDispersion: dise.dispersion.IdDispersion,
            MontoDes: dise.dispersion.MontoDes,
            TipoCuenta: dise.dispersion.TipoCuenta,
            Error: dise.err.originalError.info.message
          })
        });
        this.presentAlert('Error', 'Se presentó problemas al dispersar las siguientes solicitudes (ver archivo ErroresDis.xlsx)', sols);
        this.exportAsExcelFile(ErroresDis, 'ErroresDis');
      }
      this.getPendDes();
    })
  }

  // async editEmpleado(ev: any, emp) {
  //   console.log('Empleado: ', emp);
  //   this.Empleado = emp;
  //   this.getLineasXemp();
  //   const popover = await this.popoverController.create({
  //     component: EditempPage,
  //     cssClass: 'popoverStyle2',
  //     /* event: ev, */
  //     translucent: true,
  //     componentProps: {},
  //     mode: 'ios'
  //   });
  //   return await popover.present();
  // }

  EmpleadorChan(event) {
    if (event) {
      console.log('EmpleadorChan: ', event);
      let index = this.empresas1.findIndex(e => e.IdEmpresa == event);
      this.Empleado.Empleador = this.empresas1[index].Nombre;
      this.Empleado.IdEmpresa = event;
      this.getLineasXemp();
    }
  }

  EmpleadorChanNew(event) {
    if (event) {
      console.log('EmpleadorChanNew: ', event);
      let index = this.empresas1.findIndex(e => e.IdEmpresa == event);
      this.EmpleadoNew.Empleador = this.empresas1[index].Nombre;
      this.EmpleadoNew.IdEmpresa = event;
      this.getLineasXempNew();
    }
  }

  BancoChan(event) {
    if (event) {
      console.log('BancoChan: ', event);
      let index = this.bancos.findIndex(e => e.Cod == event);
      this.Empleado.Banco = this.bancos[index].Banco;
      this.Empleado.BancoCodigo = event;
    }
  }

  BancoChanNew(event) {
    if (event) {
      console.log('BancoChanNew: ', event);
      let index = this.bancos.findIndex(e => e.Cod == event);
      this.EmpleadoNew.Banco = this.bancos[index].Banco;
      this.EmpleadoNew.BancoCodigo = event;
    }
  }

  Nombre1Chan(event) {
    console.log('Nombre1Chan: ', event);
    this.Empleado.Nombre = event;
  }

  Nombre1ChanNew(event) {
    console.log('Nombre1ChanNew: ', event);
    this.EmpleadoNew.Nombre = event;
  }

  async getLineas() {
    console.log('Obteniendo Lineas');
    /* await this.presentLoading('Obteniendo lineas...');
    this.apiOnReq = true; */
    let body = {};
    this.http.post(environment.urlApi + 'getconvenios', body).subscribe((res: any) => {
      this.Lineas = res
      console.log('lineas: ', this.Lineas);
      /* this.AllHisDes=res;
      this.FiltHisDes;
      this.loading.dismiss();
      this.apiOnReq = false;
      clearTimeout(this.temporizador);
      this.updateFilter11(this.busqueda11.trim()); */
    })
  }

  getCodBancos() {
    console.log('Obteniendo codigos bancos...');
    /* this.presentLoading('Obteniendo todas las solicitudes en proceso...');
    this.apiOnReq = true; */
    let body = {};
    this.http.post(environment.urlApi + 'getcodbanks', body).subscribe((res: any) => {
      this.bancos = res;
      console.log('Bancos: ', this.bancos);
      /* this.loading.dismiss();
      this.apiOnReq = false;
      clearTimeout(this.temporizador); */
    })
  }

  toNull(dato) {
    switch (dato) {
      case 0: return 0;
      case "": return null;
      case null: return null;
      default: return dato;
    }
  }

  async saveEmp() {
    if (this.toNull(this.Empleado.Cedula) != null && this.toNull(this.Empleado.Nombre) != null && this.toNull(this.Empleado.Salario) != null && this.toNull(this.Empleado.Contrato) != null && this.toNull(this.Empleado.IdEmpresa) != null && this.toNull(this.Empleado.TipoContrato) != null && this.toNull(this.Empleado.Descuentos) != null && this.toNull(this.Empleado.Periodo) != null && this.toNull(this.Empleado.IdConvenio) != null && this.toNull(this.Empleado.FechaIngreso) != null) {
      if (this.Empleado.TipoContrato.toLowerCase() != 'indefinido' && this.toNull(this.Empleado.FechaFinalCont) == null) {
        this.presentAlert('Error', 'Al crear empleado', 'Si el "Tipo Contrato" es diferente "INDEFINIDO" se requiere "Fecha Fin Contrato"');
      } else {
        console.log('Empleado to save: ', this.Empleado);
        console.log('Guardando datos de Empleado...');
        await this.presentLoading('Guardando datos de Empleado...');
        this.apiOnReq = true;
        let body = {
          empleado: this.Empleado
        };
        this.http.post(environment.urlApi + 'updateemp', body).subscribe((res: any) => {
          console.log('saveEmp: ', res);
          if (res.res == "error") {
            this.presentAlert('Error', 'Al editar empleado', res.body.originalError.info.message);
            /* alert(res.body.originalError.info.message) */
          } else {
            this.popoverController.dismiss();
            this.empleadosSearchFun();
            this.presentToast('Información guardada correctamente!');
          }
          if (this.loading) { this.loading.dismiss(); }
          this.apiOnReq = false;
          clearTimeout(this.temporizador);
        })
      }
    } else {
      this.presentAlert('Error', 'Al guardar empleado', 'Los campos que inician con * son obligatorios');
    }
  }

  async verNewEmp() {
    const popover = await this.popoverController.create({
      component: NewempPage,
      cssClass: 'popoverStyle2',
      /* event: ev, */
      translucent: true,
      componentProps: {},
      mode: 'ios'
    });
    return await popover.present();
  }

  async crearEmp() {
    console.log('crearEmp: ', this.EmpleadoNew);
    if (this.toNull(this.EmpleadoNew.Cedula) != null && this.toNull(this.EmpleadoNew.Nombre) != null && this.toNull(this.EmpleadoNew.Salario) != null && this.toNull(this.EmpleadoNew.Contrato) != null && this.toNull(this.EmpleadoNew.IdEmpresa) != null && this.toNull(this.EmpleadoNew.TipoContrato) != null && this.toNull(this.EmpleadoNew.Descuentos) != null && this.toNull(this.EmpleadoNew.Periodo) != null && this.toNull(this.EmpleadoNew.IdConvenio) != null && this.toNull(this.EmpleadoNew.FechaIngreso) != null) {
      if (this.EmpleadoNew.TipoContrato.toLowerCase() != 'indefinido' && this.toNull(this.EmpleadoNew.FechaFinalCont) == null) {
        this.presentAlert('Error', 'Al crear empleado', 'Si el "Tipo Contrato" es diferente "INDEFINIDO" se requiere "Fecha Fin Contrato"');
      } else {
        console.log('creando empleado');
        await this.presentLoading('creando empleado...');
        this.apiOnReq = true;
        let body = {
          empleado: this.EmpleadoNew
        };
        this.http.post(environment.urlApi + 'insertemp', body).subscribe((res: any) => {
          console.log('saveEmp: ', res);
          if (res.res == "error") {
            this.presentAlert('Error', 'Al crear empleado', res.body.originalError.info.message);
          } else {
            this.popoverController.dismiss();
            this.empleadosSearchFun();
            this.presentToast('Empleado creado correctamente!');
          }
          if (this.loading) { this.loading.dismiss(); }
          this.apiOnReq = false;
          clearTimeout(this.temporizador);
        })
      }
    } else {
      this.presentAlert('Error', 'Al crear empleado', 'Los campos que inician con * son obligatorios');
    }
  }

  /* async getLineas2(){
    console.log('Obteniendo Lineas...');
    await this.presentLoading('Obteniendo Lineas de crédito...');
    this.apiOnReq = true;
    let body={};
    this.http.post(environment.urlApi + 'getlineas',body).subscribe((res:any)=>{
      res.forEach(lin => {
        let empresa = this.empresas1.find(empresa => empresa.IdEmpresa==lin.IdEmpresa);
        lin.Empresa = empresa.Nombre.trim();
        if (lin.Liquidacion) {
          lin.LiquidacionObj = JSON.parse(lin.Liquidacion);
        } else {
          lin.LiquidacionObj = {
            Cesantias: undefined,
            Prima: undefined,
            Salario: undefined,
            Vacaciones: undefined
          };
        }
        if (lin.DenarioYA) {
          lin.EnDenarioYA = 'SI';
          lin.DenarioYA = 1;
        } else {
          lin.EnDenarioYA = 'NO';
          lin.DenarioYA = 0;
        }
      });
      this.allLineas = res;
      this.filtLineas = res;
      console.log('allLineas: ',this.allLineas)
      if (this.loading) { this.loading.dismiss(); }
      this.apiOnReq = false;
      clearTimeout(this.temporizador);
      this.updateFilter12(this.busqueda12.trim());
    })
  } */

  /* async editLinea(ev: any, linea) {
    console.log('Linea: ', linea);
    this.linea=linea;
    if(!this.linea.BNPL){this.linea.BNPL = 0;}else{this.linea.BNPL = 1;}
    const popover = await this.popoverController.create({
      component: EditlineaPage,
      cssClass: 'popoverStyle2',
      event: ev,
      translucent: true,
      componentProps: {},
      mode:'ios'
    });
    return await popover.present();
  } */

  /* async verAddLinea(ev: any) {
    console.log('LineaNew: ', this.lineaNew);
    const popover = await this.popoverController.create({
      component: NewlineaPage,
      cssClass: 'popoverStyle2',
      event: ev,
      translucent: true,
      componentProps: {},
      mode:'ios'
    });
    return await popover.present();
  } */

  /* EmpresaChan(event) {
    if(event){
      console.log('EmpresaChan: ',event);
      let index = this.empresas1.findIndex(e=>e.IdEmpresa==event);
      this.linea.Empresa=this.empresas1[index].Nombre;
      this.linea.IdEmpresa=event;
    }
  } */

  /* EmpresaChanNew(event) {
    if(event){
      console.log('EmpresaChanNew: ',event);
      let index = this.empresas1.findIndex(e=>e.IdEmpresa==event);
      this.lineaNew.Empresa=this.empresas1[index].Nombre;
      this.lineaNew.IdEmpresa=event;
    }
  } */


  /* async editLineaApi() {
    console.log('Linea to edit:', this.linea);
    if (this.toNull(this.linea.IdConvenio) != null && this.toNull(this.linea.Riesgo) != null && this.toNull(this.linea.Tasa) != null&& this.toNull(this.linea.PlazoMin) != null&& this.toNull(this.linea.PlazoMax) != null&& this.toNull(this.linea.Parafiscales) != null&& this.toNull(this.linea.CuentaVariable) != null ) {
        console.log('Guardando datos de linea...');
        await this.presentLoading('Guardando datos de linea de credito...');
        this.apiOnReq = true;
        let body={
          linea:this.linea
        };
        this.http.post(environment.urlApi + 'updatelinea',body).subscribe((res:any)=>{
          console.log('updatelinea: ',res);
          if (res.res == "error") {
            this.presentAlert('Error', 'Al editar linea', res.body.originalError.info.message);
          }else{
            this.popoverController.dismiss();
            this.getLineas2();
            this.presentToast('Información guardada correctamente!');
          }
          if (this.loading) { this.loading.dismiss(); }
          this.apiOnReq = false;
          clearTimeout(this.temporizador);
        })
    } else {
      this.presentAlert('Error', 'Al editar linea', 'Los campos que inician con * son obligatorios');
    }
  } */

  /* async crearLineaApi() {
    console.log('crearLineaApi: ', this.lineaNew);
    if (this.toNull(this.lineaNew.IdConvenio) != null && this.toNull(this.lineaNew.Riesgo) != null && this.toNull(this.lineaNew.Tasa) != null&& this.toNull(this.lineaNew.PlazoMin) != null&& this.toNull(this.lineaNew.PlazoMax) != null&& this.toNull(this.lineaNew.Parafiscales) != null&& this.toNull(this.lineaNew.CuentaVariable) != null ) {
        console.log('creando linea');
        await this.presentLoading('creando linea de credito...');
        this.apiOnReq = true;
        let body={
          linea:this.lineaNew
        };
        this.http.post(environment.urlApi + 'createlinea',body).subscribe((res:any)=>{
          console.log('createlinea: ',res);
          if (res.res == "error") {
            this.presentAlert('Error', 'Al crear linea de credito', res.body.originalError.info.message);
          }else{
            this.popoverController.dismiss();
            this.getLineas2();
            this.presentToast('Linea de credito creada correctamente!');
          }
          if (this.loading) { this.loading.dismiss(); }
          this.apiOnReq = false;
          clearTimeout(this.temporizador);
        })
    } else {
      this.presentAlert('Error', 'Al crear empleado', 'Los campos que inician con * son obligatorios');
    }
  } */

  /* async deleteLinea(linea) {
    console.log('linea: ',linea)
    const alert = await this.alertController.create({
      cssClass: 'my-custom-class',
      header: '¿Estás seguro?',
      mode:'ios',
      subHeader: 'Eliminarás '+ linea.IdConvenio,
      buttons: [
        {
          text: 'Cancelar',
          role: 'cancel',
          cssClass: 'secondary',
          handler: (blah) => {
            console.log('Confirm Cancel: blah');
          }
        }, {
          text: 'Confirmar',
          handler: () => {
            console.log('Confirm Okay');
            this.deleteLineaApi(linea);
          }
        }
      ]
    });

    await alert.present();
  } */

  /* async deleteLineaApi(linea) {
    console.log('deleteLineaApi: ', linea);
    console.log('Eliminando Linea...');
        await this.presentLoading('Eliminando linea de credito...');
        this.apiOnReq = true;
        let body={
          linea:linea
        };
        this.http.post(environment.urlApi + 'deletelinea',body).subscribe((res:any)=>{
          console.log('deletelinea: ',res);
          if (res.res == "error") {
            this.presentAlert('Error', 'Al eliminar linea', res.body.originalError.info.message);
          } else {
            this.getLineas2();
            this.presentToast('Linea eliminada correctamente!');
          }
          if (this.loading) { this.loading.dismiss(); }
          this.apiOnReq = false;
          clearTimeout(this.temporizador);
        })
  } */


  totalOtros2() {
    this.totalSaldoK = 0;
    this.totalMontoSol = 0;
    this.totalCuotasSol = 0;
    this.CapacidadCliente = 0;
    this.CapacidadClientePor = 0;
    this.CapacidadClienteDin = 0;
    this.otrosCreditos.forEach(credito => {
      this.totalSaldoK = this.totalSaldoK + credito.Saldok;
      this.totalMontoSol = this.totalMontoSol + credito.MontoSol;
      this.totalCuotasSol = this.totalCuotasSol + credito.TotCuota;
    });
    console.log('totalSaldoK: ', this.totalSaldoK);
    console.log('totalMontoSol: ', this.totalMontoSol);
    console.log('totalCuotasSol: ', this.totalCuotasSol);
    console.log('CapacidadCliente: ', this.CapacidadCliente);
    this.otrosCreditos.push({
      MontoSol: this.totalMontoSol,
      NumSol: 'TOTAL',
      OnCuota: '',
      Plazo: '',
      Saldok: this.totalSaldoK,
      TotCuota: this.totalCuotasSol
    })

  }

  getCapacidadYcupo() {
    this.CapacidadCliente = 0;
    this.CapacidadClientePor = 0;
    this.CapacidadClienteDin = 0;
    this.CapacidadCliente = this.empToEsp.TotCuotas / (this.empToEsp.Salario * 0.6);
    console.log('CapacidadCliente: ', this.CapacidadCliente);
    if (this.CapacidadCliente > 0.5) { this.CapacidadCliente = 0.5; }
    this.CapacidadClientePor = Math.round(100 - 2 * (this.CapacidadCliente * 100));
    this.CapacidadClienteDin = (this.empToEsp.Salario * 0.6 / 2) - this.empToEsp.TotCuotas;
    if (this.CapacidadClienteDin < 0) { this.CapacidadClienteDin = 0; }
    this.CupoDisPor = this.empToEsp.Cupo / this.empToEsp.CupoTot;
  }


  async searchCcEsp() {
    console.log('ccCreEsp: ', this.ccCreEsp);
    console.log('Buscando empleado...');
    await this.presentLoading('Buscando empleado...');
    this.apiOnReq = true;
    let body = {
      cedula: this.ccCreEsp
    };
    this.http.post(environment.urlApi + 'getemptoesp', body).subscribe((res: any) => {
      console.log('getEmpToEsp: ', res);
      if (res.detalle) {
        res.detalle.Empresa = this.empresas1.find(empresa => empresa.IdEmpresa == res.detalle.NitEmpresa).Nombre;
        this.empToEsp = res.detalle;
        this.getCapacidadYcupo();
      } else {
        if (this.loading) { this.loading.dismiss(); }
        this.apiOnReq = false;
        clearTimeout(this.temporizador);
        this.presentAlert('Información no encontrada', 'Cedula no encontrada', 'La persona que buscas no está en nuestra base de datos')
      }
      if (res.tablaotros.length > 0) {
        res.tablaotros.forEach(credito => {
          if (credito.IdEstado == 2 && credito.AprobadoRH == 0) { credito.IdEstado = '8' }
          credito.Estado = this.estados.find(estado => estado.IdEstado == credito.IdEstado).Descripcion
        });
        this.otrosCreditosAll = res.tablaotros;
        this.otrosCreditos = res.tablaotros;
        /* this.totalOtros2(); */
        this.filtEncCreditEstadosEsp(this.otrosCreditosAll);
      }
      console.log('empToEsp: ', this.empToEsp);
      console.log('otrosCreditos: ', this.otrosCreditos);
      if (this.loading) { this.loading.dismiss(); }
      this.apiOnReq = false;
      clearTimeout(this.temporizador);
    },
      (err) => {
        if (this.loading) { this.loading.dismiss(); }
        this.apiOnReq = false;
        clearTimeout(this.temporizador);
        alert('Error: ' + err.error)
      })
  }


  filtEncCreditEstadosEsp(filtEncCredits) {
    let tempFilt = [];
    this.estadosSelectEspValue.forEach(estado => {
      const found = filtEncCredits.filter(est => est.Estado.toLowerCase() == estado.toLowerCase());
      tempFilt = tempFilt.concat(found);
    });
    tempFilt.sort((a, b) => b.NumSol - a.NumSol);
    this.otrosCreditos = tempFilt;
    this.totalSaldoK = 0;
    this.totalMontoSol = 0;
    this.totalCuotasSol = 0;
    this.otrosCreditos.forEach(credito => {
      this.totalSaldoK = this.totalSaldoK + credito.Saldok;
      this.totalMontoSol = this.totalMontoSol + credito.MontoSol;
      this.totalCuotasSol = this.totalCuotasSol + credito.TotCuota;
    });
    console.log('totalSaldoK: ', this.totalSaldoK);
    console.log('totalMontoSol: ', this.totalMontoSol);
    console.log('totalCuotasSol: ', this.totalCuotasSol);
    console.log('CapacidadCliente: ', this.CapacidadCliente);
    this.otrosCreditos.push({
      MontoSol: this.totalMontoSol,
      NumSol: 'TOTAL',
      OnCuota: '',
      Plazo: '',
      Saldok: this.totalSaldoK,
      TotCuota: this.totalCuotasSol
    })
  }

  estadosSelectEsp(event) {
    this.estadosSelectEspValue = event.detail.value;
    console.log('Estados select: ', this.estadosSelectEspValue);
    this.filtEncCreditEstadosEsp(this.otrosCreditosAll);
  }

  async CrearCredEsp() {
    console.log('ccCreEsp: ', this.ccCreEsp);
    console.log('empToEsp: ', this.empToEsp);
    console.log('prodEsp: ', this.prodEsp);
    console.log('pubSelected: ', this.pubSelected);
    console.log('montoEsp: ', this.montoEsp);
    console.log('plazoEsp: ', this.plazoEsp);
    console.log('obsEsp: ', this.obsEsp);
    console.log('cod1Esp: ', this.cod1Esp);
    console.log('cod2Esp: ', this.cod2Esp);
    console.log('cod3Esp: ', this.cod3Esp);
    if (this.prodEsp == "MARKET" && this.pubSelected.Id == 0) { this.presentAlert('Datos incompletos', 'Selecciona Producto market', 'Si el tipo de crédito es MARKET debes seleccionar un producto de la tienda') }
    else if (!this.prodEsp) { this.presentAlert('Datos incompletos', 'Selecciona tipo de crédito', 'Debes seleccionar el tipo de crédito para procesar tu solicitud') }
    else if (!this.montoEsp) { this.presentAlert('Datos incompletos', 'Selecciona monto del crédito', 'Debes seleccionar el monto del crédito para procesar tu solicitud') }
    else if (!this.plazoEsp) { this.presentAlert('Datos incompletos', 'Selecciona plazo del crédito', 'Debes seleccionar el plazo del crédito para procesar tu solicitud') }
    else if (this.cod3Esp == "" && this.montoEsp > 20000000) { this.presentAlert('Datos incompletos', 'Ingresa clave', 'Debes ingresar las claves para procesar tu solicitud') }
    else if (this.cod1Esp == "" || this.cod2Esp == "") { this.presentAlert('Datos incompletos', 'Ingresa clave', 'Debes ingresar las claves para procesar tu solicitud') }
    else {
      await this.presentLoading('Creando solicitud especial...');
      this.apiOnReq = true;
      let body = {
        data: {
          Cedula: this.ccCreEsp,
          Monto: this.montoEsp,
          Plazo: this.plazoEsp,
          prodEsp: this.prodEsp,
          IdProducto: this.pubSelected.Id,
          Obs: this.obsEsp,
          Cod1: this.cod1Esp,
          Cod2: this.cod2Esp,
          Cod3: this.cod3Esp
        }
      };
      this.http.post(environment.urlApi + 'putcreditoesp', body).subscribe((res: any) => {
        console.log('putcreditoesp: ', res);
        if (res.body.RESULT == "1") {
          this.NumSolEsp = res.body.NumSol;
          this.ccCreEsp = null;
          this.empToEsp = null;
          this.prodEsp = null;
          this.pubSelected = {
            CodUniversal: null,
            Id: 0,
            IdCategoria: null,
            Stock: null,
            Titulo: null,
            UrlFotos: null,
            Usr: null,
            ValorUnt: null
          };;
          this.montoEsp = null;
          this.plazoEsp = null;
          this.obsEsp = null;
          this.cod1Esp = "";
          this.cod2Esp = "";
          this.cod3Esp = "";
          this.presentToast('Solicitud ' + this.NumSolEsp + ' creada correctamente');
        } else {
          this.presentAlert('Error', 'Al Crear solicitud especial', res.body.RESULT);
        }
        if (this.loading) { this.loading.dismiss(); }
        this.apiOnReq = false;
        clearTimeout(this.temporizador);
      }, (err) => {
        if (this.loading) { this.loading.dismiss(); }
        this.apiOnReq = false;
        clearTimeout(this.temporizador);
        alert('Error: ' + err.error.body.originalError.info.message);
      })
    }
  }

  prodSelectEsp() {
    console.log('prodEsp: ', this.prodEsp);
    this.plazoEsp = null;
    this.montoEsp = null;
  }

  async presentPopbuscarPublicEsp() {
    const popover = await this.popoverController.create({
      component: PublictoespPage,
      cssClass: 'popoverStyle3',
      /* event: ev, */
      translucent: true,
      componentProps: {},
      mode: 'ios',
      animated: true,
      showBackdrop: true,
    });
    await popover.present();
    if (this.loading) { this.loading.dismiss(); }
    this.apiOnReq = false;
    clearTimeout(this.temporizador);
  }

  irPublicToEsp() {
    this.router.navigate(['/publictoesp']);
  }

  async getPublicToEsp() {
    console.log('Obteniendo publicaciones market...');
    await this.presentLoading('Obteniendo publicaciones market...');
    this.apiOnReq = true;
    let body = {
    };
    this.http.post(environment.urlApi + 'getpublicforesp', body).subscribe((res: any) => {
      console.log('getpublicforesp: ', res);
      res.body.public.forEach(pub => {
        pub.UrlFotos = pub.UrlFotos.split('Merka_SSTEC');
      });
      this.publicToEsp = res.body.public;
      this.publicToEspFilt = res.body.public;
      this.catPublic = res.body.cat;
      /* this.catSelectValue = [];
      this.catPublic.forEach(cat => {
        this.catSelectValue.push(cat.IdCategoria.toString());
      }); */
      this.updateFiltePublicEsp();
      if (this.loading) { this.loading.dismiss(); }
      this.apiOnReq = false;
      clearTimeout(this.temporizador);
    })
  }

  updateFiltePublicEsp() {
    const val = this.busqueda13.toLowerCase().trim();
    console.log('val: ', val);
    this.publicToEspFilt = this.publicToEsp.filter((d) => {
      return (
        d.CodUniversal.toLowerCase().indexOf(val) !== -1
        || d.Titulo.toLowerCase().indexOf(val) !== -1
        || d.ValorUnt.toString().indexOf(val) !== -1
        || d.Usr.toLowerCase().indexOf(val) !== -1
        || !val);
    });
    this.filCat();
  }

  filCat() {
    let tempFilt = [];
    console.log('catSelectValue: ', this.catSelectValue);
    this.catSelectValue.forEach(estado => {
      const found = this.publicToEspFilt.filter(est => est.IdCategoria == estado);
      tempFilt = tempFilt.concat(found);
    });
    tempFilt.sort((a, b) => a.ValorUnt - b.ValorUnt);
    this.publicToEspFilt = tempFilt;
  }

  publicSelected(pub) {
    console.log('pub: ', pub);
    this.pubSelected = pub;
  }

  aceptPublicEsp() {
    this.montoEsp = this.pubSelected.ValorUnt * this.porPublic / 100;
    this.router.navigate(['/credespeciales']);
  }

  cancelPublicEsp() {
    this.pubSelected = {
      CodUniversal: null,
      Id: 0,
      IdCategoria: null,
      Stock: null,
      Titulo: null,
      UrlFotos: null,
      Usr: null,
      ValorUnt: null
    };
    this.router.navigate(['/credespeciales']);
  }

  porPublicF() {
    this.montoEsp = this.pubSelected.ValorUnt * this.porPublic / 100;
  }


  async getAllCredEsp() {
    console.log('Obteniendo historial de creditos especiales......');
    await this.presentLoading('Obteniendo historial de creditos especiales...');
    this.apiOnReq = true;
    let body = {};
    this.http.post(environment.urlApi + 'getallcredesp', body).subscribe((res: any) => {
      if (!this.verRol('verPens')) { res.creditos = this.filtPensionados(res.creditos) };
      res.creditos.forEach(credito => {
        let empresa = this.empresas1.find(empresa => empresa.IdEmpresa == credito.IdEmpresa);
        credito.IdEmpresa = empresa.Nombre.trim();
        if (credito.IdEstado == 2 && credito.AprobadoRH == 0) { credito.IdEstado = '8' }
        let estado = this.estados.find(estado => estado.IdEstado == credito.IdEstado)
        credito.IdEstado = estado.Descripcion
      });
      this.allCredEsp = res.creditos;
      this.filtCredEsp = res.creditos;
      console.log('allCredEsp: ', this.allCredEsp);
      if (this.loading) { this.loading.dismiss(); }
      this.apiOnReq = false;
      clearTimeout(this.temporizador);
      this.updateFilterEsp(this.busqueda14);
    })
  }

  estadosEspSelectChan() {
    console.log('Estados select: ', this.estadosSelectHisEspValue);
    this.updateFilterEsp(this.busqueda14);
  }


  updateFilterEsp(event) {
    const val = event.toLowerCase().trim();
    // filter our data
    this.filtCredEsp = this.allCredEsp.filter((d) => {
      return (
        d.Cedula.toLowerCase().indexOf(val) !== -1
        || d.NombreCompleto.toLowerCase().indexOf(val) !== -1
        || d.NumSol.toString().indexOf(val) !== -1
        || d.IdEmpresa.toLowerCase().indexOf(val) !== -1
        || d.IdEstado.toLowerCase().indexOf(val) !== -1
        || d.TipoCredito.toLowerCase().indexOf(val) !== -1
        || !val);
    });
    this.filtCredEspFun(this.filtCredEsp);
  }


  filtCredEspFun(filtCredEsp) {
    let tempFilt = [];
    this.estadosSelectHisEspValue.forEach(estado => {
      const found = filtCredEsp.filter(est => est.IdEstado.toLowerCase() == estado.toLowerCase());
      tempFilt = tempFilt.concat(found);
    });
    tempFilt.sort((a, b) => b.NumSol - a.NumSol);
    this.filtCredEsp = tempFilt;
    this.totMontoSol = 0;
    this.totSolAprobado = 0;
    this.totSolPendienteRh = 0;
    this.totSolPendientesDes = 0;
    this.totSolDesembolsado = 0;
    this.filtCredEsp.forEach(row => {
      this.totMontoSol = this.totMontoSol + row.MontoSol
      if (row.IdEstado == "APROBADO") { this.totSolAprobado = this.totSolAprobado + 1; }
      if (row.IdEstado == "PENDIENTE-RH") { this.totSolPendienteRh = this.totSolPendienteRh + 1; }
      if (row.IdEstado == "PENDIENTE-DESEMBOLSO") { this.totSolPendientesDes = this.totSolPendientesDes + 1; }
      if (row.IdEstado == "DESEMBOLSADO") { this.totSolDesembolsado = this.totSolDesembolsado + 1; }
    });
    console.log('filtCredEsp: ', this.filtCredEsp);
    console.log('totMontoSol: ', this.totMontoSol);
    console.log('totSolAprobado: ', this.totSolAprobado);
    console.log('totSolPendienteRh: ', this.totSolPendienteRh);
    console.log('totSolPendientesDes: ', this.totSolPendientesDes);
    console.log('totSolDesembolsado: ', this.totSolDesembolsado);
  }

  updateFilterPse(event) {
    const val = this.sinTildes(event);
    // filter our data
    this.filtOpPse = this.allOpPse.filter((d) => {
      if (d.Nombre == null) { d.Nombre = ""; }
      return (
        this.sinTildes(d.Cedula).indexOf(val) !== -1
        || this.sinTildes(d.NumSol).indexOf(val) !== -1
        || this.sinTildes(d.Nombre).indexOf(val) !== -1
        || this.sinTildes(d.OrdId).indexOf(val) !== -1
        || this.sinTildes(d.IdPedido).indexOf(val) !== -1
        || this.sinTildes(d.IdPago).indexOf(val) !== -1
        || !val
      );
    });
    this.filtOpPse.sort((a, b) => b.NumSol - a.NumSol);
  }

  updateFilterGmovil(event) {
    const val = event.toLowerCase().trim();
    // filter our data
    this.filtOpGmovil = this.allOpGmovil.filter((d) => {
      if (d.Nombre == null) { d.Nombre = ""; }
      return (
        d.Documento.toLowerCase().indexOf(val) !== -1
        || d.NumSol.toString().indexOf(val) !== -1
        || d.Nombres.toLowerCase().indexOf(val) !== -1
        || (d.EstadoDesp || "").toLowerCase().indexOf(val) !== -1
        || (d.Producto || "").toLowerCase().indexOf(val) !== -1
        || d.Apellidos.toLowerCase().indexOf(val) !== -1
        || d.IdPedido.toString().indexOf(val) !== -1
        || !val);
    });
    this.filtOpGmovil.sort((a, b) => b.NumSol - a.NumSol);
  }

  async getOpPse() {
    console.log('Obteniendo todas las operaciones PSE...');
    await this.presentLoading('Obteniendo todas las operaciones PSE...');
    this.apiOnReq = true;
    let body = {};
    this.http.post(environment.urlApi + 'getoppse', body).subscribe((res: any) => {
      console.log('getOpPse: ', res);
      this.allOpPse = res;
      this.filtOpPse = res;
      if (this.loading) { this.loading.dismiss(); }
      this.apiOnReq = false;
      clearTimeout(this.temporizador);
      this.updateFilterPse(this.busqueda15);
    })
  }

  async getOpGmovil() {
    console.log('Obteniendo todas las operaciones Gmovil...');
    await this.presentLoading('Obteniendo todas las operaciones Gmovil...');
    this.apiOnReq = true;
    this.http.get(environment.urlApi + 'coorp/opgmovil', this.HTTPoptions).subscribe((res: any) => {
      console.log('getOpGmovil: ', res);
      res.forEach(op => {
        if (!op.EstadoDesp) { op.EstadoDesp = 'Error'; }
      });
      this.allOpGmovil = res;
      this.filtOpGmovil = res;
      if (this.loading) { this.loading.dismiss(); }
      this.apiOnReq = false;
      clearTimeout(this.temporizador);
      this.updateFilterGmovil(this.busqueda19);
    })
  }

  estadosGmovil = [];
  getEstadosGmovil() {
    console.log("obteniendo estados Gmovil...");
    this.http.get(environment.urlApi + 'coorp/estadosGmovil', this.HTTPoptions).subscribe(
      (res: any) => {
        this.estadosGmovil = res;
        console.log("Estados Gmovil: ", this.estadosGmovil);
      }
      , (err: any) => {
        this.presentAlert("Error", "Al consultar estados Gmovil", JSON.stringify(err));
      }
    )
  }


  InputCedulasChang(event) {
    let cedulas = event.detail.value;
    console.log('cedulas: ', cedulas)
    let cedulasArr = cedulas.split(',')
    console.log('Cedulas split: ', cedulasArr)
    this.cedulasExist = [];
    this.cedulasString = "";
    cedulasArr.forEach(cedula => {
      if (cedula.trim() != "") {
        this.cedulasString = this.cedulasString + cedula.trim() + ", ";
        this.cedulasExist.push({ cedula: cedula.trim() });
      }
    });
    if (this.cedulasExist.length > 0) { this.generarShow = true; }
    console.log('cedulasExist: ', this.cedulasExist)
  }

  updateFileClick() {
    this.uploadFileValue = '';
  }

  onFileChange(ev) {
    console.log('uploadFileValue: ', this.uploadFileValue)
    console.log('Event: ', ev);
    let workBook = null;
    let jsonData = null;
    const reader = new FileReader();
    const file = ev.target.files[0];
    reader.onload = (event) => {
      const data = reader.result;
      workBook = XLSX.read(data, { type: 'binary' });
      jsonData = workBook.SheetNames.reduce((initial, name) => {
        const sheet = workBook.Sheets[name];
        initial[name] = XLSX.utils.sheet_to_json(sheet);
        return initial;
      }, {});
      console.log('DataJson: ', jsonData);
      if (jsonData.Hoja1) {
        console.log('bien');
        this.cedulasExist = jsonData.Hoja1;
        this.cedulasString = "";
        if (this.cedulasExist.length > 0) { this.generarShow = true; }
        this.cedulasExist.forEach(cedula => {
          this.cedulasString = this.cedulasString + cedula.cedula + ", ";
        });
      } else {
        console.log('Por favor cambia el nobre de la hoja de excel a Hoja1');
        alert('Por favor cambia el nobre de la hoja de excel a Hoja1');
      }
    }
    reader.readAsBinaryString(file);
  }

  async getUsersForLiq2() {
    await this.presentLoading('Preparando todo, por favor espera...');
    this.apiOnReq = true;
    await this.getClientesForConv();
    console.log('Obteniendo usuarios para liquidar2...');
    this.generarShow = false;
    this.usersForLiq = [];
    this.cedulasNotFound = [];
    this.cedulasNotFoundString = "";
    this.cedulasExist.forEach(cedula => {
      let usuario = this.ClientesConv.filter(cliente => cliente.Cedula.trim() == cedula.cedula.toString().trim())
      if (usuario.length > 0) {
        usuario.forEach(usr => {
          this.usersForLiq.push(usr)
        });
      } else {
        this.cedulasNotFound.push(cedula.cedula);
        this.cedulasNotFoundString = this.cedulasNotFoundString + cedula.cedula + ", ";
      }
    });
    console.log('usersForLiq: ', this.usersForLiq);
    if (this.loading) { this.loading.dismiss(); }
    this.apiOnReq = false;
    clearTimeout(this.temporizador);
    if (this.usersForLiq.length > 0) {
      this.getLiqOnly();
    }
  }

  async getUsersForLiqCalculadora() {
    await this.presentLoading('Preparando todo, por favor espera...');
    this.apiOnReq = true;
    await this.getClientesForConv();
    console.log('Obteniendo usuarios para liquidar2...');
    this.generarShow = false;
    this.usersForLiq = [];
    this.cedulasNotFound = [];
    this.cedulasNotFoundString = "";
    this.cedulasExist.forEach(cedula => {
      let usuario = this.ClientesConv.filter(cliente => cliente.Cedula.trim() == cedula.cedula.toString().trim())
      if (usuario.length > 0) {
        usuario.forEach(usr => {
          this.usersForLiq.push(usr)
        });
      } else {
        this.cedulasNotFound.push(cedula.cedula);
        this.cedulasNotFoundString = this.cedulasNotFoundString + cedula.cedula + ", ";
      }
    });
    console.log('usersForLiq: ', this.usersForLiq);
    if (this.loading) { this.loading.dismiss(); }
    this.apiOnReq = false;
    clearTimeout(this.temporizador);
    if (this.usersForLiq.length > 0) {
      await this.getLiqCalculadora();
    }
  }

  getClientesForConv() {
    return new Promise((resolve, reject) => {
      console.log('Obteniendo usuarios del convenio...');
      let body = {
        idempresa: 1,
        rol: 10
      };
      this.http.post(environment.urlApi + 'getclientesforconv', body).subscribe((res: any) => {
        this.ClientesConv = res.creditos;
        console.log('Clientes por Convenio: ', this.ClientesConv);
        resolve("ok");
      })
    })
  }

  async getLiqOnly() {
    console.log('Obteniendo Liquidaciones...');
    this.Liq = [];
    this.filtLiq = [];
    this.presentToast('Obteniendo Liquidaciones, por favor espera...Tiempo aproximado (' + this.usersForLiq.length + ' seg.)');
    this.descargaShow = true;
    this.count = 0;
    for (let user of this.usersForLiq) {
      user.Usuario = this.user.Usuario.trim();
      user.Cedula = user.Cedula.trim();
      user.Fecha = this.FechaGenLiq;
      let body = {
        user: user
      };
      let envio = new Promise((resolve, reject) => {
        this.http.post(environment.urlApi + 'getliquidmasivasonly', body).subscribe((res: any) => {
          console.log('res: ', res);
          this.Liq.push(res);
          this.filtLiq.push(res);
          this.updateFilterLiq(this.busqueda16);
          resolve('ok');
        })
      })
      await envio;
      this.count = this.count + 1;
      this.descarga = this.count / this.usersForLiq.length;
    }
    this.descargaShow = false;
  }

  async getLiqCalculadora() {
    console.log('Obteniendo Liquidaciones...');
    this.Liq = [];
    this.filtLiq = [];
    this.presentToast('Obteniendo Liquidaciones, por favor espera...Tiempo aproximado (' + this.usersForLiq.length + ' seg.)');
    this.descargaShow = true;
    this.count = 0;
    for (let user of this.usersForLiq) {
      user.Usuario = this.user.Usuario.trim();
      user.Cedula = user.Cedula.trim();
      user.Fecha = this.FechaGenLiq;
      let body = {
        user: user
      };
      let envio = new Promise((resolve, reject) => {
        this.http.post(environment.urlApi + 'getliquidcalculadora', body, this.HTTPoptions).subscribe((res: any) => {
          console.log('res: ', res);
          this.Liq.push(res);
          this.filtLiq.push(res);
          this.updateFilterLiq(this.busqueda16);
          resolve('ok');
        })
      })
      await envio;
      this.count = this.count + 1;
      this.descarga = this.count / this.usersForLiq.length;
    }
    this.descargaShow = false;
    console.log(this.Liq);
    console.log(this.filtLiq);
  }

  updateFilterHtml(event) {
    this.updateFilterLiq(event.detail.value);
  }

  updateFilterLiq(event) {
    const val = event.toLowerCase().trim();
    // filter our data
    this.filtLiq = this.Liq.filter((d) => {
      return (d.Cedula.toLowerCase().indexOf(val) !== -1 || d.NombreCompleto.toLowerCase().indexOf(val) !== -1 || d.NumSol.toString().indexOf(val) !== -1 || d.IdEmpresa.toString().indexOf(val) !== -1 || !val);
    });
  }

  async searchCiudades(val, newEmp) {
    this.ciudadValue = val;
    this.isNewEmp = newEmp;
    this.updateFilterCiudad(this.busquedaCiu);
    const popover = await this.popoverController.create({
      component: SearchciudadesPage,
      cssClass: 'popoverStyle4',
      /* event: ev, */
      translucent: true,
      componentProps: {},
      mode: 'ios'
    });
    return await popover.present();
  }

  ciudadSelect(ciudad) {
    console.log('ciudad: ', ciudad);
    this.ciudadValue = ciudad.nombre;
  }

  updateFilterCiudad(value) {
    let ciu = value.toLowerCase().trim();
    this.ciudadesFromTrebolFilt = this.ciudadesFromTrebol.filter(c => c.nombre.toLowerCase().trim().indexOf(ciu) !== -1);
  }

  ciudadAcept() {
    if (this.isNewEmp) {
      this.EmpleadoNew.Ciudad = this.ciudadValue;
    } else {
      this.Empleado.Ciudad = this.ciudadValue;
    }
    this.popoverController.dismiss();
  }

  async getAnalizador() {
    this.presentLoading('Descargando Analizador...');
    this.apiOnReq = true;
    let body = {};
    this.http.get(environment.urlApi + 'getanalizador', body).subscribe((res: any) => {
      if (this.loading) { this.loading.dismiss(); }
      this.apiOnReq = false;
      clearTimeout(this.temporizador);
      res.forEach(r => {
        r.FechaDes = r.FechaDes;
      });
      console.log('res: ', res);
      this.exportAsExcelFile(res, 'Analizador');
    },
      (err: any) => {
        if (this.loading) { this.loading.dismiss(); }
        this.apiOnReq = false;
        clearTimeout(this.temporizador);
        this.presentAlert('Error', 'Al obtener informe Analizador', JSON.stringify(err));
      })
  }

  async getUltCuota() {
    this.presentLoading('Descargando informe de ultima cuota...');
    this.apiOnReq = true;
    let body = {};
    this.http.get(environment.urlApi + 'coorp/getUltCuota', body).subscribe((res: any) => {
      if (this.loading) { this.loading.dismiss(); }
      this.apiOnReq = false;
      clearTimeout(this.temporizador);
      console.log('res: ', res);
      this.exportAsExcelFile(res, 'ultCuota');
    },
      (err: any) => {
        if (this.loading) { this.loading.dismiss(); }
        this.apiOnReq = false;
        clearTimeout(this.temporizador);
        this.presentAlert('Error', 'Al obtener informe ultCuota', JSON.stringify(err));
      })
  }

  async getInfoDesembolsos() {
    console.log('FechaDesde: ', this.FechaDesde);
    console.log('FechaHasta: ', this.FechaHasta);
    this.presentLoading('Descargando informe de Desembolsos...');
    this.apiOnReq = true;
    let body = {
      fechadesde: this.FechaDesde,
      fechahasta: this.FechaHasta
    };
    this.http.post(environment.urlApi + 'getinfodesembolsos', body).subscribe((res: any) => {
      if (this.loading) { this.loading.dismiss(); }
      this.apiOnReq = false;
      clearTimeout(this.temporizador);
      let total = 0;
      res.forEach(r => {
        total = total + r.MontoDes;
      });
      res.push({
        Cedula: "*** TOTAL ***",
        MontoDes: total
      })
      console.log('res: ', res);
      this.exportAsExcelFile(res, 'Info-Desembolsos');
    },
      (err: any) => {
        if (this.loading) { this.loading.dismiss(); }
        this.apiOnReq = false;
        clearTimeout(this.temporizador);
        this.presentAlert('Error', 'Al obtener informe de Desembolsos', JSON.stringify(err));
      })
  }

  async getInfoSaldos() {
    console.log('FechaDesde: ', this.FechaDesde);
    console.log('FechaHasta: ', this.FechaHasta);
    this.presentLoading('Descargando informe de Saldos...');
    this.apiOnReq = true;
    let body = {
      fechadesde: this.FechaDesde,
      fechahasta: this.FechaHasta
    };
    this.http.post(environment.urlApi + 'getinfosaldos', body).subscribe((res: any) => {
      if (this.loading) { this.loading.dismiss(); }
      this.apiOnReq = false;
      clearTimeout(this.temporizador);
      /* res.forEach(r => {
        r.TotalSaldo = r.SaldoK + r.SaldoCloud + r.SaldoSeguro + r.saldoInteres;
      }); */
      console.log('res: ', res);
      this.exportAsExcelFile(res, 'Info-Saldos');
    },
      (err: any) => {
        if (this.loading) { this.loading.dismiss(); }
        this.apiOnReq = false;
        clearTimeout(this.temporizador);
        this.presentAlert('Error', 'Al obtener informe de Saldos', JSON.stringify(err));
      }
    )
  }

  async getCartera() {
    this.presentLoading('Descargando Cartera...');
    this.apiOnReq = true;
    let body = {};
    this.http.post(environment.urlApi + 'getcartera', body).subscribe((res: any) => {
      if (this.loading) { this.loading.dismiss(); }
      this.apiOnReq = false;
      clearTimeout(this.temporizador);
      /* res.forEach((r:any) => {
        if (r.FechaDes) { r.FechaDes = new Date(this.datePipe.transform(r.FechaDes, "yyy-MM-dd", "+0000") + "T12:00:00"); }
        if (r.UltimaFechaPago) { r.UltimaFechaPago = new Date(this.datePipe.transform(r.UltimaFechaPago, "yyy-MM-dd", "+0000") + "T12:00:00"); }
        if (r.FechaProxCuota) { r.FechaProxCuota = new Date(r.FechaProxCuota); r.FechaProxCuota.setHours(r.FechaProxCuota.getHours() + 5);}
      }); */
      console.log('res: ', res);
      this.exportAsExcelFile(res, 'Cartera');
    },
      (err: any) => {
        if (this.loading) { this.loading.dismiss(); }
        this.apiOnReq = false;
        clearTimeout(this.temporizador);
        this.presentAlert('Error', 'Al obtener informe de Cartera (No Labora)', JSON.stringify(err));
      })
  }

  async presentAlertLiquidacion(user) {
    console.log('user: ', user);
    const alert = await this.alertController.create({
      cssClass: 'my-custom-class',
      header: 'Obtener liquidación',
      message: 'Ingresa la fecha estimada de pago',
      inputs: [
        {
          name: 'fecha',
          type: 'date',
          /* value: this.fechaHoy.toString(), */
          value: this.datePipe.transform(this.fechaHoy, "yyy-MM-dd", "+0000"),
          min: this.datePipe.transform(this.fechaHoy, "yyy-MM-dd", "+0000")
        }
      ],
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          cssClass: 'secondary',
          handler: () => {
            console.log('Confirm Cancel');
          }
        }, {
          text: 'Ok',
          handler: (res) => {
            console.log('Confirm Ok', res);
            this.cedulasExist = [];
            this.cedulasExist.push({
              Cedula: user.Cedula,
              NumSol: user.NumSol
            });
            this.FechaGenLiq = res.fecha;
            this.getUsersForLiq3(user);
          }
        }
      ]
    });

    await alert.present();
  }

  async getUsersForLiq3(user) {
    await this.presentLoading('Preparando todo, por favor espera...');
    this.apiOnReq = true;
    await this.getClientesForConv();
    console.log('Obteniendo usuarios para liquidar2...');
    this.generarShow = false;
    this.usersForLiq = [];
    this.cedulasNotFound = [];
    this.cedulasNotFoundString = "";
    this.cedulasExist.forEach(cedula => {
      let usuario = this.ClientesConv.filter(cliente => cliente.Cedula.trim() == cedula.Cedula.toString().trim() && cliente.NumSol == cedula.NumSol);
      if (usuario.length > 0) {
        usuario.forEach(usr => {
          this.usersForLiq.push(usr)
        });
      } else {
        this.cedulasNotFound.push(cedula.cedula);
        this.cedulasNotFoundString = this.cedulasNotFoundString + cedula.cedula + ", ";
      }
    });
    console.log('usersForLiq: ', this.usersForLiq);
    if (this.loading) { this.loading.dismiss(); }
    this.apiOnReq = false;
    clearTimeout(this.temporizador);
    if (this.usersForLiq.length > 0) {
      this.getLiqOnly2(user);
    }
  }

  async getLiqOnly2(user) {
    console.log('Obteniendo Liquidaciones...');
    this.Liq = [];
    this.filtLiq = [];
    /* this.presentToast('Obteniendo Liquidaciones, por favor espera...Tiempo aproximado ('+this.usersForLiq.length+' seg.)'); */
    this.descargaShow = true;
    this.count = 0;
    for (let user of this.usersForLiq) {
      user.Usuario = this.user.Usuario.trim();
      user.Cedula = user.Cedula.trim();
      user.Fecha = this.FechaGenLiq;
      let body = {
        user: user
      };
      let envio = new Promise((resolve, reject) => {
        this.http.post(environment.urlApi + 'getliquidmasivasonly', body).subscribe((res: any) => {
          console.log('res: ', res);
          this.Liq.push(res);
          this.filtLiq.push(res);
          resolve('ok');
        })
      })
      await envio;
      this.count = this.count + 1;
      this.descarga = this.count / this.usersForLiq.length;
    }
    console.log('Liq: ', this.Liq);
    user.ValPagado = this.Liq[0].Total;
    user.liq = this.Liq[0].Total;
    this.getTotalValPagado();
    this.descargaShow = false;
  }

  downLoadPantillaConciliacion() {
    let plantillaConciliacion = [];
    this.conciliacion.forEach(c => {
      plantillaConciliacion.push({
        IdReporte: this.encReporte.IdReporte
        , Cedula: c.Cedula
        , NumSol: c.NumSol
        , Cuota: c.Cuota
        , ValCuota: c.ValCuota
        , ValPagado: null
        , Obs: null
      })
    });
    console.log('plantillaConciliacion: ', plantillaConciliacion);
    this.exportAsExcelFile(plantillaConciliacion, 'Plantilla_Conciliacion');
  }

  async selectFileConc(data) {
    let jsonResult: any = await this.importExcelAsJSON(data);
    console.log('jsonResult: ', jsonResult.Plantilla_Conciliacion);
    if (jsonResult.Plantilla_Conciliacion) {
      this.popoverController.dismiss();
      let regNoSub = [];
      jsonResult.Plantilla_Conciliacion.forEach(cd => {
        let cdn = false;
        this.conciliacion.forEach(cu => {
          if (cu.IdReporte == cd.IdReporte && cu.Cedula == cd.Cedula && cu.NumSol == cd.NumSol && cu.Cuota == cd.Cuota) {
            cu.ValPagado = cd.ValPagado;
            cu.Obs = cd.Obs;
            cdn = true;
          }
        });
        if (!cdn) {
          regNoSub.push(cd);
        }
      });
      this.getTotalValPagado();
      if (regNoSub.length > 0) {
        this.exportAsExcelFile(regNoSub, 'Registros-No-Subidos');
      }
    } else {
      this.presentAlert('Error', 'Importando archivo de conciliación', 'El nombre de la hoja a importar debe ser "Plantilla_Conciliacion"');
    }
  }


  async selectFilePagosXdocAlert(data) {
    this.pagosXdoc = [];
    let jsonResult: any = await this.importExcelAsJSON(data);
    this.pagosXdoc = jsonResult.Hoja1;
    let pagoTotAlert = 0;
    this.pagosXdoc.forEach(p => {
      pagoTotAlert = pagoTotAlert + p.pago;
    });
    const alert = await this.alertController.create({
      mode: 'ios',
      header: 'Confirma',
      message: `Numero de cobros: ${this.pagosXdoc.length} <br> Pago total: ${this.currencyPipe.transform(pagoTotAlert, '$ ', 'symbol', '.0-0')}`,
      buttons: [
        {
          text: 'Cancelar',
          role: 'cancel',
          cssClass: 'secondary',
          handler: (blah) => {
            console.log('Confirm Cancel: blah');
          },
        },
        {
          text: 'Confirmar',
          handler: () => {
            console.log('Confirm Okay');
            this.selectFilePagosXdoc()
          },
        },
      ],
    });
    await alert.present();
  }


  pagosXdoc = [];
  contPxD = 0;
  pagosXdocLoadEn = false;
  docPxD;
  porcPxD;
  liquidacionesPxD = [];
  cuotasPxD = [];
  devolucionesPxD = [];
  liquidacionesPxDFilt = [];
  cuotasPxDFilt = [];
  devolucionesPxDFilt = [];
  async selectFilePagosXdoc() {
    this.contPxD = 0;
    this.pagosXdocLoadEn = false;
    this.liquidacionesPxD = [];
    this.cuotasPxD = [];
    this.devolucionesPxD = [];
    console.log('jsonResult: ', this.pagosXdoc);
    if (this.pagosXdoc) {
      this.popoverController.dismiss();
      console.log('PagosXdoc: ', this.pagosXdoc);
      this.pagosXdocLoadEn = true;
      this.contPxD = 1;
      /* variable para revision */ let pagoTotRev = 0;
      /* variable para revision */ let difPagoRev = 0;
      /* variable para revision */ let pagoLiqRev = 0;
      /* variable para revision */ let pagoCuotRev = 0;
      /* variable para revision */ let pagoDevRev = 0;
      for (let p of this.pagosXdoc) {
        this.docPxD = p.documento;
        this.apiOnReq = false;
        let body = {
          documento: p.documento,
          pago: p.pago,
          idpago: this.encReporte.IdReporte,
          usr: this.user.Usuario
        };
        let aplPago = new Promise((resolve, reject) => {
          this.http.post(environment.urlApi + 'coorp/getPagoXccTables', body, this.HTTPoptions).subscribe((res: any) => {
            this.apiOnReq = false;
            let totPagoInd = 0;
            res[0].forEach(l => { this.liquidacionesPxD.push(l); totPagoInd = totPagoInd + l.total; pagoLiqRev = pagoLiqRev + l.total; });
            res[1].forEach(c => { this.cuotasPxD.push(c); totPagoInd = totPagoInd + c.Pago; pagoCuotRev = pagoCuotRev + c.Pago; });
            res[2].forEach(d => { this.devolucionesPxD.push(d); totPagoInd = totPagoInd + d.Devolucion; pagoDevRev = pagoDevRev + d.Devolucion; });

            /* revision */
            if (Math.abs(totPagoInd - p.pago) > 1) {
              console.log('Error al aplicar pago: ', p.documento);
              console.log('pago: ', p.pago);
              console.log('pago aplicado: ', totPagoInd);
              console.log('diferencia: ', (p.pago - totPagoInd));
            }
            pagoTotRev = pagoTotRev + p.pago;
            difPagoRev = difPagoRev + (p.pago - totPagoInd);
            /* fin revision */


            resolve('ok');
          });
        })
        await aplPago;
        this.contPxD = this.contPxD + 1;
        this.porcPxD = this.contPxD / this.pagosXdoc.length;
      }
      /* para revision */ console.log('pagoTotRev: ', pagoTotRev);
      /* para revision */ console.log('difPagoRev: ', difPagoRev);
      /* para revision */ console.log('pagoLiqRev: ', pagoLiqRev);
      /* para revision */ console.log('pagoCuotRev: ', pagoCuotRev);
      /* para revision */ console.log('pagoDevRev: ', pagoDevRev);
      /* para revision */ console.log('totRev: ', pagoLiqRev + pagoCuotRev + pagoDevRev);
      this.pagosXdocLoadEn = false;
      this.liquidacionesPxDFilt = this.liquidacionesPxD;
      this.cuotasPxDFilt = this.cuotasPxD;
      this.devolucionesPxDFilt = this.devolucionesPxD;
      console.log('liquidaciones: ', this.liquidacionesPxD);
      console.log('cuotas: ', this.cuotasPxD);
      console.log('devoluciones: ', this.devolucionesPxD);
      this.diligenciaConciliacion();
      this.getTotalValPagado2();
    } else {
      this.presentAlert('Error', 'Importando archivo de conciliación', 'El nombre de la hoja a importar debe ser "Hoja1"');
    }
  }

  diligenciaConciliacion() {
    this.conciliacion.forEach(c => { /* llena la conciliacion */
      let liquidacion = this.liquidacionesPxD.find(l => l.NumSol == c.NumSol);  /* revisa liquidaciones */
      if (liquidacion) {
        c.ValPagado = liquidacion.total;
        c.Obs = `Liquidación usr: ${liquidacion.usuario}, fecha: ${liquidacion.fecha}`;
      }
      let cuotas = this.cuotasPxD.filter(k => k.NumSol == c.NumSol); /* revisa cuotas */
      if (cuotas.length > 0) {
        if (cuotas.length == 1) {
          c.ValPagado = cuotas[0].Pago;
          if (c.Cuota != cuotas[0].Cuota) {
            c.Obs = `Se aplica sobre la cuota: ${cuotas[0].Cuota}`;
          } else {
            /* if (c.TotCuota != cuotas[0].VlrCuota) { */
            if ((c.TotCuota - cuotas[0].Pago) > this.DifCuota) {
              c.Obs = "Se aplica lo que alcanzó";
            }
          }
        } else {
          let totk = 0;
          let cuotask = "";
          cuotas.forEach(k => {
            totk = totk + k.Pago;
            cuotask = cuotask + " - " + k.Cuota;
          });
          c.ValPagado = totk;
          c.Obs = `Se aplica sobre las cuotas: ${cuotask}`;
        }
      }
      if (!c.ValPagado) {
        c.ValPagado = 0;
        c.Obs = "No se recibe nada para esta cuota";
      }
    });
  }

  getTotalValPagado2() {
    /* variable para revision */ let pagoLiqRev2 = 0;
    /* variable para revision */ let pagoCuotRev2 = 0;
    /* variable para revision */ let pagoDevRev2 = 0;
    this.getTotalValPagado();
    this.totalValPagado = 0;
    this.liquidacionesPxD.forEach(l => {
      this.totalValPagado = this.totalValPagado + l.total;
      pagoLiqRev2 = pagoLiqRev2 + l.total
      if (this.conciliacion.findIndex(c => c.NumSol == l.NumSol) < 0) { l.NoExisteCon = 1; }
    });
    this.cuotasPxD.forEach(c => {
      this.totalValPagado = this.totalValPagado + c.Pago;
      pagoCuotRev2 = pagoCuotRev2 + c.Pago;
      if (this.conciliacion.findIndex(co => co.NumSol == c.NumSol) < 0) { c.NoExisteCon = 1; }
    });
    this.devolucionesPxD.forEach(d => {
      this.totalValPagado = this.totalValPagado + d.Devolucion;
      pagoDevRev2 = pagoDevRev2 + d.Devolucion;
      if (this.conciliacion.findIndex(c => c.Cedula == d.Documento) < 0) { d.NoExisteCon = 1; }
    });
    this.updateFilter17(this.busqueda17);
    /* para revision */ console.log('pagoLiqRev2: ', pagoLiqRev2);
    /* para revision */ console.log('pagoCuotRev2: ', pagoCuotRev2);
    /* para revision */ console.log('pagoDevRev2: ', pagoDevRev2);
    /* para revision */ console.log('totRev: ', pagoLiqRev2 + pagoCuotRev2 + pagoDevRev2);
  }

  getTotalValPagado() {
    this.totalReportado = 0;
    this.totalValPagado = 0;
    this.numCuotasToApl = 0;
    this.numCuotasApl = 0;
    this.conciliacion.forEach(c => {
      this.totalReportado = this.totalReportado + c.ValCuota;
      if (c.ValPagado != null) {
        this.totalValPagado = this.totalValPagado + c.ValPagado;
      }
      if (this.DifCuota > Math.abs(c.ValPagado - c.TotCuota) && c.Pago == 0 && c.Estado == "DESEMBOLSADO") {
        this.numCuotasToApl = this.numCuotasToApl + 1;
      }
      if (c.Pago > 0) {
        this.numCuotasApl = this.numCuotasApl + 1;
      }
    });
  }


  async SaveConciliacionConfirm() {
    const alert = await this.alertController.create({
      mode: 'ios',
      header: 'Confirma!',
      message: `<b>Total reportado: </b>${this.currencyPipe.transform(this.totalReportado, '$ ', 'symbol', '.0-0')}<br> <b>Total Conciliado: </b>${this.currencyPipe.transform(this.totalValPagado, '$ ', 'symbol', '.0-0')}`,
      buttons: [
        {
          text: 'Cancelar',
          role: 'cancel',
          cssClass: 'secondary',
          handler: (blah) => {
            console.log('Confirm Cancel: blah');
          }
        }, {
          text: 'Aceptar',
          handler: () => {
            console.log('Confirm Okay');
            /* this.SaveConciliacion(); */
            this.SaveConciliacionByOne();
          }
        }
      ]
    });

    await alert.present();
  }

  async SaveConciliacionConfirm2() {
    const alert = await this.alertController.create({
      mode: 'ios',
      header: 'Confirma!',
      message: `<b>Total reportado: </b>${this.currencyPipe.transform(this.totalReportado, '$ ', 'symbol', '.0-0')}<br> <b>Total Conciliado: </b>${this.currencyPipe.transform(this.totalValPagado, '$ ', 'symbol', '.0-0')}`,
      buttons: [
        {
          text: 'Cancelar',
          role: 'cancel',
          cssClass: 'secondary',
          handler: (blah) => {
            console.log('Confirm Cancel: blah');
          }
        }, {
          text: 'Aceptar',
          handler: () => {
            console.log('Confirm Okay');
            /* this.SaveConciliacion(); */
            this.SaveConciliacionByOneAll();
          }
        }
      ]
    });

    await alert.present();
  }


  async SaveConciliacion() {
    await this.presentLoading('Guardando conciliación...');
    this.apiOnReq = true;
    let body = {
      usr: this.user.Usuario,
      conciliacion: this.conciliacion
    };
    this.http.post(environment.urlApi + 'saveconciliacion', body).subscribe((res: any) => {
      if (this.loading) { this.loading.dismiss(); }
      this.apiOnReq = false;
      clearTimeout(this.temporizador);
      console.log('res: ', res);
      if (res.conciliacionesError.length > 0) {
        this.presentAlert('Alerta!', 'Errores al guardar conciliación', 'Por favor revisa el archivo de excel "ConcilError" que se acaba de descargar.');
        this.exportAsExcelFile(res.conciliacionesError, 'ConcilError');
      } else {
        this.presentToast('Se guardó todo correctamente!');
        this.encReporte.ValorRec = this.totalValPagado;
      }
      this.irConciliacion(this.encReporte);
    })
  }

  descargarAllInfoPagos() {
    if (this.liquidacionesPxD.length > 0) { this.exportAsExcelFile(this.liquidacionesPxD, 'Liquidaciones_' + this.encReporte.IdReporte); }
    if (this.cuotasPxD.length > 0) { this.exportAsExcelFile(this.cuotasPxD, 'Cuotas_' + this.encReporte.IdReporte); }
    if (this.devolucionesPxD.length > 0) { this.exportAsExcelFile(this.devolucionesPxD, 'Devoluciones_' + this.encReporte.IdReporte); }
  }

  async SaveConciliacionByOneAll() {
    this.descargarAllInfoPagos();
    await this.SaveConciliacionByOne();
    await this.SaveConciliacionLiqByOne();
    await this.SaveConciliacionCuotByOne();
    await this.SaveConciliacionDevByOne();
    await this.aplicarCuotas2();
    await this.aplicarLiquidaciones();
    await this.sendPaymentsAppliedToTrebol(this.paymentsDone);
  }

  async sendPaymentsAppliedToTrebol(cuotas: any) {
    if (cuotas.length > 0) {
      console.log('paymentsDone: ', this.paymentsDone);
      const body = {
        pagos: cuotas,
        RN: this.encReporte.IdReporte
      }
      await this.req('post', 'trebolaplicarpago2', body, '', false)
        .then((response) => {
          console.log('response: ', response);
        })
        .catch((error) => {
          console.log('Error al enviar pagos a Trebol: ', error);
          this.loadingController.dismiss();
          this.presentAlert('Error', 'Error al enviar recaudos a Trebol', JSON.stringify(error));
        })
    }
  }

  conSaveLoadEn = false;
  contConciSave = 0;
  porcConciSave = 0;
  async SaveConciliacionByOne() {
    /* this.presentLoading('Guardando conciliación, por favor espera...'); */
    let conciliacionMal = [];
    this.contConciSave = 0;
    this.porcConciSave = 0;
    this.conSaveLoadEn = true;
    for (let c of this.conciliacion) {
      this.apiOnReq = true;
      if (c.Obs == null) { c.Obs = ""; }
      let body = {
        usr: this.user.Usuario,
        conciliacion: c
      };
      let httpReqProm = new Promise((resolve, reject) => {
        this.http.post(environment.urlApi + 'saveconciliacionbyone', body).subscribe((res: any) => {
          this.apiOnReq = false;
          if (!res.res) {
            conciliacionMal.push(res);
            console.log('Conciliacion mal: ', c.NumSol);
          }
          this.contConciSave = this.contConciSave + 1;
          this.porcConciSave = this.contConciSave / this.conciliacion.length;
          console.log(c.NumSol + "-" + this.contConciSave + "-", this.porcConciSave);
          resolve('ok');
        });
      });
      await httpReqProm;
    }
    this.conSaveLoadEn = false;
    clearTimeout(this.temporizador);
    if (this.loading) { this.loading.dismiss(); }
    if (conciliacionMal.length > 0) {
      this.presentAlert('Alerta!', 'Errores al guardar conciliación', 'Por favor revisa el archivo de excel "ConcilError" que se acaba de descargar.');
      this.exportAsExcelFile(conciliacionMal, 'ConcilError');
    } else {
      this.presentToast('Se guardó todo correctamente!');
      this.encReporte.ValorRec = this.totalValPagado;
    }
  }

  conLiqSaveLoadEn = false;
  contConciLiqSave = 0;
  porcConciLiqSave = 0;
  async SaveConciliacionLiqByOne() {
    /* this.presentLoading('Guardando Liquidaciones, por favor espera...'); */
    let conciliacionMal = [];
    this.contConciLiqSave = 0;
    this.porcConciLiqSave = 0;
    this.conLiqSaveLoadEn = true;
    for (let c of this.liquidacionesPxD) {
      this.apiOnReq = true;
      if (c.Obs == null) { c.Obs = ""; }
      let body = {
        idpago: this.encReporte.IdReporte,
        liquidacion: c
      };
      let httpReqProm = new Promise((resolve, reject) => {
        this.http.post(environment.urlApi + 'coorp/saveConciliacionLiq', body, this.HTTPoptions).subscribe(
          (res: any) => {
            this.apiOnReq = false;
            this.contConciLiqSave = this.contConciLiqSave + 1;
            this.porcConciLiqSave = this.contConciLiqSave / this.liquidacionesPxD.length;
            console.log(c.NumSol + "-" + this.contConciLiqSave + "-", this.porcConciLiqSave);
            resolve('ok');
          },
          (err) => {
            conciliacionMal.push({
              NumSol: c.NumSol,
              Error: err
            });
            console.log('Conciliacion mal: ', c.NumSol);
          }
        );
      });
      await httpReqProm;
    }
    this.conLiqSaveLoadEn = false;
    clearTimeout(this.temporizador);
    if (this.loading) { this.loading.dismiss(); }
    if (conciliacionMal.length > 0) {
      this.presentAlert('Alerta!', 'Errores al guardar conciliación', 'Por favor revisa el archivo que se acaba de descargar.');
      this.exportAsExcelFile(conciliacionMal, 'ConcilSaveLiquidError');
    } else {
      this.presentToast('Se guardó liquidaciones correctamente!');
      /* this.encReporte.ValorRec = this.totalValPagado; */
    }
    /* this.irConciliacion(this.encReporte); */
  }

  conCuotSaveLoadEn = false;
  contConciCuotSave = 0;
  porcConciCuotSave = 0;
  async SaveConciliacionCuotByOne() {
    /* this.presentLoading('Guardando cuotas, por favor espera...'); */
    let conciliacionMal = [];
    this.contConciCuotSave = 0;
    this.porcConciCuotSave = 0;
    this.conCuotSaveLoadEn = true;
    for (let c of this.cuotasPxD) {
      this.apiOnReq = true;
      if (c.Obs == null) { c.Obs = ""; }
      let body = {
        idpago: this.encReporte.IdReporte,
        cuota: c
      };
      let httpReqProm = new Promise((resolve, reject) => {
        this.http.post(environment.urlApi + 'coorp/saveConciliacionCuot', body, this.HTTPoptions).subscribe(
          (res: any) => {
            this.apiOnReq = false;
            this.contConciCuotSave = this.contConciCuotSave + 1;
            this.porcConciCuotSave = this.contConciCuotSave / this.cuotasPxD.length;
            console.log(c.NumSol + "-" + this.contConciCuotSave + "-", this.porcConciCuotSave);
            resolve('ok');
          },
          (err) => {
            conciliacionMal.push({
              NumSol: c.NumSol,
              Error: err
            });
            console.log('Conciliacion mal: ', c.NumSol);
          }
        );
      });
      await httpReqProm;
    }
    this.conCuotSaveLoadEn = false;
    clearTimeout(this.temporizador);
    if (this.loading) { this.loading.dismiss(); }
    if (conciliacionMal.length > 0) {
      this.presentAlert('Alerta!', 'Errores al guardar conciliación', 'Por favor revisa el archivo que se acaba de descargar.');
      this.exportAsExcelFile(conciliacionMal, 'ConcilSaveCuotError');
    } else {
      this.presentToast('Se guardó Cuotas correctamente!');
      /* this.encReporte.ValorRec = this.totalValPagado; */
    }
    /* this.irConciliacion(this.encReporte); */
  }


  conDevSaveLoadEn = false;
  contConciDevSave = 0;
  porcConciDevSave = 0;
  async SaveConciliacionDevByOne() {
    /* this.presentLoading('Guardando Devoluciones, por favor espera...'); */
    let conciliacionMal = [];
    this.contConciDevSave = 0;
    this.porcConciDevSave = 0;
    this.conDevSaveLoadEn = true;
    for (let c of this.devolucionesPxD) {
      console.log('guardando devolucion: ', c);
      this.apiOnReq = true;
      if (c.Obs == null) { c.Obs = ""; }
      let body = {
        idpago: this.encReporte.IdReporte,
        devolucion: c
      };
      let httpReqProm = new Promise((resolve, reject) => {
        this.http.post(environment.urlApi + 'coorp/saveConciliacionesDev', body, this.HTTPoptions).subscribe(
          (res: any) => {
            this.apiOnReq = false;
            this.contConciDevSave = this.contConciDevSave + 1;
            this.porcConciDevSave = this.contConciDevSave / this.devolucionesPxD.length;
            console.log(c.Documento + "-" + this.contConciDevSave + "-", this.porcConciDevSave);
            resolve('ok');
          },
          (err) => {
            conciliacionMal.push({
              NumSol: c.Documento,
              Error: err
            });
            console.log('Conciliacion mal: ', c.Documento);
          }
        );
      });
      await httpReqProm;
    }
    this.conDevSaveLoadEn = false;
    clearTimeout(this.temporizador);
    if (this.loading) { this.loading.dismiss(); }
    if (conciliacionMal.length > 0) {
      this.presentAlert('Alerta!', 'Errores al guardar conciliación', 'Por favor revisa el archivo que se acaba de descargar.');
      this.exportAsExcelFile(conciliacionMal, 'ConcilSaveDevError');
    } else {
      this.presentToast('Se guardó devoluciones correctamente!');
      /* this.encReporte.ValorRec = this.totalValPagado; */
    }
    /* this.irConciliacion(this.encReporte); */
  }



  async aplicarCuotasAnt() {
    console.log('conciliacion: ', this.conciliacion);
    console.log('encReporte: ', this.encReporte);
    let Pagos = [];
    this.conciliacion.forEach(c => {
      if (this.DifCuota > Math.abs(c.ValPagado - c.TotCuota) && c.Pago == 0 && c.Estado == "DESEMBOLSADO") {
        Pagos.push({
          EMPRESA: this.encReporte.IdEmpresa,
          NumSol: c.NumSol,
          CEDULA: c.Cedula,
          CUOTA: c.Cuota,
          NOMBRE: c.NombreCompleto,
          VALOR: c.ValPagado,
          FechaPago: this.datePipe.transform(c.FechaEstPago, "yyy-MM-dd", "+0000"),
          IdPago: "RN " + this.encReporte.IdReporte,
          USUARIO: this.user.Usuario.trim()
        })
      }
    });
    console.log('Pagos: ', Pagos);
    this.apiOnReq = true;
    let body = {
      Hoja1: Pagos
    };
    this.http.post(environment.urlApi + 'aplicarpagos', body).subscribe((res: any) => {
      if (this.loading) { this.loading.dismiss(); }
      this.apiOnReq = false;
      clearTimeout(this.temporizador);
      console.log(res);
      this.presentToast('Pagos aplicados!');
      this.irConciliacion(this.encReporte);
    });
    await this.presentLoading('Aplicando Pagos, por favor espera...');
    if (!this.apiOnReq) { this.loading.dismiss(); }
  }

  async aplicarCuotas() {
    this.AplEn = true;
    console.log('conciliacion: ', this.conciliacion);
    console.log('encReporte: ', this.encReporte);
    let Pagos = [];
    let PagosManuales = []
    this.conciliacion.forEach(c => {
      if (this.DifCuota > Math.abs(c.ValPagado - c.TotCuota) && c.Pago == 0 && c.Estado == "DESEMBOLSADO") {
        Pagos.push({
          EMPRESA: this.encReporte.IdEmpresa,
          NumSol: c.NumSol,
          CEDULA: c.Cedula,
          CUOTA: c.Cuota,
          NOMBRE: c.NombreCompleto,
          VALOR: c.ValPagado,
          FechaPago: this.datePipe.transform(c.FechaEstPago, "yyy-MM-dd", "+0000"),
          IdPago: "RN " + this.encReporte.IdReporte,
          USUARIO: this.user.Usuario.trim()
        })
      } else {
        PagosManuales.push({
          EMPRESA: this.encReporte.IdEmpresa,
          NumSol: c.NumSol,
          CEDULA: c.Cedula,
          CUOTA: c.Cuota,
          NOMBRE: c.NombreCompleto,
          ValorCuota: c.TotCuota,
          SaldoCuota: c.ValCuota,
          VALOR: c.ValPagado,
          FechaPago: this.datePipe.transform(c.FechaEstPago, "yyy-MM-dd", "+0000"),
          IdPago: "RN " + this.encReporte.IdReporte,
          USUARIO: this.user.Usuario.trim(),
          ESTADO: c.Estado,
          OBSERVACION: c.Obs
        })
      }
    });
    console.log('Pagos: ', Pagos);
    console.log('PagosManuales: ', PagosManuales);
    this.exportAsExcelFile(Pagos, "PagosAuto-" + this.encReporte.IdReporte);
    this.exportAsExcelFile(PagosManuales, "PagosManuales-" + this.encReporte.IdReporte);

    let pagosMal = [];
    this.pagosToApl = Pagos.length;
    this.pagosAplCount = 0;
    this.pagosAplLoad = true;
    await this.presentLoading('Aplicando Pagos, por favor espera...');
    for (let p of Pagos) {
      this.apiOnReq = true;
      let body = {
        pago: p,
        RN: this.encReporte.IdReporte
      };
      let aplPago = new Promise((resolve, reject) => {
        this.http.post(environment.urlApi + 'aplicarpagosprocomp', body).subscribe((res: any) => {
          this.apiOnReq = false;
          if (res.res == false) {
            pagosMal.push({
              NumSol: p.Numsol,
              err: JSON.stringify(res.error)
            })
          }
          resolve('ok');
        });
      })
      await aplPago;
      this.pagosAplCount = this.pagosAplCount + 1;
      this.pagosAplPorc = this.pagosAplCount / this.pagosToApl;
      console.log(this.pagosAplCount);
    }
    if (this.loading) { this.loading.dismiss(); }
    clearTimeout(this.temporizador);
    this.pagosAplLoad = false;
    if (pagosMal.length == 0) {
      this.presentToast('Tolos los pagos aplicados!');
    } else {
      this.presentAlert("Alerta", "Algunos pagos tuvieron problema", 'Por favor revisa el archivo "PagosError" para más información');
      this.exportAsExcelFile(pagosMal, "PagosError");
    }
    this.irConciliacion(this.encReporte);
    this.AplEn = false;
  }


  paymentsDone = [];
  async aplicarCuotas2() {
    this.AplEn = true;
    console.log('encReporte: ', this.encReporte);
    let Pagos = [];
    this.cuotasPxD.forEach(c => {
      Pagos.push({
        EMPRESA: this.encReporte.IdEmpresa,
        NumSol: c.NumSol,
        CEDULA: c.documento,
        CUOTA: c.Cuota,
        NOMBRE: c.nombre,
        VALOR: c.TotPago,
        FechaPago: this.datePipe.transform(c.FechaEstPago, "yyy-MM-dd", "+0000"),
        IdPago: "RN " + this.encReporte.IdReporte,
        USUARIO: this.user.Usuario.trim()
      })
    });
    console.log('Pagos: ', Pagos);
    /* this.exportAsExcelFile(Pagos, "PagosAuto-" + this.encReporte.IdReporte); */
    let pagosMal = [];
    this.pagosToApl = Pagos.length;
    this.pagosAplCount = 0;
    this.pagosAplLoad = true;
    for (let p of Pagos) {
      this.apiOnReq = true;
      let body = {
        pago: p,
        RN: this.encReporte.IdReporte
      };
      let aplPago = new Promise((resolve, reject) => {
        this.http.post(environment.urlApi + 'aplicarpagosprocomp', body).subscribe((res: any) => {
          this.apiOnReq = false;
          if (res.res == false) {
            pagosMal.push({
              NumSol: p.Numsol,
              err: JSON.stringify(res.error)
            })
          } else {
            this.paymentsDone.push(p);
          }
          resolve('ok');
        });
      })
      await aplPago;
      this.pagosAplCount = this.pagosAplCount + 1;
      this.pagosAplPorc = this.pagosAplCount / this.pagosToApl;
      console.log(this.pagosAplCount);
    }
    if (this.loading) { this.loading.dismiss(); }
    clearTimeout(this.temporizador);
    this.pagosAplLoad = false;
    if (pagosMal.length == 0) {
      this.presentToast('Tolos los pagos aplicados!');
    } else {
      this.presentAlert("Alerta", "Algunos pagos tuvieron problema", 'Por favor revisa el archivo "PagosError" para más información');
      this.exportAsExcelFile(pagosMal, "PagosError");
    }
    this.irConciliacion(this.encReporte);
    this.AplEn = false;
  }

  liquidacionesApl = []
  liquAplCount = 0;
  liqAplLoad = false;
  async aplicarLiquidaciones() {
    this.liqAplLoad = true;
    let aplLiqErr = [];
    this.liquidacionesApl = [];
    this.liquAplCount = 0;
    for (let l of this.liquidacionesPxD) {
      const body = {
        numsol: l.NumSol,
        saldok: l.saldok,
        intereses: l.intereses,
        cloud: l.cloud,
        seguro: l.seguro,
        fecha: l.fecha,
        usuario: this.user.Usuario,
        diasinteres: l.diasinteres,
        obs: `LIQUIDACION RN ${this.encReporte.IdReporte}`
      }
      await this.req('post', 'pagoant', body, '', false)
        .then((res) => {
          console.log(`Liquidacion aplicada NumSol:${l.NumSol}`);
          this.liquidacionesApl.push(l);

          l.CEDULA = l.documento;
          l.VALOR = l.total
          this.paymentsDone.push(l);

          this.liquAplCount = this.liquAplCount + 1;
        })
        .catch((err) => {
          console.log(`Error al aplicar pago  NumSol:${l.NumSol}, Cuota:${l.CUOTA}: `, err);
          aplLiqErr.push({
            liquidacion: JSON.stringify(l),
            error: JSON.stringify(err)
          });
        });
    }
    if (aplLiqErr.length == 0) {
      this.presentToast('Todas las liquidaciones aplicadas!');
    } else {
      this.presentAlert("Alerta", "Algunas liquidaciones tuvieron problema", 'Por favor revisa el archivo "LiquidacionesError" para más información');
      this.exportAsExcelFile(aplLiqErr, "LiquidacionesError");
    }
    this.liqAplLoad = false;
    return true;
  }



  warnSaldoCuota(row) {
    if (Math.abs(row.ValCuota - row.TotCuota) > this.DifCuota) {
      return true;
    } else {
      false;
    }
  }

  getCuotasPendientes() {
    let pagosPendientes = [];
    this.conciliacion.forEach(c => {
      if (c.Pago == 0) {
        pagosPendientes.push({
          EMPRESA: this.encReporte.IdEmpresa,
          NumSol: c.NumSol,
          CEDULA: c.Cedula,
          CUOTA: c.Cuota,
          NOMBRE: c.NombreCompleto,
          ValorCuota: c.TotCuota,
          SaldoCuota: c.ValCuota,
          VALOR: c.ValPagado,
          FechaPago: this.datePipe.transform(c.FechaEstPago, "yyy-MM-dd", "+0000"),
          IdPago: "RN " + this.encReporte.IdReporte,
          USUARIO: this.user.Usuario.trim(),
          ESTADO: c.Estado,
          OBSERVACION: c.Obs
        })
      }
    });
    console.log('pagosPendientes: ', pagosPendientes);
    if (pagosPendientes.length > 0) {
      this.exportAsExcelFile(pagosPendientes, "PagosPendientes-" + this.encReporte.IdReporte);
    } else {
      this.presentToast("No hay pagos pendientes que revisar!");
    }
  }

  warnSaldoCuotaSort() {
    this.updateFilter17(this.busqueda17);
    this.conciliacionFilt.sort((b, a) => (Math.abs(a.ValCuota - a.TotCuota)) - (Math.abs(b.ValCuota - b.TotCuota)));
    console.log(this.conciliacionFilt);
  }

  CuotasPagadasSort() {
    this.updateFilter17(this.busqueda17);
    this.conciliacionFilt.sort((a, b) => b.Pago - a.Pago);
    console.log(this.conciliacionFilt);
  }

  sumarizacion(arrayDesglosado: any) {
    let arraySumarizado = [];
    arrayDesglosado.forEach(ad => {
      if (arraySumarizado.filter(as => as.Cedula == ad.Cedula).length == 0) {
        let arr = arrayDesglosado.filter(adt => adt.Cedula == ad.Cedula);
        ad.numcred = arr.length;
        let totmonto = 0;
        let promplazo = 0;
        let promcuota = 0;
        let totvalcuota = 0;
        let tottotcuota = 0;
        let totvalpagado = 0
        arr.forEach(ar => {
          totmonto = totmonto + ar.Monto;
          promplazo = promplazo + ar.Plazo;
          promcuota = promcuota + ar.Cuota;
          totvalcuota = totvalcuota + ar.ValCuota;
          tottotcuota = tottotcuota + ar.TotCuota;
          totvalpagado = totvalpagado + ar.ValPagado;
        });
        promplazo = Math.round(promplazo / arr.length);
        promcuota = Math.round(promcuota / arr.length);
        ad.totmonto = totmonto;
        ad.promplazo = promplazo;
        ad.promcuota = promcuota;
        ad.totvalcuota = totvalcuota;
        ad.tottotcuota = tottotcuota;
        ad.totvalpagado = totvalpagado;
        arraySumarizado.push(ad);
      }
    });
    arraySumarizado.sort((b, a) => a.numcred - b.numcred);
    console.log(arraySumarizado);
    this.conciliacionAgru = arraySumarizado;
    this.conciliacionAgruFilt = arraySumarizado;
    this.conciliacionAgruEn = true;
    this.updateFilter18(this.busqueda18);
    this.getTotalValPagado();
  }

  typeListChan(event) {
    console.log(event.detail.value);
    if (event.detail.value == "Agrupado") {
      this.sumarizacion(this.conciliacion);
    } else {
      this.conciliacionAgruEn = false;
    }
  }

  descargarConcAgrupXdoc() {
    this.sumarizacion(this.conciliacion);
    let concAgruForm = [];
    this.conciliacionAgruFilt.forEach(c => {
      concAgruForm.push({
        IdReporte: c.IdReporte,
        IdEmpresa: c.IdEmpresa,
        Tipo: c.Tipo,
        Cedula: c.Cedula,
        NombreCompleto: c.NombreCompleto,
        numcred: c.numcred,
        totmonto: c.totmonto,
        promplazo: c.promplazo,
        promcuota: c.promcuota,
        totcuota: c.tottotcuota,
        totvalpagado: c.totvalpagado || 0
      })
    });
    this.exportAsExcelFile(concAgruForm, 'Conciliacion-agruXdoc_' + this.encReporte.IdReporte);
    this.descargarAllInfoPagos();
  }


  descargarPlantillaPxD() {
    this.sumarizacion(this.conciliacion);
    let concAgruForm = [];
    this.conciliacionAgruFilt.forEach(c => {
      concAgruForm.push({
        documento: c.Cedula,
        NombreCompleto: c.NombreCompleto,
        totcuota: c.tottotcuota,
        pago: 0
      })
    });
    this.exportAsExcelFile2(concAgruForm, 'Plantilla-pagoXdoc_' + this.encReporte.IdReporte);
  }

  descargarPlantillaPxDvacia() {
    /* this.sumarizacion(this.conciliacion); */
    let concAgruForm = [];
    concAgruForm.push({
      documento: null,
      pago: null
    })
    this.exportAsExcelFile2(concAgruForm, 'Plantilla-pagoXdoc-vacio_' + this.encReporte.IdReporte);
  }


  descargarConcDesgloXdoc() {
    this.exportAsExcelFile(this.conciliacion, 'Conciliacion-desgloXdoc_' + this.encReporte.IdReporte);
    this.descargarAllInfoPagos();
  }

  editFromAgru(row) {
    console.log(row);
    this.busqueda17 = row.Cedula;
    this.updateFilter17(this.busqueda17);
    this.conciliacionAgruEn = false;
    this.toAgruEn = true;
  }

  backToAgru() {
    this.conciliacionAgruEn = true;
    this.toAgruEn = false;
    this.sumarizacion(this.conciliacion);
  }

  async editEncReporteAlert(row) {
    console.log('row: ', row);
    console.log('Fecha abono: ', this.datePipe.transform(row.FechaAbono, "dd-MM-yyy", "+0000"));
    const alert = await this.alertController.create({
      mode: 'ios',
      header: 'Editar encabezado de reporte ' + row.IdReporte,
      subHeader: 'Valor abonado, Fecha abono y Observaciones',
      inputs: [
        {
          name: 'abono',
          /* label: 'Valor abono ('+this.currencyPipe.transform(row.ValorAbon,'$ ','symbol','.0-0')+')', */
          value: row.ValorAbon,
          type: 'number',
          placeholder: 'Valor abonado'
        },
        {
          name: 'fechaAbono',
          value: this.datePipe.transform(row.FechaAbono, "yyy-MM-dd", "+0000"),
          type: 'date',
          placeholder: 'Fecha abono'
        },
        {
          name: 'obs',
          value: row.Obs,
          type: 'textarea',
          placeholder: 'Observaciones',
          attributes: {
            maxlength: 100,
          }
        }
      ],
      buttons: [
        {
          text: 'Cancelar',
          role: 'cancel',
          cssClass: 'secondary',
          handler: () => {
            console.log('Confirm Cancel');
          }
        }, {
          text: 'Guardar',
          handler: (res) => {
            console.log('Confirm Ok: ', res);
            if (res.fechaAbono == null || res.fechaAbono == "") { res.fechaAbono = "2000-12-31"; }
            if (res.obs == null) { res.obs = ""; }
            if (res.abono == null || res.abono == "") { res.abono = 0; }
            let datos = {
              IdReporte: row.IdReporte,
              Abono: res.abono,
              FechaAbono: res.fechaAbono,
              Obs: res.obs,
              Usr: this.user.Usuario.trim()
            }
            this.saveEditEncReporte(datos);
          }
        }
      ]
    });

    await alert.present();

  }

  async saveEditEncReporte(datos) {
    console.log(datos);
    await this.presentLoading('Guardando encabezado, por favor espera...');
    this.apiOnReq = true;
    let body = {
      datos: datos
    };
    this.http.post(environment.urlApi + 'addencreporteabono', body).subscribe((res: any) => {
      if (this.loading) { this.loading.dismiss(); }
      this.apiOnReq = false;
      clearTimeout(this.temporizador);
      console.log(res);
      this.presentToast('Encabezado guardado');
      this.getEncReporte();
    });
  }

  /* sectoresConvenios = [];
  getSectoresConvenios() {
    return new Promise((resolve, reject) => {
      if (this.loading) { this.loading.dismiss(); }
      this.apiOnReq = true;
      this.http.get(environment.urlApi + '/coorp/SectoresConvenios', this.HTTPoptions).subscribe((res: any) => {
        this.apiOnReq = false;
        res.forEach(sector => {
          sector.IdString = sector.Id;
        });
        this.sectoresConvenios = res;
        console.log('SectoresConvenios: ', this.sectoresConvenios);
        resolve(1);
      })
    })
  } */

  /* INICIO CODIGO REINTEGROS SEBASTIAN */

  /* estadosReintegros = ["1","3"]; */
  allReintegros = [];
  /* allEstadosReintegros = []; */
  antUrl5 = '';
  filtEncReintegro = [];
  detReintegro;
  detReintegro2;
  detReintegroId = '';
  detReintegroCedula = '';
  detReintegroEstado = 0;
  detReintegroDes = '';
  detReintegroObsBank = '';
  detReintegroObsFin = '';
  url1Reintegro = [];
  url1ReintegroOk = [];
  url4Reintegro = [];
  url4ReintegroOk = [];
  url5Reintegro = [];
  url5ReintegroOk = [];
  data5Reintegro = [];
  segAllReintegros = false;
  busqueda20 = "";
  detReintegroObsBanker = '';
  segDesembolso = false;

  irReintegros(resRein) {
    if (resRein == 'p') {
      this.segReinReload = false;
      if (this.allReintegros.length == 0) { this.getAllReintegros('p'); }
      this.menu.close('custom')
      this.router.navigate(['/reintegros']);
    } else {
      this.segReinReload = true;
      if (this.allReintegros.length == 0) { this.getAllReintegros('r'); }
      this.menu.close('custom')
      this.router.navigate(['/reintegros']);
    }
  }
  async getAllReintegros(resRein2) {
    var urlReinComp = ''; if (resRein2 == 'p') { urlReinComp = 'getallreintegros'; } else { urlReinComp = 'getallreintegros2'; }
    await this.presentLoading('Obteniendo todas las solicitudes de reintegro...');
    this.apiOnReq = true;
    let body = {};
    this.http.post(environment.urlApi + urlReinComp, body).subscribe((res: any) => {
      if (this.loading) { this.loading.dismiss() };
      this.apiOnReq = false;
      clearTimeout(this.temporizador);
      this.allReintegros = res.body;
      this.filtEncReintegro = this.allReintegros;
      this.updateFilter20(this.busqueda20);
    }, (err: any) => {
      if (this.loading) { this.loading.dismiss() };
      this.apiOnReq = false;
      clearTimeout(this.temporizador);
      this.presentAlert('Error', 'Al cargar solicitudes en proceso', JSON.stringify(err));
    })
  }
  /* async getAllReintegros2(){
    let body={};
    this.http.post(environment.urlApi+'getallreintegros', body).subscribe((res: any) => {
      
      this.allReintegros = res.body;
      this.filtEncReintegro = this.allReintegros;
    }, (err: any) => {
    })
  } */

  updateFilter20(event) {
    const val = event.toLowerCase().trim();
    this.filtEncReintegro = this.allReintegros.filter((d) => {
      return (d.id.toString().indexOf(val) !== -1 || d.cedula.toLowerCase().indexOf(val) !== -1 || d.nombre.toLowerCase().indexOf(val) !== -1 || d.nomEmpresa.toLowerCase().indexOf(val) !== -1 || !val);
      /* return (d.id.toLowerCase().indexOf(val) !== -1 || d.cedula.toLowerCase().indexOf(val) !== -1 || d.nombre.toLowerCase().indexOf(val) !== -1 || d.empresa.toLowerCase().indexOf(val) !== -1 || !val); */
    });
  }

  async getDetReintegro(solicitud) {
    var contador1 = 0;
    var contador4 = 0;
    this.detReintegro = [];
    this.detReintegro2 = [];
    this.antUrl5 = '';
    this.url1Reintegro = [];
    this.url1ReintegroOk = [];
    this.url4Reintegro = [];
    this.url4ReintegroOk = [];
    this.url5Reintegro = [];
    this.url5ReintegroOk = [];
    this.detReintegroId = '';
    this.detReintegroCedula = '';
    this.detReintegroEstado = 0;
    this.detReintegroDes = '';
    this.detReintegroObsBank = '';
    this.detReintegroObsBanker = '';
    this.detReintegroObsFin = '';
    this.segDesembolso = false; //ok
    this.apiOnReq = true;
    let body = {
      id: solicitud
    };
    this.http.post(environment.urlApi + 'idoperacion', body).subscribe((res: any) => {
      if (this.loading) { this.loading.dismiss(); }
      this.apiOnReq = false;
      clearTimeout(this.temporizador);
      if (res.body2) {
        this.detReintegro2 = res.body2;
      }
      if (res.body) {
        /* if(res.body.montoDes){
        }else{
          this.detReintegroDes = 0;
        } */
        this.detReintegroDes = res.body.montoDes;
        this.detReintegro = res.body;
        this.antUrl5 = res.body.url5;
        this.detReintegroId = res.body.id;
        this.detReintegroCedula = res.body.cedula;
        this.detReintegroObsBank = res.body.obsBank;
        this.detReintegroObsBanker = res.body.obsBanker;//ok
        this.detReintegroObsFin = res.body.obsFin;
        this.detReintegroEstado = res.body.estado;
        this.url1Reintegro = res.body.url1.split(',,');
        this.url4Reintegro = res.body.url4.split(',,');
        this.url1Reintegro.forEach(dato => { if (dato) { contador1++; this.url1ReintegroOk.push({ dato: dato, id: contador1 }); } });
        this.url4Reintegro.forEach(dato => { if (dato) { contador4++; this.url4ReintegroOk.push({ dato: dato, id: contador4 }); } });
        if (res.body.url5) { var contador = 0; this.url5Reintegro = res.body.url5.split(',,'); this.url5Reintegro.forEach(dato => { if (dato) { contador++; this.url5ReintegroOk.push({ dato: dato, id: contador }); } }); }
      } else {
        if (this.loading) { this.loading.dismiss(); }
        this.apiOnReq = false;
        clearTimeout(this.temporizador);
        this.presentAlert('Error', 'Información no encontrada', 'El detalle de ésta solicitud no fué encontrado');
      }
    },
      (err) => {
        if (this.loading) { this.loading.dismiss(); }
        this.apiOnReq = false;
        clearTimeout(this.temporizador);
        this.presentAlert('Error ', 'Al cargar detalle de la solicitud', +err.error.body.originalError.info.message);

      });
    await this.presentLoading('Obteniendo Detalles del credito...');
    if (!this.apiOnReq) { this.loading.dismiss(); }
  }
  async filesReintegro(event) {
    let filesArr = event.target.files
    console.log('filesChan: ', filesArr);
  }

  showDetReintegro(reintegro) {
    this.getDetReintegro(reintegro);
    this.router.navigate(['/detalle-reintegro']);
  }

  /* FIN CODIGO REINTEGROS SEBASTIAN */


  noLabora = [];
  noLaboraFilt = [];
  busquedaNL = "";
  async getCredNoLabora() {
    this.apiOnReq = true;
    await this.presentLoading('Cargando créditos No Labora...');
    this.http.get(environment.urlApi + '/coorp/getNoLabora', this.HTTPoptions).subscribe(
      (res: any) => {
        res.forEach(credito => {
          let empresa = this.empresas1.find(empresa => empresa.IdEmpresa == credito.IdEmpresa);
          credito.IdEmpresa = empresa.Nombre.trim();
          if (credito.IdEstado == 2 && credito.AprobadoRH == 0) { credito.IdEstado = '8' }
          let estado = this.estados.find(estado => estado.IdEstado == credito.IdEstado);
          credito.IdEstado = estado.Descripcion;
          /* if(credito.Acuerdo == null){ credito.Acuerdo = false; }
          if(credito.Acuerdo == true){
            credito.alDia = 'al dia';
          }
          else{
            if(estado.Descripcion == 'PAGADO' || estado.Descripcion == 'PAGO-ANTICIPADO' || estado.Descripcion == 'REPERFILADO' || estado.Descripcion == 'VENTA'){
              credito.alDia = 'al dia'
            } else{
              if(credito.UltCuota){
                if (credito.UltCuota >= this.fechaHoyS) { credito.alDia = 'al dia'; } else { ;credito.alDia = 'vencido'; }
              } else {
                if (credito.PrimCuota >= this.fechaHoyS) { credito.alDia = 'al dia'; } else { credito.alDia = 'vencido'; }
              }
            }
          } */
        });
        this.noLabora = res;
        this.noLaboraFilt = res;
        this.updateFilterNL();
        console.log('noLabora: ', this.noLabora);
        this.endLoading();
      }
      , (err) => {
        this.endLoading();
        this.presentAlert("Error", "AL consultar créditos No Labora", JSON.stringify(err));
      }
    )
  }

  setComentarionNoLabora(dato1, dato2, dato3) {
    var acuerdoOk = 0;
    if (this.acuerdoNoLabora) { acuerdoOk = 1; }
    var usrOk = this.user.Usuario.trim();
    this.popoverController.dismiss()
    let body = { mensajeOk: dato1, numSol: this.numSolNoLabora, usrComent: usrOk, cedula: this.cedulaNoLabora.trim(), acuerdo: acuerdoOk, fecha: dato2, llamada: dato3 }
    if (dato2 == '') { body.fecha = null }
    if (dato3 == '') { body.llamada = null }
    console.log(body);
    this.http.post(environment.urlApi + 'coorp/setComLabora', body, this.HTTPoptions).subscribe((res: any) => {
      this.noLabora.forEach(solicitud => {
        if (solicitud.NumSol == this.numSolNoLabora) { solicitud.Comentarios = dato1; solicitud.Acuerdo = this.acuerdoNoLabora; solicitud.FechaAcuerdo = dato2; solicitud.UltLlamada = dato3; }
      });
      this.updateFilterNL();
      console.log('resComentario: ', res);
      this.endLoading();
    }, (err) => {
      this.endLoading();
      this.presentAlert("Error", "Al actualizar mensaje", JSON.stringify(err));
    });
  }

  totMontoSolNL = 0;
  totSaldoKNL = 0;
  totSolPagadoNL = 0;
  totSolDesembolsadoNL = 0;
  fechaAcuerdoNL = '';
  fechaNoLabora = '';
  fechaUltLlamada = '';

  updateFilterNL() {
    this.noLabora.forEach(credito => {
      if (credito.FechaAcuerdo == null) { credito.FechaAcuerdo = ''; }
      if (credito.UltLlamada == null) { credito.UltLlamada = ''; }
      if (credito.Acuerdo == null) { credito.Acuerdo = false; }
      credito.DiasMora = 0;
      if (credito.Acuerdo == true) {
        /* credito.alDia = 'al dia'; */
        credito.checkAcuerdo = 'ok';
      } else {
        credito.checkAcuerdo = 'no';
        if (credito.IdEstado == 'PAGADO' || credito.IdEstado == 'PAGO-ANTICIPADO' || credito.IdEstado == 'REPERFILADO' || credito.IdEstado == 'VENTA') {
          /* credito.alDia = 'al dia' */
        } else {
          // ESTE CODIGO NO VALIDA SI LA FECHA DE PRIMERA O ULTIMA CUOTA LLEGAN EN NULL --------------------
          // if(credito.UltCuota){ //restafecha
          //   if (credito.UltCuota >= this.fechaHoyS) { /* credito.alDia = 'al dia'; */ } else { /* credito.alDia = 'vencido'; */ credito.DiasMora = ((new Date().getTime() - (new Date(credito.UltCuota.split('T')[0])).getTime())/86400000) - 30; }
          // } else {
          //   if (credito.PrimCuota >= this.fechaHoyS) { /* credito.alDia = 'al dia'; */ } else { /* credito.alDia = 'vencido'; */ credito.DiasMora = ((new Date().getTime() - (new Date(credito.PrimCuota.split('T')[0])).getTime())/86400000) - 30; }
          // }
          // -----------------------------------------------------------------------------------------------

          if (credito.UltCuota && credito.UltCuota !== null && credito.PrimCuota && credito.PrimCuota !== null) {
            if (credito.UltCuota >= this.fechaHoyS) {
              // al día
            } else {
              const fechaUlt = credito.UltCuota.split('T')[0];
              credito.DiasMora = (Date.now() - new Date(fechaUlt).getTime()) / 86400000 - 30;
            }
          } else if (credito.PrimCuota && credito.PrimCuota !== null) {
            if (credito.PrimCuota >= this.fechaHoyS) {
              // al día
            } else {
              const fechaPrim = credito.PrimCuota.split('T')[0];
              credito.DiasMora = (Date.now() - new Date(fechaPrim).getTime()) / 86400000 - 30;
            }
          }
        }
      }
    });
    let filt1 = this.filtPalabaClave(this.noLabora);
    /* let filt4 = this.filtEncCreditEstadosNL(filt1);
    let filt2 = this.filtEncCreditFechaNL(filt4);
    let filt3 = this.filtestadoCastSelectNL(filt2)
    this.noLaboraFilt = filt3;
 */
    let filt2 = this.filtEncCreditEstadosNL(filt1);
    let filt3 = this.filtestadoCastSelectNL(filt2);
    let filt4 = this.filtEncargado(filt3);
    let filt5 = this.filtUltLlamada(filt4);
    let filt6 = this.filtCheckAcuerdoNL(filt5);
    let filt7 = this.filtDiasMoraNL(filt6);
    let filt8 = this.filtFecha(filt7);
    this.noLaboraFilt = filt8;
    this.noLaboraFilt.sort((a, b) => b.NumSol - a.NumSol);
    this.totMontoSolNL = 0;
    this.totSaldoKNL = 0;
    this.totSolPagadoNL = 0;
    this.totSolDesembolsadoNL = 0;
    this.noLaboraFilt.forEach(row => {
      this.totMontoSolNL = this.totMontoSolNL + row.MontoSol;
      this.totSaldoKNL = this.totSaldoKNL + row.SaldoK;
      if (row.IdEstado == "PAGADO") { this.totSolPagadoNL = this.totSolPagadoNL + 1; }
      if (row.IdEstado == "DESEMBOLSADO") { this.totSolDesembolsadoNL = this.totSolDesembolsadoNL + 1; }
    });
    console.log('noLaboraFilt: ', this.noLaboraFilt);
    console.log('totMontoSolNL: ', this.totMontoSolNL);
    console.log('totSaldoKNL: ', this.totSaldoKNL);
    console.log('totSolDesembolsadoNL: ', this.totSolDesembolsadoNL);

  }
  filtFecha(arr) {
    console.log(this.fechaAcuerdoNL);
    let tempFilt = [];
    let val = this.fechaAcuerdoNL;
    if (this.fechaAcuerdoNL) {
      tempFilt = arr.filter((d) => {
        return (
          d.FechaAcuerdo.indexOf(val) !== -1
          || !val);
      });
      return tempFilt;
    } else { return arr; }
  }
  filtUltLlamada(arr) {
    let tempFilt = [];
    let val = this.fechaUltLlamada;
    if (this.fechaUltLlamada) {
      tempFilt = arr.filter((d) => {
        return (
          d.UltLlamada.indexOf(val) !== -1
          || !val);
      });
      return tempFilt;
    } else { return arr; }
  }
  encargadoNL = "";
  filtEncargado(arr) {
    let tempFilt = [];
    const val = this.sinTildes(this.encargadoNL);
    tempFilt = arr.filter((d) => {
      return (this.sinTildes(d.Encargado).indexOf(val) !== -1);
    });
    return tempFilt;
  }

  filtPalabaClave(arr) {
    let tempFilt = [];
    const val = this.sinTildes(this.busquedaNL);
    tempFilt = arr.filter((d) => {
      return (
        this.sinTildes(d.Cedula).indexOf(val) !== -1
        || this.sinTildes(d.NombreCompleto).indexOf(val) !== -1
        || this.sinTildes(d.NumSol).indexOf(val) !== -1
        || this.sinTildes(d.IdEmpresa).indexOf(val) !== -1
        || this.sinTildes(d.IdEstado).indexOf(val) !== -1
        || this.sinTildes(d.TipoCredito).indexOf(val) !== -1
        || this.sinTildes(d.Encargado).indexOf(val) !== -1
        || this.sinTildes(d.Celular).indexOf(val) !== -1
        || !val);
    });
    return tempFilt;
  }

  estadosSelectValueNL = ["APROBADO", "PENDIENTE-DESEMBOLSO", "PENDIENTE-RH", "DESEMBOLSADO", "PAGADO", "VENTA"];
  filtEncCreditEstadosNL(arr) {
    let tempFilt = [];
    this.estadosSelectValueNL.forEach(estado => {
      const found = arr.filter(est => est.IdEstado.toLowerCase() == estado.toLowerCase());
      tempFilt = tempFilt.concat(found);
    });
    return tempFilt;
  }

  checkAcuerdoNoLAbora = ['ok', 'no'];
  filtCheckAcuerdoNL(arr) {
    let tempFilt = [];
    this.checkAcuerdoNoLAbora.forEach(fecha => {
      arr.forEach(c => {
        if (c.checkAcuerdo == fecha) {
          tempFilt.push(c);
        }
      });
    });
    return tempFilt;
  }

  estadoCastSelectFecha = ['al dia', 'vencido'];
  filtEncCreditFechaNL(arr) {
    let tempFilt = [];
    this.estadoCastSelectFecha.forEach(fecha => {
      arr.forEach(c => {
        if (c.alDia == fecha) {
          tempFilt.push(c);
        }
      });
    });
    return tempFilt;
  }

  estadoCastSelectValue = ['SI', 'NO'];
  filtestadoCastSelectNL(arr) {
    let tempFilt = [];
    this.estadoCastSelectValue.forEach(e => {
      arr.forEach(c => {
        if (c.Castigado == e) {
          tempFilt.push(c);
        }
      });
    });
    return tempFilt;
  }

  selectDiasMora = ['0', '0_30', '30_60', '60_90', '90_180', '180'];
  filtDiasMoraNL(arr) {
    let tempFilt = [];
    this.selectDiasMora.forEach(e => {
      let rangoTem = e.split('_');
      if (rangoTem.length == 1) {
        if (rangoTem[0] == '0') {
          arr.forEach(c => {
            if (c.DiasMora == rangoTem[0]) {
              tempFilt.push(c);
            }
          });
        } else {
          arr.forEach(c => {
            if (c.DiasMora > rangoTem[0]) {
              tempFilt.push(c);
            }
          });
        }
      } else {
        arr.forEach(c => {
          if (c.DiasMora > rangoTem[0] && c.DiasMora <= rangoTem[1]) {
            tempFilt.push(c);
          }
        });
      }
    });
    return tempFilt;
  }

  async saveChanOpGmovilAlet(opToChan) {
    console.log(opToChan)
    const alert = await this.alertController.create({
      mode: 'ios',
      header: 'Confirma',
      message: `Modificarás ${opToChan.length} operacion(es).`,
      buttons: [
        {
          text: 'Cancelar',
          role: 'cancel',
          cssClass: 'secondary',
          handler: (blah) => {
            console.log('Confirm Cancel: blah');
          }
        }, {
          text: 'Confirmar',
          handler: () => {
            console.log('Confirm Okay');
            this.saveChanOpGmovil(opToChan);
          }
        }
      ]
    });

    await alert.present();
  }

  opGmovilToChanTot = 0;
  countOpGmovil = 0;
  async saveChanOpGmovil(opToChan) {
    let opError = [];
    this.opGmovilToChanTot = opToChan.length;
    this.countOpGmovil = 0;
    this.apiOnReq = true;
    for (let o of opToChan) {
      let opHttp = new Promise((resolve, reject) => {
        let body = {
          op: o
        }
        this.http.put(environment.urlApi + '/coorp/updateOpGmovil', body, this.HTTPoptions).subscribe(
          (result: any) => {
            console.log(result, ': ', o.NumSol);
            this.countOpGmovil = this.countOpGmovil + 1;
            resolve(1);
          }
          , (err) => {
            console.log(err)
            opError.push({
              NumSol: o.NumSol,
              Error: JSON.stringify(err)
            })
            resolve(0);
          }
        );
      });
      await opHttp;
    }
    this.apiOnReq = false;
    if (opError.length > 0) {
      console.log(opError);
    }
    this.opGmovilToChanTot = 0;
    this.countOpGmovil = 0;
    this.getOpGmovil();
  }


  /* CODIGO SEBASTIAN */
  dateDownRein = '';
  dateDownReinHasta = '';
  irDownRein() { //Cambios yo 03-02
    this.menu.close('custom');
    this.router.navigate(['/downrein']);
  }

  enviarDownRein() { //Cambios yo 03-02
    if (this.dateDownRein != '' && this.dateDownReinHasta != '') {
      var fecha1 = this.dateDownRein.split('-');
      var fecha2 = this.dateDownReinHasta.split('-');
      var f1 = new Date(parseInt(fecha1[0]), parseInt(fecha1[1]), parseInt(fecha1[2]));
      var f2 = new Date(parseInt(fecha2[0]), parseInt(fecha2[1]), parseInt(fecha2[2]));
      if (f1 <= f2) {
        var arrReinOk = [];
        let body = {
          fecha: this.dateDownRein, fechaHasta: this.dateDownReinHasta
        };
        this.http.post(environment.urlApi + 'reintegrosok', body).subscribe((res: any) => {
          if (this.loading) { this.loading.dismiss() };
          if (res.body.length > 0) {
            res.body.forEach(dato => {
              var codigoBancoOk = '00';
              if (dato.BancoCodigo) {
                codigoBancoOk = dato.BancoCodigo;
              }
              arrReinOk.push({
                OK: 'OK', TipoId: '01- Cédula de ciudadanía', NumeroId: dato.NumeroId, TipoCta: this.formTipoCuenta(dato.TipoCta), NumeroCta: dato.NumeroCta, Banco: this.formCodBank(codigoBancoOk) + '.' + dato.Banco, Nombre: this.titlecase.transform(dato.Nombre), Direccion: dato.Direccion, email: dato.email, TipoPago: '1- Abono en Cuenta', OficinaPago: '', Importe: dato.Importe, Concepto1: 'REINTEGROS', FechaLim: '', Concepto2: dato.Concepto2
              });
            });
            this.exportAsExcelFile(arrReinOk, 'Reintegros')
          }
          this.apiOnReq = false;
          clearTimeout(this.temporizador);
        }, (err: any) => {
          if (this.loading) { this.loading.dismiss() };
          this.apiOnReq = false;
          clearTimeout(this.temporizador);
          this.presentAlert('Error', 'Al actualizar datos', JSON.stringify(err));
        });
        this.popoverController.dismiss()
      }
    }
  }

  async selectDownRein(ev: any) { //Cambios yo 03-02
    const popover = await this.popoverController.create({
      component: DownloadreintegrosPage,
      cssClass: 'popoverStyle',
      event: ev,
      translucent: true,
      componentProps: {},
      mode: 'ios'
    });
    return await popover.present();
  }
  /* FIN CODIGO SEBASTIAN */


  creditosPend = [];
  idEmpresa;
  /* async getEstadosCredXdoc(documento) {
    if(documento){
      this.apiOnReq = true;
      await this.presentLoading('Cargando creditos pendientes, por favor espera...');
      const body = {
        documento:documento
      }
      this.http.post(environment.urlApi + '/coorp/getEstadosCredXdoc', body, this.HTTPoptions).subscribe(
        (res: any)=>{
          console.log(res);
          if (res.length > 0) {
            this.creditosPend = res;
            this.idEmpresa = res[0].IdEmpresa;
            console.log('IdEmpresa: ',this.idEmpresa);
          } else {
            this.presentAlert('Info', '', 'Esta cedula no tiene créditos pendientes');
          }
          this.endLoading();
        }
        ,(err: any)=>{
          this.endLoading();
          this.presentAlert('Error', 'Al ver creditos pendientes', err);
        }
      );
    }else{
      this.presentAlert('Error','Datos incompletos','Ingresa un documento');
    }
  } */

  endLoading() {
    this.apiOnReq = false;
    this.loading.dismiss();
    clearTimeout(this.temporizador);
  }

  tablaSinAbonoK = [];
  tablaConAbonoK = [];
  async simularAbonok(credito, pago, idPago) {
    this.apiOnReq = true;
    await this.presentLoading('Simulando abono a capital, por favor espera...');
    const body = {
      credito: credito,
      pago: pago,
      idpago: idPago
    }
    this.http.post(environment.urlApi + '/coorp/verAbonoK', body, this.HTTPoptions).subscribe(
      (res: any) => {
        console.log(res);
        this.tablaSinAbonoK = res[0];
        this.tablaConAbonoK = res[1];
        this.btnAplAbonokEn = true;
        this.endLoading();
      }
      , (err: any) => {
        this.endLoading();
        this.presentAlert('Error', 'Al simular abono a capital', err);
      }
    );
  }

  btnAplAbonokEn = true;
  async aplicarAbonok(credito, pago, idPago) {
    this.btnAplAbonokEn = false;
    this.apiOnReq = true;
    await this.presentLoading('Aplicando abono a capital, por favor espera...');
    const body = {
      credito: credito,
      pago: pago,
      usr: this.user.Usuario.trim(),
      idpago: idPago
    }
    this.http.post(environment.urlApi + '/coorp/aplicarAbonoK', body, this.HTTPoptions).subscribe(
      (res: any) => {
        console.log(res);
        this.endLoading();
        this.presentToast('Abono a capital aplicado correctamente!');
      }
      , (err: any) => {
        this.endLoading();
        this.presentAlert('Error', 'Al aplicar abono a capital', err);
      }
    );
  }

  liquidAuto = [];
  cuotasAuto = [];
  devoAuto = [];
  /* async getPagosAutoXdoc(documento,pago,idPago,liqEn) {
      this.apiOnReq = true;
      await this.presentLoading('Obteniendo pagos automaticos, por favor espera...');
      const body = {
        documento:documento,
        pago:pago,
        idpago:idPago,
        usr: this.user.Usuario.trim(),
        liqEn: liqEn 
      }
      console.log('getPagosAutoXdoc body: ',body);
      this.http.post(environment.urlApi + '/coorp/getPagosAutoXdoc', body, this.HTTPoptions).subscribe(
        (res: any)=>{
          console.log(res);
          this.liquidAuto = res[0];
          this.cuotasAuto = res[1];
          this.devoAuto = res[2];
          this.btnPagosAutoEn = true;
          this.endLoading();
        }
        ,(err: any)=>{
          this.endLoading();
          this.presentAlert('Error', 'Al obtener pagos automáticos', JSON.stringify(err));
        }
      );
  } */

  btnPagosAutoEn = true;
  async aplicarPagAuto() {
    this.btnPagosAutoEn = false;
    await this.presentLoading('Aplicando pagos automáticos, por favor espera...');
    await this.SaveDevByOne();
    await this.aplicarCuotas3();
    this.endLoading();
  }


  async SaveDevByOne() {
    if (this.devoAuto.length > 0) {
      let devoMal = [];
      for (let c of this.devoAuto) {
        console.log('guardando devolucion: ', c);
        this.apiOnReq = true;
        if (c.Obs == null) { c.Obs = ""; }
        let body = {
          idpago: 1,
          devolucion: c
        };
        let httpReqProm = new Promise((resolve, reject) => {
          this.http.post(environment.urlApi + 'coorp/saveConciliacionesDev', body, this.HTTPoptions).subscribe(
            (res: any) => {
              this.apiOnReq = false;
              resolve('ok');
            },
            (err) => {
              devoMal.push({
                NumSol: c.Documento,
                Error: err
              });
              console.log('Conciliacion mal: ', c.Documento);
            }
          );
        });
        await httpReqProm;
      }
      if (devoMal.length > 0) {
        this.presentAlert('Alerta!', 'Errores al guardar conciliación', 'Por favor revisa el archivo que se acaba de descargar.');
        this.exportAsExcelFile(devoMal, 'ConcilSaveDevError');
      } else {
        this.presentToast('Se guardó devoluciones correctamente!');
      }
    }
  }

  async aplicarCuotas3() {
    if (this.cuotasAuto.length > 0) {
      let Pagos = [];
      this.cuotasAuto.forEach(c => {
        Pagos.push({
          EMPRESA: this.idEmpresa,
          NumSol: c.NumSol,
          CEDULA: c.documento,
          CUOTA: c.Cuota,
          NOMBRE: c.nombre,
          VALOR: c.TotPago,
          FechaPago: this.datePipe.transform(c.FechaEstPago, "yyy-MM-dd", "+0000"),
          IdPago: c.IdPago,
          USUARIO: this.user.Usuario.trim()
        })
      });
      console.log('Pagos: ', Pagos);
      /* this.exportAsExcelFile(Pagos, "PagosAuto-" + this.encReporte.IdReporte); */
      let pagosMal = [];
      for (let p of Pagos) {
        this.apiOnReq = true;
        let body = {
          pago: p,
          RN: 1
        };
        let aplPago = new Promise((resolve, reject) => {
          this.http.post(environment.urlApi + 'aplicarpagosprocomp', body).subscribe((res: any) => {
            this.apiOnReq = false;
            if (res.res == false) {
              pagosMal.push({
                NumSol: p.Numsol,
                err: JSON.stringify(res.error)
              })
            }
            resolve('ok');
          });
        })
        await aplPago;
      }
      if (pagosMal.length == 0) {
        this.presentToast('Tolos los pagos aplicados!');
      } else {
        this.presentAlert("Alerta", "Algunos pagos tuvieron problema", 'Por favor revisa el archivo "PagosError" para más información');
        this.exportAsExcelFile(pagosMal, "PagosError");
      }
    }
  }

  hisLiqXdoc = [];
  async getHisLiqXdoc(documento, credito) {
    if (credito) {
      this.apiOnReq = true;
      await this.presentLoading('Obteniendo historial de liquididaciones, por favor espera...');
      const body = {
        documento: documento,
        numSol: credito
      }
      console.log('getPagosAutoXdoc body: ', body);
      this.http.post(environment.urlApi + '/coorp/getHisLiqXdoc', body, this.HTTPoptions).subscribe(
        (res: any) => {
          console.log(res);
          this.hisLiqXdoc = res;
          this.endLoading();
        }
        , (err: any) => {
          this.endLoading();
          this.presentAlert('Error', 'Al obtener pagos automáticos', err);
        }
      );
    } else {
      this.presentAlert('Error', 'Datos incompletos', 'Por favor selecciona el numero de solicitud');
    }
  }

  ExcelToJson(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => {
        let workBook: any;
        const data = reader.result;
        let res: any;
        workBook = XLSX.read(data, { type: 'binary' });
        res = workBook.SheetNames.reduce((initial, name) => {
          const sheet = workBook.Sheets[name];
          initial[name] = XLSX.utils.sheet_to_json(sheet);
          return initial;
        }, {});
        resolve(res);
      }
      reader.readAsBinaryString(file);
    })
  }

  sinTildes(entrada) {
    if (entrada == null) { entrada = ""; }
    let input = entrada.toString();
    var tittles = "ÃÀÁÄÂÈÉËÊÌÍÏÎÒÓÖÔÙÚÜÛãàáäâèéëêìíïîòóöôùúüûÑñÇç´";
    var original = "AAAAAEEEEIIIIOOOOUUUUaaaaaeeeeiiiioooouuuunncc ";
    for (var i = 0; i < tittles.length; i++) {
      input = input.replace(tittles.charAt(i), original.charAt(i)).toLowerCase().trim();
    };
    return input;
  }

  async req(tipo, path, body = {}, mssLoading, loadingEn = true) {
    if (!this.apiOnReq) {
      this.apiOnReq = true;
      if (loadingEn) { await this.presentLoading(mssLoading); }
      return new Promise((resolve, reject) => {
        switch (tipo.toLowerCase()) {
          case "get":
            this.http.get(environment.urlApi + path, this.HTTPoptions).subscribe(
              (res: any) => {
                this.apiOnReq = false;
                if (this.loading && loadingEn) { this.loading.dismiss() };
                clearTimeout(this.temporizador);
                console.log(`${path}: `, res);
                resolve(res);
              }
              , (error) => {
                this.apiOnReq = false;
                if (this.loading && loadingEn) { this.loading.dismiss() };
                clearTimeout(this.temporizador);
                console.log(`${path} error: `, error);
                reject(error);
              }
            );
            break;
          case "post":
            this.http.post(environment.urlApi + path, body, this.HTTPoptions).subscribe(
              (res: any) => {
                this.apiOnReq = false;
                if (this.loading && loadingEn) { this.loading.dismiss() };
                clearTimeout(this.temporizador);
                console.log(`${path}: `, res);
                resolve(res);
              }
              , (error) => {
                this.apiOnReq = false;
                if (this.loading && loadingEn) { this.loading.dismiss() };
                clearTimeout(this.temporizador);
                console.log(`${path} error: `, error);
                reject(error);
              }
            );
            break;
          default:
            break;
        }
      })
    } else {
      this.presentToast('Servicio ocupado, por favor espera', 'warning', 4000);
    }
  }
  async req2(tipo, path, body = {}, mssLoading, loadingEn = true, cantidad) {
    if (!this.apiOnReq) {
      this.apiOnReq = true;
      if (loadingEn) { await this.presentLoadingContados(mssLoading, cantidad); }
      return new Promise((resolve, reject) => {
        switch (tipo.toLowerCase()) {
          case "get":
            this.http.get(environment.urlApi + path, this.HTTPoptions).subscribe(
              (res: any) => {
                this.apiOnReq = false;
                if (this.loading && loadingEn) { this.loading.dismiss() };
                clearTimeout(this.temporizador);
                console.log(`${path}: `, res);
                resolve(res);
              }
              , (error) => {
                this.apiOnReq = false;
                if (this.loading && loadingEn) { this.loading.dismiss() };
                clearTimeout(this.temporizador);
                console.log(`${path} error: `, error);
                reject(error);
              }
            );
            break;
          case "post":
            this.http.post(environment.urlApi + path, body, this.HTTPoptions).subscribe(
              (res: any) => {
                this.apiOnReq = false;
                if (this.loading && loadingEn) { this.loading.dismiss() };
                clearTimeout(this.temporizador);

                resolve(res);
              }
              , (error) => {
                this.apiOnReq = false;
                if (this.loading && loadingEn) { this.loading.dismiss() };
                clearTimeout(this.temporizador);
                console.log(`${path} error: `, error);
                reject(error);
              }
            );
            break;
          default:
            break;
        }
      })
    } else {
      this.presentToast('Servicio ocupado, por favor espera', 'warning', 4000);
    }
  }


  /* CODIGO SEBASTIAN */

  motivoRechazoCalc = "Otros";
  busquedaCalc = '';
  arrCalc;
  arrVinc;
  loadingX;
  fechaRetiro;
  fechaRetiroOk;
  segSocial = 80000;
  capMensual;
  capSobrante;
  otrosDenario;
  creditosCalc = [];
  otrasLibranzas;
  embargos;
  ahorros;
  totEgresos;
  botonApr = false;
  idOp = false;

  irCalculadora() {
    this.menu.close('custom')
    this.router.navigate(['/calculadora']);
    this.title = "Calculadora";
  }

  empleadosSearchCalc() {
    this.arrCalc = []; this.arrVinc = []; this.otrasLibranzas = undefined; this.embargos = undefined; this.ahorros = undefined; this.totEgresos = undefined; this.otrosDenario = 0; this.creditosCalc = []; this.botonApr = false; this.otrasLibranzas = undefined; this.embargos = undefined; this.ahorros = undefined;
    if (this.busquedaCalc) {
      let body = { numsol: this.busquedaCalc };
      this.http.post(environment.urlApi + 'coorp/getcalc', body).subscribe((res: any) => {
        console.log(res);
        this.idOp = res.idOp;
        if (res.arr1.length > 0) {
          res.arr1[0].Condiciones ? res.arr1[0].Condiciones = JSON.parse(res.arr1[0].Condiciones) : false;
          this.arrCalc = res.arr1[0];
          if (res.arr1[0].Contrato == 'INDEFINIDO') {
            this.fechaRetiroOk = undefined;
          } else {
            if (res.arr1[0].FechaRetiro) { this.fechaRetiro = (new Date(res.arr1[0].FechaRetiro.split('T')[0])).getTime(); this.fechaRetiroOk = (this.fechaRetiro - (new Date().getTime())) / 86400000; }
            console.log('fechaRetiroOk: ', this.fechaRetiroOk);
          }
          this.getOtrosCreditosCal(this.arrCalc.Cedula);
        } else { this.arrCalc = undefined; }
      });
    }
  }
  validarSol() {
    this.totEgresos = 0; this.capMensual = 0; this.capSobrante = 0;
    this.totEgresos = this.totEgresos + this.otrosDenario;
    if (this.arrCalc.Condiciones) {
      for (let i = 0; i < this.arrCalc.Condiciones.length; i++) {
        this.arrCalc.Sueldo >= this.arrCalc.Condiciones[i].salMin && this.arrCalc.Sueldo <= this.arrCalc.Condiciones[i].salMax ? ((this.arrCalc.Porcentaje = this.arrCalc.Condiciones[i].porcentaje), (this.arrCalc.NumCre = this.arrCalc.Condiciones[i].numCre), i = this.arrCalc.Condiciones.length) : false;
      }
    }
    //if(this.otrosDenario == 0) { this.otrosDenario = undefined; }
    if (!this.ahorros) { this.totEgresos + 0 } else { this.totEgresos = this.totEgresos + this.ahorros }
    if (!this.embargos) { this.totEgresos + 0 } else { this.totEgresos = this.totEgresos + this.embargos }
    if (!this.segSocial) { this.totEgresos + 0 } else { this.totEgresos = this.totEgresos + this.segSocial }
    if (!this.otrasLibranzas) { this.totEgresos + 0 } else { this.totEgresos = this.totEgresos + this.otrasLibranzas }
    this.capMensual = (this.arrCalc.Sueldo * (this.arrCalc.Porcentaje / 100)) - this.totEgresos;
    this.capSobrante = this.capMensual - this.arrCalc.Cuota;
    if (this.arrCalc.Activos <= this.arrCalc.NumCre && this.capSobrante > 0) {
      if (this.fechaRetiroOk) {
        if ((this.fechaRetiroOk + 1) > 0) { this.botonApr = true; } else { this.botonApr = false; }
      } else { this.botonApr = true; }
    } else { this.botonApr = false; }
  }
  getOtrosCreditosCal(cedula) {
    /* this.presentLoading('Cargando'); */
    let body = { cedula: cedula };
    this.http.post(environment.urlApi + 'getotroscreditos', body).subscribe((res: any) => {
      console.log(res);
      this.creditosCalc = res.tabla;
      if (this.creditosCalc) {
        this.creditosCalc.forEach(credito => { this.otrosDenario = this.otrosDenario + credito.TotCuota; });
      }
      console.log(this.otrosDenario);
      this.validarSol();
      /* this.loading.dismiss();
      this.apiOnReq = false;
      clearTimeout(this.temporizador); */
    });
  }

  setEstudioCalc(motivo) {
    // this.popoverController.dismiss()
    // this.presentLoading('Cargando');
    var usuarioOK = this.user.Usuario.trim();
    if (this.arrCalc.Responsable == undefined) { this.arrCalc.Responsable = '0'; }
    if (this.arrCalc.FechaRetiro == undefined) { this.arrCalc.FechaRetiro = this.arrCalc.FechaIngreso; }
    if (this.fechaRetiroOk == undefined) { this.fechaRetiroOk = 0; }
    if (this.otrosDenario == undefined) { this.otrosDenario = 0; }
    if (this.otrasLibranzas == undefined) { this.otrasLibranzas = 0; }
    if (this.embargos == undefined) { this.embargos = 0; }
    if (this.ahorros == undefined) { this.ahorros = 0; }
    if (this.segSocial == undefined) { this.segSocial = 0; }
    if (this.totEgresos == undefined) { this.totEgresos = 0; }
    if (this.capMensual == undefined) { this.capMensual = 0; }
    if (this.capSobrante == undefined) { this.capSobrante = 0; }
    let body = {
      NumSol: this.arrCalc.NumSol, Nombre: this.arrCalc.Nombre, Empresa: this.arrCalc.Empresa, Cedula: this.arrCalc.Cedula, Responsable: this.arrCalc.Responsable, Activos: this.arrCalc.Activos, FechaIngreso: this.arrCalc.FechaIngreso, FechaRetiro: this.arrCalc.FechaRetiro, FechaSol: this.arrCalc.FechaSol, MontoSol: this.arrCalc.MontoSol, Plazo: this.arrCalc.Plazo, Cuota: this.arrCalc.Cuota, Producto: this.arrCalc.Producto, Contrato: this.arrCalc.Contrato, Sueldo: this.arrCalc.Sueldo,
      DiasRestantes: Math.round(this.fechaRetiroOk) + 1, CuotasDenario: this.otrosDenario, OtrasLib: this.otrasLibranzas, Embargos: this.embargos, Ahorros: this.ahorros, SegSocial: this.segSocial, TotEgresos: this.totEgresos, CapMensual: this.capMensual, CapSobrante: this.capSobrante, Banker: usuarioOK, MotivoRechazo: motivo
    };
    this.http.post(environment.urlApi + 'coorp/setcalc', body).subscribe((res: any) => {
      this.empleadosSearchCalc();
    });
  }



  /* FIN CODIGO SEBASTIAN */

  clonar(obj) { return JSON.parse(JSON.stringify(obj)); }

  imgVisor;
  irVisor(img) {
    this.imgVisor = img;
    this.router.navigate(['/visor-img']);
  }

  async sendSmsDatosDesp(desp) {
    console.log('Desp: ', desp);

    console.log('Reenviando mensaje para datos de despacho...');
    await this.presentLoading('Reenviando mensaje para datos de despacho...');
    this.apiOnReq = true;
    let body = {
      cedula: desp.Celula.trim(),
      idpedido: desp.IdPedido,
      telefono: desp.TelefonoReg.trim()
    };
    this.http.post(environment.urlApi + 'SendSmsFormMk2', body).subscribe((res: any) => {
      console.log('SendSmsFormMk2: ', res);
      this.loading.dismiss();
      this.apiOnReq = false;
      clearTimeout(this.temporizador);
    },
      (err) => {
        console.log('Error http: ', err);
        this.loading.dismiss();
        this.apiOnReq = false;
        clearTimeout(this.temporizador);
        alert('Error: ' + err.body.error.originalError.info.message);
      })

  }

  usuariosPermmitidos: string[] = ['juan.duran', 'juanfra.reyes', 'jhon.hernandez', 'nicolas.caicedo', 'juan.penagos']
  usuariosPermmitidosBanners: string[] = ['juan.duran', 'juanfra.reyes', 'jhon.hernandez', 'nicolas.caicedo', 'juan.penagos', 'marie.estepa']
  usuariosPermmitidosDruo: string[] = ['juan.duran', 'juanfra.reyes', 'jhon.hernandez', 'nicolas.caicedo', 'juan.penagos', 'sonia.hilarion', 'gregorio.acosta']
  usuariosPermmitidosNovedades: string[] = ['juan.duran', 'juanfra.reyes', 'jhon.hernandez', 'nicolas.caicedo', 'juan.penagos', 'sonia.hilarion', 'adriana.crespo', 'juan.corredor']
  usuariosPermmitidosDispersiones: string[] = ['juan.duran', 'juanfra.reyes', 'jhon.hernandez', 'nicolas.caicedo', 'juan.penagos', '', 'lina.alzate', 'patricia.garcia', 'ferney.acevedo', 'yesenia.alfonso.com', 'cesar.hernandez']

  verRol(funcion: string): boolean {
    if (this.user) {
      if (this.user.IdRol == 200 || this.user.IdRol == 100 || this.user.IdRol == 201 || this.user.IdRol == 202) { //super usuarios
        return true;
      } else {
        switch (funcion) {
          case 'verReporte': if (this.user.IdRol == 301 || this.user.IdRol == 302 || this.user.IdRol == 400) { return true; } else { return false; }
          case 'genReporte': if (this.user.IdRol == 301 || this.user.IdRol == 302) { return true; } else { return false; }
          case 'editReporte': if (this.user.IdRol == 301 || this.user.IdRol == 302) { return true; } else { return false; }
          case 'AplSaveConc': if (this.user.IdRol == 301 || this.user.IdRol == 302) { return true; } else { return false; }
          case 'desRepNov': if (this.user.IdRol == 301 || this.user.IdRol == 302) { return true; } else { return false; }
          case 'editarSol': if (this.user.IdRol == 301 || this.user.IdRol == 302) { return true; } else { return false; }
          case 'aplicarLiq': if (this.user.IdRol == 301 || this.user.IdRol == 302) { return true; } else { return false; }
          case 'pagosAutomaticos': if (this.user.IdRol == 301 || this.user.IdRol == 302) { return true; } else { return false; }
          case 'verHisLiq': if (this.user.IdRol == 301 || this.user.IdRol == 302 || this.user.IdRol == 400) { return true; } else { return false; }
          case 'verOpPensiones': if (this.user.IdRol == 301 || this.user.IdRol == 302 || this.user.IdRol == 101 || this.user.IdRol == 400) { return true; } else { return false; }
          case 'verLineas': if (this.user.IdRol == 301 || this.user.IdRol == 302 || this.user.IdRol == 400) { return true; } else { return false; }
          case 'desOpEnProc': if (this.user.IdRol == 301 || this.user.IdRol == 302 || this.user.IdRol == 400) { return true; } else { return false; }
          case 'verOpGmovil': if (this.user.IdRol == 301 || this.user.IdRol == 302 || this.user.IdRol == 400) { return true; } else { return false; }
          case 'verOpTpaga': if (this.user.IdRol == 301 || this.user.IdRol == 302 || this.user.IdRol == 400) { return true; } else { return false; }
          case 'verOpPSE': if (this.user.IdRol == 301 || this.user.IdRol == 302 || this.user.IdRol == 400) { return true; } else { return false; }
          case 'verOpDenarioYa': if (this.user.IdRol == 301 || this.user.IdRol == 302 || this.user.IdRol == 400) { return true; } else { return false; }
          case 'editOpGmovil': if (this.user.IdRol == 301 || this.user.IdRol == 302) { return true; } else { return false; }
          case 'addEmp': if (this.user.IdRol == 101) { return true; } else { return false; }
          case 'graficasDashborad1': if (this.user.IdRol == 301 || this.user.IdRol == 302 || this.user.IdRol == 400) { return true; } else { return false; }
          case 'codigos': if (this.user.IdRol == 400 || this.user.IdRol == 201 || this.user.IdRol == 202 || this.user.IdRol == 302) { return true; } else { return false; }
          case 'cobros': if (this.user.IdRol == 302 || this.user.Usuario == 'juan.duran' || this.user.Usuario == 'juanfra.reyes' || (this.user.Usuario).trim() == 'jhon.hernandez' || (this.user.Usuario).trim() == 'nicolas.caicedo' || this.user.Usuario == 'david.suarez') { return true; } else { return false; }
          case 'super': if (this.user.Usuario == 'juan.duran' || this.user.Usuario == 'juanfra.reyes' || (this.user.Usuario).trim() == 'jhon.hernandez' || (this.user.Usuario).trim() == 'nicolas.caicedo' || this.user.Usuario == 'david.suarez') { return true; } else { return false; }
          case 'facturacionDCard': if (this.user.Usuario == 'juan.duran' || this.user.Usuario == 'juanfra.reyes' || (this.user.Usuario).trim() == 'jhon.hernandez' || (this.user.Usuario).trim() == 'nicolas.caicedo' || (this.user.Usuario).trim() == 'patricia.garcia') { return true; } else { return false; }
          case 'rechazarSol': if ((this.user.Usuario).trim() == 'sonia.cartera') { return true; } else { return false; }
          // case 'verUsuarios': if  { return true; } else { return false; }
          default:
            return false;
        }
      }
    }
  }

  // superAdmin() {
  //   return this.usuariosPermmitidos.includes((this.user.Usuario).trim())
  // }

  superAdmin() {
    const usuario = this.user?.Usuario?.trim();
    if (!usuario) return false;

    return this.usuariosPermmitidos.includes(usuario);
  }

  usuariosBanners() {
    const usuario = this.user?.Usuario?.trim();
    if (!usuario) return false;

    return this.usuariosPermmitidosBanners.includes(usuario);
  }

  usuariosNovedades() {
    const usuario = this.user?.Usuario?.trim();
    if (!usuario) return false;

    return this.usuariosPermmitidosNovedades.includes(usuario);
  }

  usuariosDispersiones() {
    const usuario = this.user?.Usuario?.trim();
    if (!usuario) return false;

    return this.usuariosPermmitidosDispersiones.includes(usuario);
  }

  usuariosCartera() {
    const usuario = this.user?.Usuario?.trim();
    if (!usuario) return false;
    
    return this.usuariosPermmitidosDruo.includes((this.user.Usuario).trim())
  }
}